"use strict";
function _toConsumableArray(e) {
    if (Array.isArray(e)) {
        for (var t = 0, a = Array(e.length); t < e.length; t++)
            a[t] = e[t];
        return a
    }
    return Array.from(e)
}
function _classCallCheck(e, t) {
    if (!(e instanceof t))
        throw new TypeError("Cannot call a class as a function")
}
var _this26 = this
  , _slicedToArray = function() {
    function e(e, t) {
        var a = []
          , i = !0
          , n = !1
          , r = undefined;
        try {
            for (var s, o = e[Symbol.iterator](); !(i = (s = o.next()).done) && (a.push(s.value),
            !t || a.length !== t); i = !0)
                ;
        } catch (l) {
            n = !0,
            r = l
        } finally {
            try {
                !i && o["return"] && o["return"]()
            } finally {
                if (n)
                    throw r
            }
        }
        return a
    }
    return function(t, a) {
        if (Array.isArray(t))
            return t;
        if (Symbol.iterator in Object(t))
            return e(t, a);
        throw new TypeError("Invalid attempt to destructure non-iterable instance")
    }
}()
  , _extends = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
        var a = arguments[t];
        for (var i in a)
            Object.prototype.hasOwnProperty.call(a, i) && (e[i] = a[i])
    }
    return e
}
  , _createClass = function() {
    function e(e, t) {
        for (var a = 0; a < t.length; a++) {
            var i = t[a];
            i.enumerable = i.enumerable || !1,
            i.configurable = !0,
            "value"in i && (i.writable = !0),
            Object.defineProperty(e, i.key, i)
        }
    }
    return function(t, a, i) {
        return a && e(t.prototype, a),
        i && e(t, i),
        t
    }
}();
if (!window.Promise) {
    var polly_script = document.createElement("script");
    polly_script.src = "https://cdnjs.cloudflare.com/ajax/libs/babel-polyfill/7.10.4/polyfill.min.js",
    document.head.appendChild(polly_script)
}
!function(e, t) {
    function a(e) {
        var a = t[e];
        t[e] = function(e) {
            return n(a(e))
        }
    }
    function i(t, a, i) {
        return (i = this).attachEvent("on" + t, function(t) {
            (t = t || e.event).preventDefault = t.preventDefault || function() {
                t.returnValue = !1
            }
            ,
            t.stopPropagation = t.stopPropagation || function() {
                t.cancelBubble = !0
            }
            ,
            a.call(i, t)
        })
    }
    function n(e, t) {
        if (t = e.length)
            for (; t--; )
                e[t].addEventListener = i;
        else
            e.addEventListener = i;
        return e
    }
    e.addEventListener || (n([t, e]),
    "Element"in e ? e.Element.prototype.addEventListener = i : (t.attachEvent("onreadystatechange", function() {
        n(t.all)
    }),
    a("getElementsByTagName"),
    a("getElementById"),
    a("createElement"),
    n(t.all)))
}(window, document),
"document"in self && ("classList"in document.createElement("_") && (!document.createElementNS || "classList"in document.createElementNS("http://www.w3.org/2000/svg", "g")) || function(e) {
    if ("Element"in e) {
        var t = "classList"
          , a = "prototype"
          , i = e.Element[a]
          , n = Object
          , r = String[a].trim || function() {
            return this.replace(/^\s+|\s+$/g, "")
        }
          , s = Array[a].indexOf || function(e) {
            for (var t = 0, a = this.length; t < a; t++)
                if (t in this && this[t] === e)
                    return t;
            return -1
        }
          , o = function(e, t) {
            this.name = e,
            this.code = DOMException[e],
            this.message = t
        }
          , l = function(e, t) {
            if ("" === t)
                throw new o("SYNTAX_ERR","An invalid or illegal string was specified");
            if (/\s/.test(t))
                throw new o("INVALID_CHARACTER_ERR","String contains an invalid character");
            return s.call(e, t)
        }
          , c = function(e) {
            for (var t = r.call(e.getAttribute("class") || ""), a = t ? t.split(/\s+/) : [], i = 0, n = a.length; i < n; i++)
                this.push(a[i]);
            this._updateClassName = function() {
                e.setAttribute("class", this.toString())
            }
        }
          , u = c[a] = []
          , d = function() {
            return new c(this)
        };
        if (o[a] = Error[a],
        u.item = function(e) {
            return this[e] || null
        }
        ,
        u.contains = function(e) {
            return -1 !== l(this, e += "")
        }
        ,
        u.add = function() {
            var e, t = arguments, a = 0, i = t.length, n = !1;
            do {
                e = t[a] + "",
                -1 === l(this, e) && (this.push(e),
                n = !0)
            } while (++a < i);
            n && this._updateClassName()
        }
        ,
        u.remove = function() {
            var e, t, a = arguments, i = 0, n = a.length, r = !1;
            do {
                for (e = a[i] + "",
                t = l(this, e); -1 !== t; )
                    this.splice(t, 1),
                    r = !0,
                    t = l(this, e)
            } while (++i < n);
            r && this._updateClassName()
        }
        ,
        u.toggle = function(e, t) {
            e += "";
            var a = this.contains(e)
              , i = a ? !0 !== t && "remove" : !1 !== t && "add";
            return i && this[i](e),
            !0 === t || !1 === t ? t : !a
        }
        ,
        u.toString = function() {
            return this.join(" ")
        }
        ,
        n.defineProperty) {
            var p = {
                get: d,
                enumerable: !0,
                configurable: !0
            };
            try {
                n.defineProperty(i, t, p)
            } catch (h) {
                h.number !== undefined && -2146823252 !== h.number || (p.enumerable = !1,
                n.defineProperty(i, t, p))
            }
        } else
            n[a].__defineGetter__ && i.__defineGetter__(t, d)
    }
}(self)),
String.prototype.trim || (String.prototype.trim = function() {
    return this.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "")
}
),
String.prototype.includes || (String.prototype.includes = function() {
    return -1 !== String.prototype.indexOf.apply(this, arguments)
}
),
Array.prototype.includes || (Array.prototype.includes = function() {
    return -1 !== Array.prototype.indexOf.apply(this, arguments)
}
),
window.NodeList && !NodeList.prototype.forEach && (NodeList.prototype.forEach = Array.prototype.forEach),
Object.entries || (Object.entries = function(e) {
    for (var t = Object.keys(e), a = t.length, i = new Array(a); a--; )
        i[a] = [t[a], e[t[a]]];
    return i
}
),
Element.prototype.matches || (Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector),
Element.prototype.closest || (Element.prototype.closest = function(e) {
    var t = this;
    do {
        if (t.matches(e))
            return t;
        t = t.parentElement || t.parentNode
    } while (null !== t && 1 === t.nodeType);
    return null
}
),
"function" != typeof Object.assign && (Object.assign = function(e) {
    if (null == e)
        throw new TypeError("Cannot convert undefined or null to object");
    e = Object(e);
    for (var t = 1; t < arguments.length; t++) {
        var a = arguments[t];
        if (null != a)
            for (var i in a)
                Object.prototype.hasOwnProperty.call(a, i) && (e[i] = a[i])
    }
    return e
}
),
function() {
    function e(e, t) {
        var a = y.app_setting_config
          , i = a && a.product_template
          , n = !!i && (i.group_swatches || i.variant_swatches);
        return !!(a.enable_swatch ? a.enable_swatch[e][t] : null) && n
    }
    function t() {
        y = window.vsk_data(),
        w = i(y),
        u = new J,
        F = y.block_collection_settings,
        d = !1,
        p = !1;
        var t = y.app_setting_config.enable_swatch;
        R = y.app_setting_config.product_batch_size || 250,
        S = y.product_data_source,
        k = true, // enable_on_home_product_grid
        A = true, // enable_on_home_featured_product
        I = false,
        T = false,
        C = false,
        x = false,
        E = false,
        D = false,
        O = false,
        L = false,
        P = false,
        N = false,
        M = false,
        q = false,
        h = !1,
        w && (n(),
        r()),
        b = y.money_format,
        V = y.is_b2b,
        (g = window.Shopify && window.Shopify.routes && (window.Shopify.routes.root || window.Shopify.routes.root_url) || "/").endsWith("/") || (g += "/"),
        0 == y.published_locales.length && console.log("SWATCH KING LANGUAGE_ERROR ::: Default langaugae is not published in this market.")
    }
    function a(e, t, a) {
        var i = window.Shopify && window.Shopify.theme ? window.Shopify.theme.id : null;
        if (e[i])
            return e[i];
        console.warn("Swatch King App: Theme ID was not located in the app metafields for this theme, please contact support.");
        var n = window.Shopify && window.Shopify.theme && window.Shopify.theme.schema_name ? window.Shopify.theme.schema_name : null;
        for (var r in t) {
            if ((o = t[r]).schema_theme_names.includes(n))
                return o.id
        }
        var s = window.Shopify && window.Shopify.theme ? window.Shopify.theme.theme_store_id : null;
        for (var r in t) {
            var o;
            if ((o = t[r]).theme_store_ids.includes(s))
                return o.id
        }
        return console.warn("Swatch King App: Theme configuration not found for this theme. Currently using the published theme configuration."),
        a
    }
    function i(e) {
        var t = e.theme_settings
          , i = e.published_theme_setting
          , n = e.theme_settings_map
          , r = null;
        if (t && n) {
            var s = a(n, t, i);
            if (s) {
                if (r = t[s]) {
                    var o = e.block_collection_settings;
                    if (o)
                        for (var l in r.settings.collections)
                            o[l] != undefined && (r.settings.collections[l] = o[l])
                }
            } else
                console.error("Swatch King App: Theme configuration not found for this theme, please contact support.")
        }
        return r
    }
    function n() {
        if (!document.querySelector('style[app="vsk"][role="custom-css"]') && u) {
            var e = u.getCustomStyle()
              , t = document.querySelector("head");
            e && t.appendChild(X(e)[0])
        }
    }
    function r() {
        if (!document.querySelector('script[app="vsk"][role="custom-script"]') && u) {
            var e = u.getCustomScripts()
              , t = document.createElement("script");
            t.innerHTML = e,
            t.setAttribute("role", "custom-script"),
            t.setAttribute("app", "vsk"),
            t.setAttribute("type", "text/javascript"),
            document.head.appendChild(t)
        }
    }
    function s(e) {
        var t = window.location.pathname.replace(l, "");
        return ("undefined" == typeof window[e] || window[e] != t) && (window[e] = t,
        !0)
    }
    function o(e) {
        var t = e.toUpperCase();
        return "PT-BR" === t || "PT-PT" === t || "ZH-CN" === t || "ZH-TW" === t ? t.replace("-", "_") : t.match(/^[a-zA-Z]{2}-[a-zA-Z]{2}$/) ? t.substring(0, 2) : t
    }
    var l = RegExp("\\/collections\\/[^\\/]*(?=\\/products)|\\/$", "gi")
      , c = "2025-01"
      , u = undefined
      , d = undefined
      , p = undefined
      , h = undefined
      , g = undefined
      , f = undefined
      , v = undefined
      , m = undefined
      , _ = (undefined,
    undefined)
      , y = undefined
      , w = undefined
      , b = undefined
      , S = undefined
      , k = undefined
      , A = undefined
      , I = undefined
      , T = undefined
      , C = undefined
      , x = undefined
      , E = undefined
      , D = undefined
      , O = undefined
      , L = undefined
      , P = undefined
      , N = undefined
      , M = undefined
      , q = undefined
      , F = undefined
      , V = undefined
      , R = undefined
      , H = "new"
      , z = "sale"
      , B = "sold_out"
      , j = 3
      , U = "lite"
      , W = function() {
        function e(t, a, i) {
            _classCallCheck(this, e),
            this.instanceType = t,
            this.currentDocument = a,
            this.storeSlug = window.Shopify.shop.split(".myshopify.com")[0],
            this.swatchDir = y.swatch_dir,
            this.productUndefined = !1,
            this.hasOnlyDefaultVariant = !1,
            this.hasOnlySingleVariant = !1,
            this.eventsRegistered = !1,
            this.multiLingualInfo = null,
            this.untranslatedData = null,
            this.untranslatedFetchStatus = "none",
            this.isSectionPrimary = !1,
            this.instanceSubType = this.instanceType,
            i && "undefined" != typeof i.instance_sub_type && (this.isSectionPrimary = i.primary,
            this.instanceSubType = i.instance_sub_type),
            this.setInstanceGlobals(),
            this.fetchInformationFromJs()
        }
        return _createClass(e, [{
            key: "setInstanceGlobals",
            value: function() {
                if (this.productInfoTree = new G,
                this.clientSpecs = new J,
                this.uiElements = new K(this.instanceType,this.clientSpecs,this.currentDocument,this.getTranslation.bind(this)),
                this.themeCode = "common",
                this.themeSupportConfig = {},
                this.selectionAllowed = !1,
                this.pInformation = {
                    product_switched: !1,
                    selected_product_group: null,
                    featured_image_src: null,
                    secondary_image_src: null,
                    image_replaced_by_hover: !1,
                    first_or_available_variant: null,
                    preselect_variant: null
                },
                this.doNotSelectAnOption = this.clientSpecs.getDoNotSelectAnOption(),
                this.doNotSelectAnOption.count = 0,
                this.allOptionsData = this.clientSpecs.getAllOptionsData(),
                this.groupsDisplaySelector = null,
                this.labelSplitSymbol = "-",
                this.isInstanceTypeProduct()) {
                    var e = this.clientSpecs.getSelectors();
                    if (this.labelSplitSymbol = this.clientSpecs.getProductSettings().label_split_symbol,
                    "quick_view" != this.instanceSubType) {
                        var t = e.swatch_root.groups_selector;
                        "" != t && (this.groupsDisplaySelector = t)
                    }
                } else
                    this.isInstanceTypeCollection() && (this.labelSplitSymbol = this.getInstanceSettings().label_split_symbol)
            }
        }, {
            key: "dispatchEvent",
            value: function(e, t) {
                var a = document.createEvent("HTMLEvents");
                a.initEvent(e, !0, !1),
                $(["Event Dispatched!!!", e, t]),
                t.dispatchEvent(a)
            }
        }, {
            key: "dispatchThemeEvent",
            value: function(e, t, a) {
                if (window.CustomEvent) {
                    var i = document.createEvent("CustomEvent");
                    i.initCustomEvent(e, !0, !1, a),
                    t.dispatchEvent(i)
                }
            }
        }, {
            key: "dispatchCustomEvent",
            value: function(e, t, a) {
                if (window.CustomEvent) {
                    var i = document.createEvent("CustomEvent");
                    i.initCustomEvent("vsk:" + t, !0, !1, a),
                    e.dispatchEvent(i)
                }
            }
        }, {
            key: "getProductHandleFromScope",
            value: function() {
                var e = [];
                if (this.isInstanceTypeCollection()) {
                    var t = this.getInstanceConfig().data_selectors;
                    "" != t.url && e.push(t.url)
                }
                var a = ['a[href*="/products/"]:not([href*="shopify.com"])', '[data-href*="/products/"]', 'meta[itemprop="url"][content*="/products/"]', "[data-product-handle]", '[data-url*="/products/"]', '[data-product-url*="/products/"]', '[product-url*="/products/"]'];
                e = e.concat(a);
                var i = null;
                if (i = this.currentDocument.matches && this.currentDocument.matches(e) ? this.currentDocument : this.currentDocument.querySelector(e)) {
                    for (var n = null, r = ["data-product-handle", "data-url", "data-product-url", "product-url", "content", "href", "data-href"], s = 0; s < r.length; s++) {
                        var o = r[s];
                        if (i.hasAttribute(o) && i.getAttribute(o)) {
                            n = i.getAttribute(o);
                            break
                        }
                    }
                    return this.extractProductHandle(n)
                }
                return null
            }
        }, {
            key: "isInstanceTypeProduct",
            value: function() {
                return "products" == this.instanceType
            }
        }, {
            key: "isInstanceTypeCollection",
            value: function() {
                return "collections" == this.instanceType
            }
        }, {
            key: "isEventTrusted",
            value: function(e, t) {
                return "undefined" != typeof e.isTrusted && "undefined" != typeof e.screenX && "undefined" != typeof e.screenY && 0 == e.isTrusted && 0 != e.screenX && 0 != e.screenY || ("undefined" != typeof e.isTrusted ? e.isTrusted : "undefined" != typeof e.screenX && "undefined" != typeof e.screenY ? 0 != e.screenX && 0 != e.screenY : t)
            }
        }, {
            key: "isClickEvent",
            value: function(e) {
                return "click" == e
            }
        }, {
            key: "extractProductHandle",
            value: function(e) {
                var t = e.split("/");
                return (t = (t = t[t.length - 1]).split(RegExp("\\?|\\#|\\.js", "gi")))[0]
            }
        }, {
            key: "setSelectMinWidth",
            value: function(e) {
                var t = 250;
                e.style.minWidth && ((t = parseInt(e.style.minWidth.split("px")[0])) || (t = 250)),
                e.offsetWidth > t && (t = e.offsetWidth),
                e.style.minWidth = t + "px"
            }
        }, {
            key: "clickToScroll",
            value: function(e, t) {
                var a = arguments.length <= 2 || arguments[2] === undefined || arguments[2]
                  , i = '[swatch-slider="true"]';
                this.resSlider(e, i, t, a)
            }
        }, {
            key: "resSlider",
            value: function(e, t, a, i) {
                var n = arguments.length <= 4 || arguments[4] === undefined ? 0 : arguments[4]
                  , r = t + ' [navigation="left"]'
                  , s = t + ' [navigation="right"]'
                  , o = JSON.parse(a.dataset.sliderData)
                  , l = a.querySelector(t + ".swatch-navigable ul");
                a.sliderInitialized || (this.initSlider(t, a),
                a.sliderInitialized = !0),
                l.style.transition = 0 !== n ? "0.6s cubic-bezier(0.215, 0.610, 0.355, 1.000)" : i ? "0.3s ease-out" : "none";
                var c = l.style.transform.match(/-?[\d\.]+/g) || [0]
                  , u = parseFloat(c[0]) || 0;
                if (0 !== n)
                    return this.applyMomentum(.25 * n, u, l, a, r, s, o);
                if (0 == e)
                    a.querySelector(s).classList.remove("star-disabled"),
                    "mode_0" != o.arrowMode && a.querySelector(s).classList.add("star-show"),
                    "swatch-pill" == o.swatchType || "button" == o.assocViewType ? (u += .8 * o.sliderWidth) >= -o.firstSwatchWidth / 2 && (u = 0,
                    this.handleEdge(a, r, "left", o)) : (u += this.calculateSlideCount(o) * (o.swatchSliderItemWidth + o.marginRight),
                    "half" === o.lastSwatchPreview && (u += o.swatchSliderItemWidth - o.lastSwatchWidth),
                    u >= -o.swatchSliderItemWidth / 3 && (u = 0,
                    this.handleEdge(a, r, "left", o)));
                else if (1 == e)
                    if (a.querySelector(r).classList.remove("star-disabled"),
                    "mode_0" != o.arrowMode && a.querySelector(r).classList.add("star-show"),
                    "swatch-pill" == o.swatchType || "button" == o.assocViewType) {
                        var d = u;
                        u -= .8 * o.sliderWidth,
                        o.totalScrollWidth <= -(u - o.sliderWidth) && (u = d + (-o.totalScrollWidth - (d - o.sliderWidth)) - 1,
                        this.handleEdge(a, s, "right", o))
                    } else {
                        d = u;
                        u -= this.calculateSlideCount(o) * (o.swatchSliderItemWidth + o.marginRight),
                        "half" === o.lastSwatchPreview && (u -= o.swatchSliderItemWidth - o.lastSwatchWidth),
                        Number(o.totalScrollWidth.toFixed(3)) <= Number((-(u - o.sliderWidth)).toFixed(3)) && (u = Number((d + (-o.totalScrollWidth - (d - o.sliderWidth))).toFixed(3)),
                        this.handleEdge(a, s, "right", o))
                    }
                return l.style.transform = "translateX(" + u + "px)",
                u
            }
        }, {
            key: "applyMomentum",
            value: function(e, t, a, i, n, r, s) {
                var o = t + e
                  , l = -s.totalScrollWidth + s.sliderWidth;
                return o > 0 ? (o = 0,
                this.handleEdge(i, n, "left", s)) : o < l && (o = l,
                this.handleEdge(i, r, "right", s)),
                o < 0 && (i.querySelector(n).classList.remove("star-disabled"),
                "mode_0" != s.arrowMode && i.querySelector(n).classList.add("star-show")),
                o > l && (i.querySelector(r).classList.remove("star-disabled"),
                "mode_0" != s.arrowMode && i.querySelector(r).classList.add("star-show")),
                a.style.transform = "translateX(" + o + "px)",
                o
            }
        }, {
            key: "calculateSlideCount",
            value: function(e) {
                var t = e.visibleSwatches > 0 ? e.visibleSwatches : 1;
                return "mode_1" == e.arrowMode && (t = e.visibleSwatches > 2 ? e.visibleSwatches - 2 : 1),
                t
            }
        }, {
            key: "handleEdge",
            value: function(e, t, a, i) {
                "mode_1" == i.arrowMode ? setTimeout(function() {
                    e.querySelector(t).classList.remove("star-show")
                }, 500) : e.querySelector(t).classList.add("star-disabled")
            }
        }, {
            key: "initSlider",
            value: function(e, t) {
                var a = this
                  , i = t.querySelector(e + ".swatch-navigable ul")
                  , n = undefined
                  , r = 0
                  , s = !1
                  , o = 0
                  , l = undefined
                  , c = undefined
                  , u = undefined
                  , d = function(e) {
                    n = l = e,
                    c = Date.now(),
                    s = !0,
                    i.style.transition = "none";
                    var t = i.style.transform;
                    if (t) {
                        var a = t.match(/translateX\(([-\d.]+)px\)/);
                        a && (r = parseFloat(a[1]))
                    }
                }
                  , p = function(e) {
                    s && ((u = Date.now()) - c > 0 && (o = (e - l) / (u - c)),
                    l = e,
                    c = u,
                    i.style.transform = "translateX(" + (r + (e - n)) + "px)")
                }
                  , h = function() {
                    s && (s = !1,
                    a.resSlider(null, e, t, !0, 1e3 * (o || .01)))
                };
                i.addEventListener("touchstart", function(e) {
                    d(e.touches[0].clientX)
                }),
                i.addEventListener("touchmove", function(e) {
                    e.preventDefault(),
                    p(e.touches[0].clientX)
                }, {
                    passive: !1
                }),
                i.addEventListener("touchend", function() {
                    h()
                })
            }
        }, {
            key: "scrollSwatchSlider",
            value: function(e) {
                var t = e.closest(".swatch-navigable")
                  , a = e.getAttribute("data-navigation");
                if (t && t.hasAttribute("data-current-scroll")) {
                    var i = Number(t.getAttribute("data-current-scroll"))
                      , n = t.querySelectorAll(".swatch-view-item")
                      , r = i;
                    if ("right" === a)
                        for (var s = i; s < n.length; s++) {
                            var o = n[s].getBoundingClientRect()
                              , l = t.getBoundingClientRect();
                            if (o.left - 3 > l.left) {
                                n[s].scrollIntoView({
                                    behavior: "smooth",
                                    block: "nearest",
                                    inline: "start"
                                }),
                                r = s;
                                break
                            }
                        }
                    else
                        "left" === a && (r = Math.max(0, i - 1));
                    var c = r === n.length - 1 ? "end" : "start";
                    return n[r].scrollIntoView({
                        behavior: "smooth",
                        block: "nearest",
                        inline: c
                    }),
                    void t.setAttribute("data-current-scroll", r)
                }
                "left" == a ? this.clickToScroll(0, t) : this.clickToScroll(1, t)
            }
        }, {
            key: "getCorrectSwatchRoot",
            value: function() {
                var e = this
                  , t = arguments.length <= 0 || arguments[0] === undefined ? "options" : arguments[0]
                  , a = null
                  , i = null
                  , n = !1
                  , r = "bottom";
                if (this.isInstanceTypeProduct()) {
                    if (a = "products_" + t + "_root",
                    void 0 === (i = this.pInformation[a]) || !i.parentNode) {
                        var s = this.clientSpecs.getSelectors()
                          , o = null
                          , l = "groups" == t;
                        r = s.swatch_root.position;
                        var c = "div[data-vsk-groups-priority]"
                          , u = document.querySelector(c)
                          , d = this.productInfoTree.getProductInfo().handle
                          , p = null;
                        u && (p = u.dataset.vskProductHandle),
                        u && p == d && (this.groupsDisplaySelector = c),
                        o = l && this.groupsDisplaySelector && this.clientSpecs.getGroupsEnableStatusForProductType() ? this.groupsDisplaySelector : s.swatch_root.selector,
                        !(i = l && u && p == d && this.clientSpecs.getGroupsEnableStatusForProductType() ? u : this.currentDocument.querySelector(o)) && this.currentDocument.matches && this.currentDocument.matches(o) && (i = this.currentDocument),
                        n = !!i
                    }
                } else
                    this.isInstanceTypeCollection() && (a = "collections_" + t + "_root",
                    void 0 !== (i = this.pInformation[a]) && i.parentNode || function() {
                        var t = e.getInstanceConfig()
                          , a = "bottom";
                        i = e.currentDocument,
                        r = a;
                        var s = t.swatch_display_options
                          , o = F.swatch_location;
                        if (s) {
                            var l = -1;
                            -1 !== (l = s.findIndex(function(e) {
                                return e.label === o
                            })) ? (r = s[l].position,
                            i = e.currentDocument.querySelector(s[l].selector)) : -1 !== (l = s.findIndex(function(t) {
                                return !!e.currentDocument.querySelector(t.selector)
                            })) && (r = s[l].position,
                            i = e.currentDocument.querySelector(s[l].selector))
                        }
                        i || (r = a,
                        i = e.currentDocument),
                        n = !0
                    }());
                if (n) {
                    var h = document.createElement("variant-swatch-king");
                    h.style.maxWidth = "100%",
                    "before" == r ? i.parentNode.insertBefore(h, i) : "after" == r ? i.parentNode.insertBefore(h, i.nextSibling) : "top" == r ? i.insertBefore(h, i.firstChild) : i.appendChild(h),
                    this.pInformation[a] = h,
                    i = h
                }
                return i
            }
        }, {
            key: "getLabelWidth",
            value: function(e, t) {
                var a = e.closest(".swatch-drop-down-label");
                if (a) {
                    var i = a.querySelector(".swatch-label-inside");
                    if (i) {
                        t = parseFloat(t.match(/[\d\.]+/g));
                        var n = i.getBoundingClientRect().width;
                        e.style.paddingLeft = t + n + "px"
                    }
                }
            }
        }, {
            key: "getPriceMaxWidth",
            value: function(e) {
                var t = e.querySelectorAll(".swatch-button-price")
                  , a = 0;
                t.forEach(function(e) {
                    var t = e.offsetWidth;
                    t > a && (a = t)
                }),
                t.forEach(function(e) {
                    e.style.width = a + "px"
                })
            }
        }, {
            key: "setProductGroupsObject",
            value: function() {
                return f || "undefined" == typeof window.starapps_data ? !f && ["lambda"].includes(this.clientSpecs.getDataUrlSource()) ? (m = this.clientSpecs.getLambdaCloudFrontUrl(),
                f = [],
                v = {}) : !f && ["metafield"].includes(this.clientSpecs.getDataUrlSource()) && (f = [],
                v = {},
                _ = 1) : (f = window.starapps_data.product_groups,
                v = window.starapps_data.product_groups_chart),
                null != f && f != undefined
            }
        }, {
            key: "getProductsGroups",
            value: function(e) {
                for (var t = [], a = 0; a < e.length; a++) {
                    var i = e[a];
                    t.push(f[i])
                }
                return t
            }
        }, {
            key: "setProductGroupsFromAPI",
            value: function(e, t) {
                e && 0 != e.length || "undefined" == typeof v[t] && (v[t] = []);
                for (var a = function(t) {
                    f.some(function(a) {
                        return a.id == e[t].id
                    }) || f.push(e[t])
                }, i = 0; i < e.length; i++)
                    a(i);
                for (var n = function(e) {
                    f[e].option_values.some(function(e) {
                        return e.handle == t
                    }) && (v[t] ? v[t].some(function(t) {
                        return t == e
                    }) || v[t].push(e) : v[t] = [e])
                }, r = 0; r < f.length; r++)
                    n(r)
            }
        }, {
            key: "getProductGroupsByAPI",
            value: function(e) {
                var t, a = this, i = arguments.length <= 1 || arguments[1] === undefined ? function() {}
                : arguments[1];
                JSON.stringify({
                    shopify_domain: window.Shopify.shop,
                    product_handle: e
                });
                window.fetch ? fetch(m + "/store/" + this.storeSlug + "/" + S + "/groups/" + e + ".json", {
                    method: "GET"
                }).then(function(e) {
                    return e.json()
                }).then(function(t) {
                    a.setProductGroupsFromAPI(t, e),
                    i && i.call(a)
                }) : ((t = new XMLHttpRequest).open("GET", m + "/store/" + a.storeSlug + "/" + S + "/groups/" + e + ".json", !0),
                t.onload = function() {
                    if (t.status >= 200 && t.status < 400) {
                        var a = JSON.parse(t.responseText);
                        this.setProductGroupsFromAPI(a, e),
                        i && i.call(this)
                    }
                }
                .bind(a),
                t.send(null))
            }
        }, {
            key: "setProductGroupsFromMetafield",
            value: function(e, t) {
                function a(e, t, i, n) {
                    return Object.entries(e).reduce(function(r, s) {
                        var o = _slicedToArray(s, 2)
                          , l = o[0]
                          , c = o[1]
                          , u = e.hasOwnProperty("products")
                          , d = t[l] || (u ? i[l] : l);
                        return Array.isArray(c) ? r[d] = c.map(function(e) {
                            return a(e, i, i, n)
                        }) : r[d] = "object" == typeof c && null !== c ? "group_display_name" === l || "product_display_name" === l ? c[n] || null : a(c, t, i, n) : c,
                        r
                    }, {})
                }
                e && 0 != e.length || "undefined" == typeof v[t] && (v[t] = []);
                var i = {
                    group_id: "id",
                    group_name: "group_name",
                    group_display_name: "option_name",
                    product_page_style_id: "products_preset_id",
                    product_page_swatch_source: "products_swatch",
                    collection_page_style_id: "collections_preset_id",
                    collection_page_swatch_source: "collections_swatch",
                    group_display_position: "display_position",
                    primary_locale: "primary_locale",
                    products: "option_values"
                }
                  , n = {
                    id: "id",
                    product_display_name: "option_value",
                    handle: "handle",
                    published: "published",
                    product_position: "product_position",
                    swatch_src: "swatch_src",
                    swatch_value: "swatch_value"
                };
                e.forEach(function(e) {
                    f.some(function(t) {
                        return t.id == e.group_id
                    }) || f.push(a(e, i, n, e.primary_locale))
                });
                for (var r = function(e) {
                    f[e].option_values.some(function(e) {
                        return e.handle == t
                    }) && (v[t] ? v[t].some(function(t) {
                        return t == e
                    }) || v[t].push(e) : v[t] = [e])
                }, s = 0; s < f.length; s++)
                    r(s)
            }
        }, {
            key: "getProductGroupsByMetafields",
            value: function(e, t) {
                var a = this
                  , i = arguments.length <= 2 || arguments[2] === undefined ? function() {}
                : arguments[2]
                  , n = t + "-" + e
                  , r = this.getDataFromSessionStorage(this.getSessionStorageKey(n, !1, !0, !0));
                if (r)
                    null !== r && r.data.length > 0 && (this.setProductGroupsFromMetafield(r.data, t),
                    i && i.call(this));
                else {
                    var s = '\n        query productGroupsData {\n            product(id: "gid://shopify/Product/' + e + '") {\n                id\n                handle\n                metafield(namespace: "vsk", key: "group_data") {\n                    value\n                }\n            }\n        }\n    ';
                    this.executeStorefrontFetch({
                        query: s,
                        isMultiple: !0,
                        callback: function(e) {
                            var r = e && e.product && e.product.metafield ? JSON.parse(e.product.metafield.value) : []
                              , s = {
                                data: r
                            };
                            r.length > 0 && a.setDataToSessionStorage(a.getSessionStorageKey(n, !1, !0, !0), s),
                            a.setProductGroupsFromMetafield(r, t),
                            i && i.call(a)
                        }
                    })
                }
            }
        }, {
            key: "getProductGroupIndexes",
            value: function(e) {
                var t = v[e];
                return void 0 !== t ? t : m || _ ? null : []
            }
        }, {
            key: "getGroupSwatchImageURL",
            value: function(e, t) {
                var a = encodeURIComponent(t);
                return "cdn" == this.clientSpecs.getSwatchUrlSource() && (a = encodeURIComponent(a)),
                "https://" + this.clientSpecs.getSwatchUrlHost() + "/apps/" + this.swatchDir + "/" + this.storeSlug + "/groups/" + e.split("group")[1] + "/" + a + ".media"
            }
        }, {
            key: "generateProductGroups",
            value: function() {
                var e = this;
                if ("collections" === this.instanceType ? this.clientSpecs.getEnableStatusForProductGridType() : "products" === this.instanceType && this.clientSpecs.getGroupsEnableStatusForProductType())
                    if (this.setProductGroupsObject())
                        if (this.hasOnlyDefaultVariant || this.uiElements.getIsSwatchRootDisplayed()) {
                            var t = this.getMultiLingualInfo().translation_status;
                            if (t && !this.productInfoTree.getUntranslatedProductHandle())
                                return setTimeout(this.generateProductGroups.bind(this), 100),
                                void $("Untranslated handle is not found ... calling generateProductGroups method again!");
                            var a = t ? this.productInfoTree.getUntranslatedProductHandle() : this.productInfoTree.getProductInfo().handle
                              , i = this.productInfoTree.getProductInfo().id
                              , n = this.getProductGroupIndexes(a)
                              , r = null;
                            if (m && null == n)
                                this.getProductGroupsByAPI(a, this.generateProductGroups.bind(this));
                            else if (_ && null == n)
                                this.getProductGroupsByMetafields(i, a, this.generateProductGroups.bind(this));
                            else if (!((r = this.getProductsGroups(n)).length <= 0)) {
                                var s = this.groupsDisplaySelector ? "groups" : "options"
                                  , o = this.getCorrectSwatchRoot(s);
                                this.uiElements.getIsSwatchRootDisplayed(s) || (this.isInstanceTypeProduct() ? this.uiElements.renderSwatchRoot(this.uiElements.getSwatchRoot([]), o, s) : this.isInstanceTypeCollection() && this.uiElements.renderSwatchRoot(this.uiElements.getSwatchRoot([]), o));
                                var l = o.querySelector(".swatches.swatches-type-" + this.instanceType)
                                  , c = {
                                    top: 0,
                                    bottom: 0
                                }
                                  , u = {
                                    top: [],
                                    bottom: []
                                };
                                Object.entries(r).forEach(function(t) {
                                    var i = _slicedToArray(t, 2)
                                      , r = i[0]
                                      , s = i[1]
                                      , o = "group" + s.id;
                                    if ("length" != r) {
                                        for (var d = 0; d < u[s.display_position].length; d++) {
                                            var p = u[s.display_position][d];
                                            if (s.group_name.toString() < p.group_name.toString()) {
                                                c[s.display_position] = d;
                                                break
                                            }
                                            "top" == s.display_position ? c[s.display_position] = d + 1 : "bottom" == s.display_position && (c[s.display_position] = -1)
                                        }
                                        var h, g, f, v, m = s.option_name ? s.option_name : "", _ = "<div " + (e.isInstanceTypeProduct() ? 'id="swatch-' + o + '" ' : "") + 'option-name="' + ("" != m.trim() ? m : "empty") + '" option-target="' + o + '" type-group="true"></div>';
                                        if ("top" == s.display_position) {
                                            var y = l.querySelector('[sa-group-position="top"]');
                                            y.querySelector('[option-target="' + o + '"]') || y.insertBefore(e.uiElements.parseHTML(_)[0], y.children[c.top])
                                        } else {
                                            var w = l.querySelector('[sa-group-position="bottom"]');
                                            if (!w.querySelector('[option-target="' + o + '"]')) {
                                                var b = w.children.length - 1 - c.bottom;
                                                -1 != c.bottom ? w.insertBefore(e.uiElements.parseHTML(_)[0], w.children[b]) : w.append(e.uiElements.parseHTML(_)[0])
                                            }
                                        }
                                        e.pInformation.selected_product_group && e.pInformation.selected_product_group == o || (v = n[r],
                                        "storefront" == S ? (h = {},
                                        g = [],
                                        f = Object.fromEntries(Object.entries(window.sessionStorage)),
                                        (g = s.option_values.reduce(function(t, a) {
                                            var i = '"gid://shopify/Product/' + a.id + '"'
                                              , n = e.getSessionStorageKey(a.id, !1, !1)
                                              , r = e.getDataFromSessionStorage(n);
                                            if ((!r || r && null == r.id) && (n = e.getSessionStorageKey(a.id, !1, !1, undefined, undefined, undefined, U),
                                            r = e.getDataFromSessionStorage(n)),
                                            f[n])
                                                if (r && null !== r.id) {
                                                    h[i] = r;
                                                    var o = s.option_values.findIndex(function(e) {
                                                        return e.id === a.id
                                                    });
                                                    -1 !== o && (s.option_values[o] = _extends({}, s.option_values[o], {
                                                        available: r.available,
                                                        published: !0,
                                                        published_at: r.publishedAt,
                                                        compare_at_price: r.compareAtPriceRange
                                                    }))
                                                } else
                                                    s.option_values = s.option_values.filter(function(e) {
                                                        return e.id !== a.id
                                                    });
                                            else
                                                t.push(i);
                                            return t
                                        }, [])).length > 0 ? function() {
                                            for (var t = R, i = Math.ceil(g.length / t), n = 0, r = function(t, i) {
                                                ++n === i && e.generateProductGroupsUI(v, c, l, o, s, a, h)
                                            }, u = 0; u < g.length; u += t) {
                                                var d = g.slice(u, u + t)
                                                  , p = Math.floor(u / t);
                                                e.getUntranslatedProductData(v, c, l, o, s, a, h, d, i, p, r)
                                            }
                                        }() : e.generateProductGroupsUI(v, c, l, o, s, a, h)) : e.generateProductGroupsUI(v, c, l, o, s, a)),
                                        u[s.display_position].push(s)
                                    }
                                })
                            }
                        } else
                            setTimeout(this.generateProductGroups.bind(this), 50);
                    else
                        setTimeout(this.generateProductGroups.bind(this), 250)
            }
        }, {
            key: "getUntranslatedProductData",
            value: function(e, t, a, i, n, r, s, l, c, u, d) {
                var p = this
                  , h = o(window.Shopify.locale)
                  , g = "\n        query productDetails @inContext(country: " + window.Shopify.country.toUpperCase() + ", language: " + h + ") {\n            nodes(ids: [" + l + "]) {\n                ... on Product {\n                    id\n                    handle\n                    title\n                    vendor\n                    availableForSale\n                    onlineStoreUrl\n                    tags\n                    publishedAt\n                    priceRange{\n                        maxVariantPrice{\n                            amount\n                        }\n                        minVariantPrice{\n                            amount\n                        }\n                    }\n                    featuredImage{\n                        id\n                        url\n                    }\n                    options{\n                        id\n                        name\n                        values\n                        optionValues{\n                            id\n                            name\n                        }\n                    }\n                    images(first: 250){\n                        nodes{\n                            id\n                            url\n                            altText\n                        }\n                    }\n                    compareAtPriceRange {\n                        maxVariantPrice {\n                            amount\n                        }\n                         minVariantPrice {\n                            amount\n                        }\n                    }\n                }\n            }\n        }\n    ";
                this.executeStorefrontFetch({
                    query: g,
                    isMultiple: !0,
                    callback: function(e, t) {
                        var a = e.nodes;
                        l.forEach(function(e, i) {
                            var r = a[i]
                              , o = e.match(/\d+/)[0]
                              , l = t.country
                              , c = t.language;
                            if (s[e] = r,
                            p.setDataToSessionStorage(p.getSessionStorageKey(o, !1, !1, !1, l, c, U), r),
                            r) {
                                p.setDataToSessionStorage(p.getSessionStorageKey(r.handle, !1, !1, undefined, undefined, undefined, U), r);
                                var u = n.option_values.findIndex(function(e) {
                                    return e.id === parseInt(o)
                                });
                                -1 !== u && (n.option_values[u] = _extends({}, n.option_values[u], {
                                    available: r.availableForSale,
                                    published: !0,
                                    published_at: r.publishedAt,
                                    compare_at_price: r.compareAtPriceRange
                                }))
                            } else
                                n.option_values = n.option_values.filter(function(e) {
                                    return e.id !== parseInt(o)
                                })
                        }),
                        d(u, c)
                    }
                })
            }
        }, {
            key: "generateProductGroupsUI",
            value: function(e, t, a, i, n, r) {
                var s = this
                  , o = arguments.length <= 6 || arguments[6] === undefined ? null : arguments[6]
                  , l = !1
                  , c = n.option_name ? n.option_name : ""
                  , u = {
                    available_count: 0,
                    name: this.getTranslation(c),
                    untranslated_name: c,
                    view_type_preset: this.clientSpecs.getViewTypeByGroup(n, this.instanceType),
                    product_group_index: e,
                    data: [],
                    show_price: !1
                }
                  , d = 0
                  , p = this.isInstanceTypeCollection() ? this.getSwatchMinifiedCount("groups") : null;
                if (0 == p && d++,
                "hidden" != u.view_type_preset.assoc_view_type) {
                    var h = null
                      , g = (undefined,
                    this.getMultiLingualInfo());
                    b ? b.trim() : g.money_format.trim(),
                    h = g.current_url + "/products";
                    var f = !1;
                    u.view_type_preset && "invisible" == u.view_type_preset.params.stock_out_type && (f = !0);
                    for (var v = n.option_values.every(function(e) {
                        return !s.getTranslatedData(e, o, "available")
                    }), m = 0; m < n.option_values.length; m++) {
                        var _ = n.option_values[m]
                          , y = this.getTranslatedData(_, o, "minPrice")
                          , w = this.getTranslatedData(_, o, "maxPrice")
                          , k = this.getTranslatedData(_, o, "title")
                          , A = this.getTranslatedData(_, o, "handle")
                          , I = r == _.handle;
                        _.available = this.getTranslatedData(_, o, "available");
                        var T = u.view_type_preset[this.instanceType + "_swatch"]
                          , C = this.uiElements.isASwatch(u.view_type_preset.assoc_view_type)
                          , x = {
                            src: "none"
                        }
                          , E = {
                            src: this.getTranslatedData(_, o, "featured_img")
                        }
                          , D = {
                            src: this.getTranslatedData(_, o, "secondary_img")
                        };
                        if ("first_product_image" == T ? x.src = this.getTranslatedData(_, o, "featured_img") : "second_product_image" == T ? x.src = this.getTranslatedData(_, o, "secondary_img") : "last_product_image" == T ? x.src = this.getTranslatedData(_, o, "last_img") : "custom_swatch" == T && C && (x = {
                            src: this.getGroupSwatchImageURL(i, _.handle)
                        }),
                        null != p && ("undefined" == typeof _.published || _.published)) {
                            if (p <= 1 && !I && (f && _.available || !f || v)) {
                                d++;
                                continue
                            }
                            !I && (f && _.available || !f || v) && p--
                        }
                        if (("undefined" == typeof _.published || _.published) && "" != _.handle) {
                            _.option_value && "" != _.option_value.trim() && (k = this.getTranslation(_.option_value));
                            var O = undefined;
                            u.view_type_preset[this.instanceType + "_swatch"];
                            if ("storefront" == S ? O = y && w ? y === w ? this.getMoneyWithFormat(b, y) : this.getMoneyWithFormat(b, y) + "+" : this.getMoneyWithFormat(b, 0) : (O = _.min_price && _.max_price ? _.min_price === _.max_price ? this.getMoneyWithFormat(b, 100 * _.min_price) : this.getMoneyWithFormat(b, 100 * _.min_price) + "+" : this.getMoneyWithFormat(b, 100 * _.price) + "+",
                            "undefined" == typeof _.available && (_.available = !0)),
                            u.data.push({
                                value: k,
                                original_value: k,
                                featured_image: x,
                                product_featured_image: E,
                                product_secondary_image: D,
                                available: _.available,
                                url: h + "/" + A,
                                selected: I,
                                price: O,
                                min_compare_at_price: _.compare_at_price ? parseFloat(_.compare_at_price.minVariantPrice.amount) : 0,
                                min_price: y,
                                published_at: _.published_at
                            }),
                            _.available && (u.available_count += 1),
                            I && (l = !0),
                            "storefront" == S)
                                u.show_price = !0;
                            else {
                                var L = window.Shopify && window.Shopify.currency ? Shopify.currency.active : null;
                                null !== L && this.clientSpecs.default_currency == L && this.clientSpecs.default_language == this.multiLingualInfo.current_language && (u.show_price = !0)
                            }
                        }
                    }
                }
                var P, N, M, q = "";
                if (q += l ? this.uiElements.getViewByType(u.view_type_preset).getView(i, u) : '<input type="hidden" value="Product group hidden or current product not present."/>',
                a.querySelector('[option-target="' + i + '"]').appendChild(this.uiElements.parseHTML(q)[0]),
                "smart_hide" == this.clientSpecs.hideSingleValueOption(this.instanceType) && (P = !1,
                N = null,
                M = a.querySelectorAll("ul.swatch-view-image, ul.swatch-view-custom-image"),
                Object.entries(M).forEach(function(e) {
                    var t = _slicedToArray(e, 2)
                      , a = t[0]
                      , i = t[1];
                    if ("length" != a) {
                        var n = 1 == i.children.length ? i.closest("div[option-target]") : null;
                        n ? (n.classList.add("option-single-value"),
                        null == N && (N = n)) : P = !0,
                        !P && N && a == M.length - 1 && N.classList.remove("option-single-value")
                    }
                })),
                l) {
                    if ("drop_down" == u.view_type_preset.assoc_view_type && "label_inside" == u.view_type_preset.params.dropdown_type) {
                        var V = a.querySelectorAll("div.swatch-drop-down-inner [type='select']");
                        Object.entries(V).forEach(function(e) {
                            var t = _slicedToArray(e, 2)
                              , a = t[0]
                              , i = t[1];
                            "length" != a && s.getLabelWidth(i, u.view_type_preset.params.padding_left)
                        })
                    }
                    if ("button" == u.view_type_preset.assoc_view_type && (u.view_type_preset.params.full_width || u.view_type_preset.params.radio_button)) {
                        var R = a.querySelectorAll(".enable-price-alignment");
                        Object.entries(R).forEach(function(e) {
                            var t = _slicedToArray(e, 2)
                              , a = t[0]
                              , i = t[1];
                            "length" != a && s.getPriceMaxWidth(i)
                        })
                    }
                    this.generateProductGroupsUIHelper(u.view_type_preset, i, a, d, u),
                    this.isInstanceTypeCollection() && F.switch_on_hover && this.addFeaturedImageDirectlyIntoDOMElementForGroups(a, u)
                }
            }
        }, {
            key: "createFeaturedImageContainer",
            value: function(e) {
                var t = e.querySelector(".vsk-product-images-data");
                if (t)
                    return t;
                var a = document.createElement("div");
                return a.className = "vsk-product-images-data",
                a.style.display = "none",
                e.insertBefore(a, e.firstChild),
                a
            }
        }, {
            key: "addFeaturedImageDirectlyIntoDOMElementForGroups",
            value: function(e, t) {
                for (var a = this.createFeaturedImageContainer(e), i = 0; i < t.data.length; i++) {
                    var n = a.querySelector('[data-product-handle="' + t.data[i].url + '"]');
                    n || ((n = document.createElement("div")).setAttribute("data-product-handle", t.data[i].url),
                    a.appendChild(n)),
                    n.setAttribute("data-featured-image", t.data[i].product_featured_image ? t.data[i].product_featured_image.src : "");
                    var r = "";
                    t.data[i].product_secondary_image && "none" != t.data[i].product_secondary_image.src ? r = t.data[i].product_secondary_image.src : t.data[i].product_featured_image && (r = t.data[i].product_featured_image.src),
                    n.setAttribute("data-secondary-image", r)
                }
            }
        }, {
            key: "generateProductGroupsUIHelper",
            value: function(e, t, a, i) {
                var n = a.querySelector('[option-target="' + t + '"] .swatch-group-selector[current-product]');
                if (n) {
                    if (0 != i) {
                        var r = n.closest("[option-name]").getAttribute("option-name")
                          , s = this.uiElements.getMinifiedHTML(r, i, this.productInfoTree.getProductInfo());
                        n.closest("ul.swatch-view").appendChild(s)
                    }
                    if (this.uiElements.selectSwatch(t, n, n.getAttribute("orig-value")),
                    "select_value" == n.getAttribute("type")) {
                        var o = n.closest("div.swatch-drop-down-inner").querySelector('div[type="select"]');
                        o.style.minWidth && "0px" != o.style.minWidth || this.setSelectMinWidth(o),
                        o.innerHTML = n.innerHTML,
                        o.setAttribute("aria-label", n.innerText),
                        o.setAttribute("aria-expanded", !1),
                        n.parentNode.classList.add("swatch-hide")
                    }
                    var l = n.closest("[option-target]")
                      , c = l.querySelector("span.swatch-variant-name");
                    if (c) {
                        var u = n.getAttribute("data-value")
                          , d = l.getAttribute("option-name");
                        c && d && "empty" != d.trim() && "none" != u && (c.innerHTML = ' <span class="swatch-split-symbol">' + this.labelSplitSymbol + "</span> " + u)
                    }
                    var p = n.closest(".swatch-navigable, variant-swatch-king")
                      , h = n.closest(".swatch-view-stack, variant-swatch-king");
                    if (p && "VARIANT-SWATCH-KING" != p.tagName) {
                        var g = n.closest("ul.swatch-view")
                          , f = n.closest("li.swatch-view-item")
                          , v = '[data-navigation="left"]'
                          , m = !!g && f.offsetLeft > g.clientWidth;
                        if (m && (v = '[data-navigation="right"]'),
                        p) {
                            p.querySelector(".swatch-navigation" + v);
                            var _ = n.closest(".swatch-navigable");
                            this.resSliderSize(_, e.params, e.assoc_view_type)
                        }
                        m && (g.style.scrollBehavior = "auto",
                        g.scrollLeft = f.offsetLeft - f.offsetWidth,
                        g.style.scrollBehavior = "")
                    } else if (h && "VARIANT-SWATCH-KING" != h.tagName) {
                        _ = n.closest(".swatch-view-stack");
                        this.resStackSize(_, e.params, e.assoc_view_type)
                    }
                }
            }
        }, {
            key: "getTranslatedData",
            value: function(e, t, a) {
                var i = '"gid://shopify/Product/' + e.id + '"';
                if (t && t[i]) {
                    var n = t[i];
                    switch (a) {
                    case "title":
                        return n.title;
                    case "handle":
                        return n.handle;
                    case "minPrice":
                        return parseFloat(n.priceRange.minVariantPrice.amount);
                    case "maxPrice":
                        return parseFloat(n.priceRange.maxVariantPrice.amount);
                    case "available":
                        return n.availableForSale;
                    case "featured_img":
                        return n.featuredImage ? n.featuredImage.url : this.clientSpecs.getDefaultSwatchImage();
                    case "secondary_img":
                        return n.images.nodes.length > 1 ? n.images.nodes[1].url : this.clientSpecs.getDefaultSwatchImage();
                    case "last_img":
                        var r = n.images.nodes.length;
                        return r ? n.images.nodes[r - 1].url : this.clientSpecs.getDefaultSwatchImage()
                    }
                }
                return e[a]
            }
        }, {
            key: "getInstanceConfig",
            value: function() {
                return this.clientSpecs.getCollectionConfig()
            }
        }, {
            key: "getInstanceSettings",
            value: function() {
                return this.clientSpecs.getCollectionSettings()
            }
        }, {
            key: "removeElement",
            value: function(e) {
                e.parentNode.removeChild(e)
            }
        }, {
            key: "generateImageURL",
            value: function(e, t) {
                var a = /\.(?:jpg|png|jpeg|gif|tiff|bmp)(?:\?|\s|$)/gm
                  , i = /(?:_\d*x\d*|_medium|_large|_small)(?:_crop_[a-zA-Z]{3,6}){0,1}(?=\.(?:jpg|png|jpeg|gif|tiff|bmp))/gm.exec(e)
                  , n = a.exec(t);
                return i && n && (t = t.replace(n[0], i[0] + n[0])),
                t
            }
        }, {
            key: "updateVariantImage",
            value: function(e, t, a) {
                var i = !1
                  , n = !1
                  , r = a ? "featured_image_src" : "secondary_image_src";
                if (a && t.featured_image ? i = !0 : !a && t.featured_image && t.featured_image.secondary_src && (i = !0),
                e && "PICTURE" == e.tagName) {
                    for (var s = e.querySelectorAll("source"), o = 0; o < s.length; o++)
                        this.removeElement(s[o]);
                    e = e.querySelector("img")
                }
                if (e && i)
                    if ("IMG" == e.tagName) {
                        var l = e.getAttribute("src");
                        if (e.currentSrc && (l = e.currentSrc),
                        !l && e.hasAttribute("data-srcset")) {
                            var c = e.getAttribute("data-srcset");
                            if ((c = c.split(",")).length > 1)
                                l = c[parseInt((c.length - 1) / 2)].trim().split(" ")[0];
                            else if (1 == c.length) {
                                l = c[0].trim().split(" ")[0]
                            }
                        }
                        this.pInformation[r] || (this.pInformation[r] = l);
                        var u = null;
                        u = a ? this.generateImageURL(l, t.featured_image.src) : this.generateImageURL(l, t.featured_image.secondary_src),
                        e.setAttribute("src", u),
                        e.setAttribute("srcset", u),
                        e.setAttribute("data-srcset", u),
                        n = !0
                    } else {
                        var d = /url\((\S*)\)/gm;
                        (l = e.style.backgroundImage) || (l = e.style.background);
                        var p = d.exec(l);
                        if (p) {
                            l = (l = p[1]).trim(),
                            this.pInformation[r] || (this.pInformation[r] = l);
                            u = null;
                            u = a ? this.generateImageURL(l, t.featured_image.src) : this.generateImageURL(l, t.featured_image.secondary_src),
                            e.setAttribute("data-bgset", u),
                            e.style.backgroundImage ? e.style.backgroundImage = "url(" + u + ")" : e.style.background = "url(" + u + ")",
                            n = !0
                        }
                    }
                else if (e)
                    if ("IMG" == e.tagName && this.pInformation[r]) {
                        u = this.pInformation[r];
                        e.setAttribute("src", u),
                        e.setAttribute("srcset", u),
                        e.setAttribute("data-srcset", u),
                        n = !0
                    } else if (this.pInformation[r]) {
                        u = this.pInformation[r];
                        e.setAttribute("data-bgset", u),
                        e.style.backgroundImage ? e.style.backgroundImage = "url(" + u + ")" : e.style.background = "url(" + u + ")",
                        n = !0
                    }
                e && n && e.className.includes("lazyload") && (e.classList.remove("lazyload"),
                e.classList.remove("lazyloading"),
                e.classList.remove("lazyloaded"),
                e.classList.add("lazyload"))
            }
        }, {
            key: "formatDefaultOption",
            value: function(e, t) {
                return void 0 === e ? t : e
            }
        }, {
            key: "formatWithDelimiters",
            value: function(e, t, a, i, n) {
                a = this.formatDefaultOption(a, 2),
                i = this.formatDefaultOption(i, ","),
                n = this.formatDefaultOption(n, ".");
                var r = (t = this.formatDefaultOption(t, !!this.getInstanceSettings().price_trailing_zeroes)) ? n + "00" : "";
                if (isNaN(e) || null == e)
                    return 0;
                var s = (e = (e * ("storefront" === S ? 1 : .01)).toFixed(a)).split(".");
                return s[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i) + (s[1] && "00" != s[1] ? n + s[1] : r)
            }
        }, {
            key: "insertHTMLAt",
            value: function(e, t, a) {
                if ("replace" != a) {
                    var i = this.uiElements.parseHTML(e)[0];
                    "before" == a ? t.parentNode.insertBefore(i, t) : "after" == a ? t.parentNode.insertBefore(i, t.nextSibling) : "top" == a ? t.insertBefore(i, t.firstChild) : t.appendChild(i)
                } else
                    t.innerHTML = e
            }
        }, {
            key: "updateGridElements",
            value: function(e) {
                var t = this.getInstanceConfig().grid_updates
                  , a = this.getGridUpdateParams(e);
                a.is_on_sale ? this.currentDocument.classList.add("swatch-variant-onsale") : this.currentDocument.classList.remove("swatch-variant-onsale"),
                "undefined" != typeof a.available && a.available ? this.currentDocument.classList.remove("swatch-variant-soldout") : this.currentDocument.classList.add("swatch-variant-soldout");
                for (var i = 0; i < t.length; i++) {
                    var n = t[i]
                      , r = n.template ? n.template.toString() : null;
                    if ("" != n.display_selector) {
                        var s = this.currentDocument.querySelector(n.display_selector);
                        if ("" != n.element_selector) {
                            var o = this.currentDocument.querySelector(n.element_selector);
                            o && this.removeElement(o)
                        }
                        s && (r = this.getModifiedTemplate(n.template, a),
                        this.insertHTMLAt(r, s, n.display_position))
                    }
                }
            }
        }, {
            key: "getMoneyWithFormat",
            value: function(e, t) {
                var a = RegExp("{{[^{]*amount[^}]*}}", "gi")
                  , i = RegExp("{+([^}]*)}+", "i").exec(e)
                  , n = "";
                if (i && (i = i[1].trim()),
                "amount" == i) {
                    var r = this.formatWithDelimiters(t, !0, 2, ",", ".");
                    n = e.replace(a, r)
                } else if ("amount_no_decimals" == i) {
                    r = this.formatWithDelimiters(t, !1, 0, ",", ".");
                    n = e.replace(a, r)
                } else if ("amount_with_comma_separator" == i) {
                    r = this.formatWithDelimiters(t, !0, 2, ".", ",");
                    n = e.replace(a, r)
                } else if ("amount_no_decimals_with_comma_separator" == i) {
                    r = this.formatWithDelimiters(t, !1, 0, ".", ",");
                    n = e.replace(a, r)
                } else if ("amount_with_apostrophe_separator" == i) {
                    r = this.formatWithDelimiters(t, !0, 2, "'", ".");
                    n = e.replace(a, r)
                } else if ("amount_with_space_separator" == i) {
                    r = this.formatWithDelimiters(t, !0, 2, " ", ",");
                    n = e.replace(a, r)
                } else if ("amount_no_decimals_with_space_separator" == i) {
                    r = this.formatWithDelimiters(t, !1, 0, " ", ",");
                    n = e.replace(a, r)
                } else {
                    r = this.formatWithDelimiters(t, !0, 2, ",", ".");
                    n = e.replace(a, r)
                }
                return n
            }
        }, {
            key: "getModifiedTemplate",
            value: function(e, t) {
                var a = RegExp("{+([^}]*)}+", "i");
                null == e && (e = "");
                for (var i = undefined, n = undefined, r = undefined; null !== (i = a.exec(e)); ) {
                    i.index === a.lastIndex && a.lastIndex++;
                    var s = i[1].trim()
                      , o = i[0]
                      , l = s.split(" ");
                    switch (s = l[0],
                    l[1],
                    s) {
                    case "sku":
                        e = e.replace(o, t.sku);
                        break;
                    case "price_code":
                        e = e.replace(o, t.price_code);
                        break;
                    case "product_id":
                        e = e.replace(o, t.product_id);
                        break;
                    case "variant_id":
                        e = e.replace(o, t.variant_id);
                        break;
                    case "product_handle":
                        e = e.replace(o, t.product_handle);
                        break;
                    case "display_on_sale":
                        e = e.replace(o, t.is_on_sale ? "" : 'style="display:none!important;"');
                        break;
                    case "hide_on_sale":
                        e = e.replace(o, t.is_on_sale ? 'style="display:none!important;"' : "");
                        break;
                    case "percentage_difference":
                        e = e.replace(o, t.percentage_difference);
                        break;
                    case "display_on_sold_out":
                        e = e.replace(o, t.available ? 'style="display:none;"' : "");
                        break;
                    case "display_on_available":
                        e = e.replace(o, t.available ? "" : 'style="display:none;"');
                        break;
                    case "price_with_format":
                        var c = this.getMoneyWithFormat(t.money_format, t.price_amount);
                        e = e.replace(o, c);
                        break;
                    case "compare_at_price_with_format":
                        var u = this.getMoneyWithFormat(t.money_format, t.compare_at_price);
                        e = e.replace(o, u);
                        break;
                    case "price_difference_with_format":
                        var d = this.getMoneyWithFormat(t.money_format, t.compare_at_price - t.price_amount);
                        e = e.replace(o, d);
                        break;
                    case "price_whole":
                        n = parseInt(t.price_amount),
                        e = e.replace(o, n);
                        break;
                    case "price_fraction":
                        var p = t.price_amount.toFixed(2).split(".")
                          , h = p[1] ? p[1] : "00";
                        e = e.replace(o, h);
                        break;
                    case "compare_at_price_whole":
                        r = parseInt(t.compare_at_price),
                        e = e.replace(o, r);
                        break;
                    case "compare_at_price_fraction":
                        var g = t.compare_at_price.toFixed(2).split(".")
                          , f = g[1] ? g[1] : "00";
                        e = e.replace(o, f);
                        break;
                    case "currency_symbol":
                        e = e.replace(o, y.currency_symbol);
                        break;
                    case "inventory_quantity":
                        e = e.replace(o, t.inventory_quantity);
                        break;
                    case "hide_above_inventory_threshold":
                        var v = 0
                          , m = y.inventory_config;
                        m && m.config && (v = m.config.threshold);
                        var _ = t.inventory_quantity && "continue" !== t.inventory_policy && t.inventory_quantity < v;
                        e = e.replace(o, _ ? "" : 'style="display:none;"');
                        break;
                    case "vendor":
                        e = e.replace(o, t.vendor);
                        break;
                    default:
                        e = e.replace(o, "")
                    }
                }
                return e
            }
        }, {
            key: "productChangeRestructure",
            value: function(e, t) {
                if (this.readyToInit() || this.hasOnlyDefaultVariant) {
                    for (var a = !1, i = e.querySelectorAll("[option-target]"), n = 0; n < i.length; n++) {
                        var r = !1
                          , s = i[n];
                        if (!a) {
                            var o = s.getAttribute("option-target");
                            s.hasAttribute("type-group") ? o == t ? (a = !0,
                            r = !0) : 0 : (0,
                            "bottom")
                        }
                        r || this.removeElement(s)
                    }
                    if (this.pInformation.selected_product_group = t,
                    !this.hasOnlyDefaultVariant) {
                        var l = this.uiElements.getSwatchRoot(this.productInfoTree.getOptions())
                          , c = this.uiElements.parseHTML(l)[0];
                        c = c.querySelector('[sa-options-position="default"]');
                        e.firstChild;
                        for (var u = e.querySelector('[sa-options-position="default"]'); c.children.length > 0; ) {
                            var d = c.children[0];
                            u.appendChild(d)
                        }
                    }
                    $("Generating restructured swatch UI..."),
                    this.generateUISwitch()(),
                    this.generateProductGroups()
                } else
                    setTimeout(this.productChangeRestructure.bind(this, e, t), 100)
            }
        }, {
            key: "productChangeOperations",
            value: function(e, t, a) {
                var i = t.getAttribute("option-target")
                  , n = t.parentNode.parentNode
                  , r = this.getFirstAvailableVariant(e)
                  , s = r ? r.id : null;
                if ("storefront" === S && s) {
                    var o = r.id.split("ProductVariant/");
                    s = o[1] ? o[1] : r.id
                }
                var l = "storefront" == S ? "undefined" != typeof e.availableForSale ? e.availableForSale : r.availableForSale : "undefined" != typeof e.available ? e.available : r.available;
                this.currentDocument.removeAttribute("swatch-current-variant"),
                null != this.pInformation.preselect_variant && ("storefront" == S && (r.id = s,
                this.pInformation.first_or_available_variant = r),
                this.pInformation.preselect_variant = r.id),
                this.currentDocument.setAttribute("swatch-generated", e.handle),
                this.productChangeRestructure(n, i);
                var c = "storefront" == S ? e.id.split("Product/")[1] : e.id;
                this.dispatchCustomEvent(this.currentDocument, "product:changed", {
                    productID: "" + c,
                    previousProductID: a
                });
                var u = this.getInstanceConfig().data_selectors
                  , d = null
                  , p = null
                  , h = null;
                if ("storefront" == S ? (h = {
                    id: c,
                    handle: e.handle,
                    title: e.title,
                    url: e.onlineStoreUrl ? e.onlineStoreUrl : this.multiLingualInfo.current_url + "/products/" + e.handle,
                    price: r.price,
                    compareAtPrice: r.compareAtPrice ? r.compareAtPrice : null,
                    variant_id: s,
                    sku: r.sku,
                    availableForSale: l,
                    quantityAvailable: r.quantityAvailable,
                    featured_image: {
                        src: null,
                        secondary_src: null
                    }
                },
                e.featuredImage ? (h.featured_image.src = e.featuredImage.url,
                h.featured_image.secondary_src = e.featuredImage.url) : e.images.nodes && e.images.nodes.length >= 1 && (h.featured_image.src = e.images.nodes[0].url,
                h.featured_image.secondary_src = e.images.nodes[0].url),
                e.images.nodes && e.images.nodes.length >= 2 && (h.featured_image.secondary_src = e.images.nodes[1].url)) : (h = {
                    id: e.id,
                    handle: e.handle,
                    title: e.title,
                    url: e.url,
                    price: r.price,
                    compare_at_price: r.compare_at_price,
                    variant_id: r.id,
                    sku: r.sku,
                    available: l,
                    inventory_policy: r.inventory_policy,
                    inventory_quantity: r.inventory_quantity,
                    featured_image: {
                        src: null,
                        secondary_src: null
                    }
                },
                e.featured_image ? (h.featured_image.src = e.featured_image,
                h.featured_image.secondary_src = e.featured_image) : e.images && e.images.length >= 1 && (h.featured_image.src = e.images[0],
                h.featured_image.secondary_src = e.images[0]),
                e.images && e.images.length >= 2 && (h.featured_image.secondary_src = e.images[1])),
                "" != u.title && (p = this.currentDocument.querySelectorAll(u.title),
                Object.entries(p).forEach(function(e) {
                    var t = _slicedToArray(e, 2)
                      , a = t[0]
                      , i = t[1];
                    "length" != a && (i.innerHTML = h.title)
                })),
                this.updateGridElements(h),
                this.updateGridAttributes(h),
                this.updateVariantImages(h, u),
                "" != u.url && (p = this.currentDocument.querySelectorAll(u.url),
                Object.entries(p).forEach(function(e) {
                    var t = _slicedToArray(e, 2)
                      , a = t[0]
                      , i = t[1];
                    "length" != a && (i.hasAttribute("href") && i.setAttribute("href", h.url),
                    i.hasAttribute("data-href") && i.setAttribute("data-href", h.url))
                })),
                this.updateAttributes({
                    handle: h.handle,
                    url: h.url,
                    product_id: h.id,
                    variant_id: h.variant_id
                }, u),
                u.form_input && "" != u.form_input && (d = this.currentDocument.querySelector(u.form_input))) {
                    if ("SELECT" == d.tagName && (d.value = h.variant_id,
                    d.value != h.variant_id)) {
                        var g = document.createElement("option");
                        g.value = h.variant_id,
                        g.text = h.title,
                        d.add(g)
                    }
                    d.value = h.variant_id,
                    this.dispatchEvent("change", d)
                }
            }
        }, {
            key: "getSwatchMinifiedCount",
            value: function(e) {
                var t = this.clientSpecs.getSwatchPresentation("collections");
                if ("general" == e && t.minified || "groups" == e && t.minified_products) {
                    var a = t.minified_display_count
                      , i = Math.ceil(1920 / a.length)
                      , n = Math.floor(window.screen.width / i);
                    return n >= a.length && (n = a.length - 1),
                    a[n]
                }
                return null
            }
        }, {
            key: "updateVariantImages",
            value: function(e) {
                var t = arguments.length <= 1 || arguments[1] === undefined ? null : arguments[1]
                  , a = t || this.getInstanceConfig().data_selectors
                  , i = null;
                "" != a.featured_image && (i = this.currentDocument.querySelector(a.featured_image),
                this.updateVariantImage(i, e, !0)),
                "" != a.featured_image && "" != a.secondary_image && (i = this.currentDocument.querySelector(a.secondary_image),
                this.updateVariantImage(i, e, !1))
            }
        }, {
            key: "updateAttributes",
            value: function(e, t) {
                var a = this;
                t.attributes.length > 0 && function() {
                    var i = a.pInformation.attrs_to_update_selectors;
                    if (void 0 === i) {
                        i = "[data-product-id]";
                        for (var n = 0; n < t.attributes.length; n++) {
                            i += ", [" + t.attributes[n].split(":")[0] + "]"
                        }
                        a.pInformation.attrs_to_update_selectors = i
                    }
                    var r = a.currentDocument.querySelectorAll(i)
                      , s = Object.entries(r);
                    s.push([s.length + 1, a.currentDocument]);
                    var o = !!window.$ && !!window.$.fn && !!window.$.fn.data;
                    s.forEach(function(a) {
                        var i = _slicedToArray(a, 2)
                          , n = i[0]
                          , r = i[1];
                        if ("length" != n)
                            for (var s = 0; s < t.attributes.length; s++) {
                                var l = t.attributes[s].split(":")
                                  , c = l[0]
                                  , u = l[1];
                                if (r.hasAttribute(c)) {
                                    var d = "";
                                    switch (u) {
                                    case "pid":
                                        d = e.product_id;
                                        break;
                                    case "vid":
                                        d = e.variant_id;
                                        break;
                                    case "handle":
                                        d = e.handle,
                                        r.getAttribute(c).includes("/products/") && (d = e.url)
                                    }
                                    d && (r.setAttribute(c, d),
                                    o && window.$(r).data(c.replace("data-", ""), d))
                                }
                            }
                    })
                }()
            }
        }, {
            key: "getGridUpdateParams",
            value: function(e) {
                var t = this.productInfoTree.getProductInfo()
                  , a = undefined;
                a = "storefront" == S ? {
                    available: e.availableForSale,
                    sku: e.sku,
                    price_amount: parseFloat(e.price.amount),
                    compare_at_price: e.compareAtPrice ? parseFloat(e.compareAtPrice.amount) : null,
                    product_id: t.id,
                    vendor: t.vendor ? t.vendor : "",
                    money_format: "{{amount}}",
                    inventory_quantity: e.quantityAvailable,
                    inventory_policy: e.inventory_policy,
                    is_on_sale: !1,
                    variant_id: e.variant_id,
                    product_handle: t.handle
                } : {
                    available: e.available,
                    sku: e.sku,
                    price_amount: e.price,
                    compare_at_price: e.compare_at_price,
                    product_id: t.id,
                    vendor: t.vendor ? t.vendor : "",
                    money_format: "{{amount}}",
                    inventory_quantity: e.inventory_quantity,
                    inventory_policy: e.inventory_policy,
                    is_on_sale: !1,
                    variant_id: e.variant_id,
                    product_handle: t.handle
                },
                Shopify && Shopify.currency && (a.price_code = Shopify.currency.active);
                var i = this.getMultiLingualInfo();
                i.money_format && (a.money_format = i.money_format.trim());
                var n = 0
                  , r = a.price_amount
                  , s = a.compare_at_price
                  , o = null != s && s > r;
                return a.is_on_sale = o,
                o && (n = r / s * 100,
                n = Math.round(100 - n),
                a.percentage_difference = n),
                a
            }
        }, {
            key: "updateGridAttributes",
            value: function(e) {
                var t = this
                  , a = this.getInstanceConfig().attribute_updates
                  , i = this.getGridUpdateParams(e)
                  , n = !!window.$ && !!window.$.fn && !!window.$.fn.data;
                a && a.forEach(function(e) {
                    var a = e.selector
                      , r = e.attribute
                      , s = e.template;
                    if ("" != a || "" != r) {
                        var o = "[" + r + "]"
                          , l = a ? t.currentDocument.querySelectorAll("" + a + o) : t.currentDocument.querySelectorAll(o);
                        if (l && l.length > 0)
                            Array.from(l).forEach(function(e) {
                                var a = t.getModifiedTemplate(s, i);
                                e.setAttribute(r, a),
                                n && window.$(e).data(r.replace("data-", ""), a)
                            })
                    }
                })
            }
        }, {
            key: "generateUIForCollection",
            value: function(e) {
                var t = this;
                if (this.clientSpecs.getEnableStatusForProductGridType()) {
                    var a = null
                      , i = null
                      , n = null
                      , r = {}
                      , s = {}
                      , o = null
                      , l = undefined;
                    if (e) {
                        if ("A" != (l = e.target).tagName && (e.preventDefault(),
                        e.stopPropagation()),
                        "LI" == l.tagName && l.hasAttribute("orig-value") && l.children && (l = l.children[0]),
                        "keyup" == e.type && 13 !== e.keyCode)
                            return;
                        for (; l.hasAttribute("swatch-inside") || "FONT" == l.tagName || "SVG" == l.tagName || "I" == l.tagName; )
                            l = l.parentNode;
                        if (this.isClickEvent(e.type) && l.hasAttribute("data-navigation"))
                            return void this.scrollSwatchSlider(l, !1);
                        var c = "mouseover" == e.type
                          , u = "mouseout" == e.type
                          , d = c || u
                          , p = d;
                        if (!l.hasAttribute("swatch-option") || u) {
                            if (this.pInformation.image_replaced_by_hover) {
                                var h = this.getCurrentOptionForCollection(!0)
                                  , g = this.productInfoTree.getVariantInfoFromOptions(h);
                                if ("storefront" == S && g) {
                                    var f = g.id.split("ProductVariant/")[1] || g.id;
                                    g.id = f
                                }
                                if (!g)
                                    if ((w = l.getAttribute("swatch-url")) && l.classList.contains("swatch-selected"))
                                        (C = this.getFeaturedProductImageFromDOM(l, w, "featured")) && (g = {
                                            featured_image: {
                                                src: C,
                                                secondary_src: C
                                            }
                                        }),
                                        (x = this.getFeaturedProductImageFromDOM(l, w, "secondary")) && (g.featured_image.secondary_src = x);
                                    else if (w) {
                                        var v = l.closest("ul.swatch-view");
                                        if (v) {
                                            var m = v.querySelector("li.swatch-view-item .swatch-selected");
                                            if (m) {
                                                var _ = m.getAttribute("swatch-url");
                                                if (_)
                                                    (C = this.getFeaturedProductImageFromDOM(l, _, "featured")) && (g = {
                                                        featured_image: {
                                                            src: C,
                                                            secondary_src: C
                                                        }
                                                    }),
                                                    (x = this.getFeaturedProductImageFromDOM(l, _, "secondary")) && (g.featured_image.secondary_src = x)
                                            }
                                        }
                                    }
                                this.updateVariantImages(g || {}),
                                this.pInformation.image_replaced_by_hover = !1
                            }
                            return
                        }
                        if ("SELECT" == l.tagName && "change" != e.type)
                            return;
                        if (c && p) {
                            var y = null
                              , w = l.getAttribute("swatch-url");
                            if (n = l.getAttribute("swatch-option"),
                            i = l.getAttribute("orig-value"),
                            w) {
                                var k = l.closest("[data-group-index]").getAttribute("data-group-index")
                                  , A = this.getProductsGroups([k])[0]
                                  , I = w.split("/products/");
                                I = I[I.length - 1];
                                for (var T = 0; T < A.option_values.length; T++) {
                                    if (I == A.option_values[T].handle) {
                                        var C, x;
                                        (C = this.getFeaturedProductImageFromDOM(l, w, "featured")) && (y = {
                                            featured_image: {
                                                src: C,
                                                secondary_src: C
                                            }
                                        }),
                                        (x = this.getFeaturedProductImageFromDOM(l, w, "secondary")) && (y.featured_image.secondary_src = x);
                                        break
                                    }
                                }
                            } else {
                                if ((y = this.getCurrentOptionForCollection())[n] = i,
                                y = this.productInfoTree.getVariantInfoFromOptions(y),
                                "storefront" == S && y) {
                                    f = y.id.split("ProductVariant/")[1] ? y.id.split("ProductVariant/")[1] : y.id;
                                    y.id = f
                                }
                                var E = this.currentDocument.querySelector("a[href]") ? this.currentDocument.querySelector("a[href]").href : null;
                                this.dispatchCustomEvent(this.currentDocument, "swatch:hover", {
                                    variantID: "" + (y ? y.id : null),
                                    productHandle: "" + this.productInfoTree.getProductInfo().handle,
                                    url: E
                                })
                            }
                            if (!y)
                                return;
                            return this.updateVariantImages(y),
                            void (this.pInformation.image_replaced_by_hover = !0)
                        }
                        if (d)
                            return
                    }
                    if (e && l.hasAttribute("swatch-url")) {
                        var D = function() {
                            if (l.hasAttribute("current-product"))
                                return {
                                    v: undefined
                                };
                            if ("SELECT" != l.tagName) {
                                var e = l.getAttribute("swatch-option")
                                  , a = l.getAttribute("orig-value")
                                  , i = l.closest("[option-target]").querySelector("span.swatch-variant-name");
                                i && "none" != a && (i.innerHTML = ' <span class="swatch-split-symbol">' + t.labelSplitSymbol + "</span> " + a),
                                t.uiElements.selectSwatch(e, l, a)
                            }
                            t.resetMultiLingualData();
                            var n = l.closest("[option-target]")
                              , r = t.productInfoTree.getProductInfo().id
                              , s = "SELECT" == l.tagName ? l.value : l.getAttribute("swatch-url");
                            if (t.selectionAllowed = !1,
                            t.hasOnlyDefaultVariant = !1,
                            t.pInformation.product_switched = !0,
                            t.productInfoTree = new G,
                            "storefront" == S) {
                                var o = s.split("/products/")[1]
                                  , c = window.Shopify.locale;
                                t.executeFetch({
                                    handle: o,
                                    locale: c,
                                    path_name: null,
                                    allow_processing: !0,
                                    callback: function(e) {
                                        t.productChangeOperations(e, n, r)
                                    },
                                    translation_request: !1
                                })
                            } else
                                t.executeFetch({
                                    url: s + ".js",
                                    path_name: null,
                                    allow_processing: !0,
                                    callback: function(e) {
                                        t.productChangeOperations(e, n, r)
                                    },
                                    translation_request: !1
                                });
                            return {
                                v: undefined
                            }
                        }();
                        if ("object" == typeof D)
                            return D.v
                    }
                    if (!(e && "SELECT" == l.tagName && l.options && l.options.length > 1 && this.isClickEvent(e.type))) {
                        if (e && "select" == l.getAttribute("type")) {
                            var O = l
                              , L = l.parentNode.querySelector("ul.swatch-drop-down-list")
                              , P = "true" == O.getAttribute("aria-expanded");
                            return O.setAttribute("aria-expanded", !P),
                            void L.classList.toggle("swatch-hide")
                        }
                        if (e && "select_value" == l.getAttribute("type"))
                            (O = l.closest("div.swatch-drop-down-inner").querySelector('div[type="select"]')).style.minWidth && "0px" != O.style.minWidth || this.setSelectMinWidth(O),
                            O.innerHTML = l.innerHTML,
                            O.setAttribute("aria-label", l.innerText),
                            O.setAttribute("aria-expanded", !1),
                            l.parentNode.classList.add("swatch-hide");
                        if (e && l.hasAttribute("swatch-option")) {
                            if (n = l.getAttribute("swatch-option"),
                            a = n,
                            this.uiElements.isDropDown(l.tagName))
                                l.hasAttribute("data-selected") && l.remove(0),
                                i = l.value;
                            else {
                                i = l.getAttribute("orig-value");
                                var N = l.closest("[option-target]").querySelector("span.swatch-variant-name");
                                N && "null" != i && (N.innerHTML = ' <span class="swatch-split-symbol">' + this.labelSplitSymbol + "</span> " + i)
                            }
                            if (e && this.pInformation.preselect_variant)
                                "option" + this.productInfoTree.getOptions().length == n && (this.pInformation.preselect_variant = 0),
                                this.selectionAllowed = !0;
                            if (this.selectionAllowed || this.isEventTrusted(e, !0)) {
                                if (this.selectionAllowed = !0,
                                this.uiElements.selectSwatch(n, l, i),
                                r = this.getCurrentOptionForCollection(),
                                o = this.productInfoTree.getVariantInfoFromOptions(r),
                                "storefront" == S && o) {
                                    f = o.id.split("ProductVariant/")[1] ? o.id.split("ProductVariant/")[1] : o.id;
                                    o.id = f
                                }
                                var M = !0
                                  , q = this.currentDocument.getAttribute("swatch-current-variant") || "0";
                                if (o && (this.currentDocument.setAttribute("swatch-current-variant", o.id),
                                this.dispatchCustomEvent(this.currentDocument, "variant:changed", {
                                    productID: "" + this.productInfoTree.getProductInfo().id,
                                    variant: "" + o.id,
                                    previousVariant: q,
                                    variantInformation: JSON.stringify(o)
                                })),
                                (o && q == o.id || this.currentDocument.hasAttribute("sa-manual-update")) && (M = !1),
                                o && M) {
                                    var F = this.getInstanceConfig().data_selectors
                                      , V = null
                                      , R = null;
                                    this.updateVariantImages(o, F),
                                    "" != F.url && function() {
                                        V = t.currentDocument.querySelectorAll(F.url);
                                        var e = /(?:variant=)[0-9]*/gm;
                                        Object.entries(V).forEach(function(t) {
                                            var a = _slicedToArray(t, 2)
                                              , i = a[0]
                                              , n = a[1];
                                            if ("length" != i && n && o.id) {
                                                var r = n.hasAttribute("href") ? n.getAttribute("href") : ""
                                                  , s = e.exec(r)
                                                  , l = "variant=" + o.id;
                                                s || (s = e.exec(r.toString())),
                                                s ? r = r.replace(s[0], l) : r.includes("?") ? r += "&" + l : r += "?" + l,
                                                n.hasAttribute("href") && n.setAttribute("href", r),
                                                n.hasAttribute("data-href") && n.setAttribute("data-href", r)
                                            }
                                        })
                                    }();
                                    var H = this.productInfoTree.getProductInfo().handle;
                                    if (this.updateAttributes({
                                        handle: H,
                                        url: "/products/" + H + "?variant=" + o.id,
                                        product_id: null,
                                        variant_id: o.id
                                    }, F),
                                    this.updateGridElements(_extends({
                                        variant_id: o.id
                                    }, o)),
                                    this.updateGridAttributes(_extends({
                                        variant_id: o.id
                                    }, o)),
                                    F.form_input && "" != F.form_input && (R = this.currentDocument.querySelector(F.form_input))) {
                                        if ("SELECT" == R.tagName && (R.value = o.id,
                                        R.value != o.id)) {
                                            var z = document.createElement("option");
                                            z.value = o.id,
                                            z.text = o.title,
                                            R.add(z)
                                        }
                                        R.value = o.id,
                                        this.dispatchEvent("change", R)
                                    }
                                }
                            }
                        }
                        if (this.readyToInit()) {
                            this.uiElements.getIsSwatchRootDisplayed() || this.uiElements.renderSwatchRoot(this.uiElements.getSwatchRoot(this.productInfoTree.getOptions()), this.getCorrectSwatchRoot()),
                            r = this.getCurrentOptionForCollection();
                            var B = undefined;
                            B = b ? b.trim() : this.multiLingualInfo.money_format.trim(),
                            s = this.productInfoTree.getNodeByOptions(r, B, this.getMoneyWithFormat.bind(this)),
                            Object.entries(s).forEach(function(e) {
                                var i = _slicedToArray(e, 2)
                                  , n = i[0]
                                  , s = i[1];
                                if (null == a) {
                                    var o = t.uiElements.getViewByType(s.view_type_preset).getView(n, s)
                                      , l = t.uiElements.renderNormal(n, o, t.getCorrectSwatchRoot());
                                    1 == s.data.length && "null" == s.data[0].value && l.length > 0 && l[0].closest && (l[0].closest("div.swatch-single").style.display = "none"),
                                    $("Generated UI for - " + n);
                                    var c = r[n]
                                      , u = !1
                                      , d = t.getSwatchMinifiedCount("general")
                                      , p = s.view_type_preset;
                                    Object.entries(l).forEach(function(e) {
                                        var i = _slicedToArray(e, 2)
                                          , n = i[0]
                                          , r = i[1];
                                        if ("length" != n) {
                                            var o = n == l.length - 1;
                                            if (null != d && ("swatch" == p.assoc_view_type || "button" == p.assoc_view_type)) {
                                                var h = null;
                                                if (n >= d) {
                                                    var g = r.closest("li.swatch-view-item");
                                                    g && (h = g)
                                                }
                                                if (o) {
                                                    var f = l.length - d;
                                                    if (f > 0) {
                                                        var v = r.closest("[option-name]").getAttribute("option-name")
                                                          , m = t.uiElements.getMinifiedHTML(v, f, t.productInfoTree.getProductInfo());
                                                        r.closest("ul.swatch-view").appendChild(m)
                                                    }
                                                    if ((S = r.closest(".swatch-navigable, variant-swatch-king")) && "VARIANT-SWATCH-KING" != S.tagName) {
                                                        S.querySelector(".swatch-navigation");
                                                        var _ = r.closest(".swatch-navigable");
                                                        t.resSliderSize(_, p.params, p.assoc_view_type)
                                                    }
                                                }
                                                if (h)
                                                    return void t.removeElement(h)
                                            }
                                            var y = null;
                                            if (setTimeout(function() {
                                                var e = "swatch-allow-animation";
                                                r.classList.add(e)
                                            }, 128),
                                            t.uiElements.isDropDown(r.tagName) || "true" == r.getAttribute("custom-select")) {
                                                t.getLabelWidth(r, p.params.padding_left),
                                                y = r.value;
                                                for (var w = r.querySelectorAll("li"), b = 0; b < w.length; b++)
                                                    w[b].getAttribute("value") == c && (y = c,
                                                    r.value = c)
                                            } else
                                                y = r.getAttribute("orig-value");
                                            if (y == c && (u = !0,
                                            t.uiElements.isDropDown(r.tagName) ? t.dispatchEvent("change", r) : t.dispatchEvent("virtual_click", r)),
                                            o) {
                                                var S;
                                                if ((S = r.closest(".swatch-navigable, variant-swatch-king")) && "VARIANT-SWATCH-KING" != S.tagName)
                                                    S.querySelector(".swatch-navigation"),
                                                    _ = r.closest(".swatch-navigable"),
                                                    t.resSliderSize(_, p.params, p.assoc_view_type);
                                                if (!t.selectionAllowed && "SELECT" == r.tagName) {
                                                    var k = t.getTranslation(t.doNotSelectAnOption.text);
                                                    k = k.replace(/{{\s*option_name\s*}}/gm, s.name);
                                                    var A = document.createElement("option");
                                                    A.value = r.value,
                                                    A.innerHTML = k,
                                                    r.insertBefore(A, r.options[0]),
                                                    r.selectedIndex = 0,
                                                    r.setAttribute("data-selected", !1)
                                                }
                                                a = "None",
                                                u || (t.uiElements.isDropDown(l[0].tagName) ? t.dispatchEvent("change", l[0]) : t.dispatchEvent("virtual_click", l[0]))
                                            }
                                        }
                                    })
                                } else
                                    a == n && (a = null)
                            })
                        } else
                            this.hasOnlyDefaultVariant || setTimeout(this.generateUIForCollection.bind(this, e), 100)
                    }
                }
            }
        }, {
            key: "getFeaturedProductImageFromDOM",
            value: function(e, t) {
                var a = arguments.length <= 2 || arguments[2] === undefined ? "featured" : arguments[2]
                  , i = e.closest("[swatch-generated]").querySelector(".vsk-product-images-data");
                if (!i)
                    return null;
                var n = i.querySelector('[data-product-handle="' + t + '"]');
                return n ? n.getAttribute("data-" + a + "-image") : null
            }
        }, {
            key: "getCurrentOptionForCollection",
            value: function() {
                var e = !(arguments.length <= 0 || arguments[0] === undefined) && arguments[0];
                if (this.pInformation.preselect_variant) {
                    for (var t = this.pInformation.preselect_variant, a = this.productInfoTree.getVariants()[t], i = {}, n = 0; n < a.options.length; n++) {
                        i[l = "option" + (n + 1)] = a.options[n]
                    }
                    return i
                }
                var r = this.getCorrectSwatchRoot().querySelectorAll(".swatches .swatch-selector")
                  , s = this.productInfoTree.getOptions()
                  , o = {};
                for (n = 0; n < r.length; n++) {
                    var l = r[n].getAttribute("swatch-option");
                    r[n].classList.contains("swatch-selected") && (o[l] = r[n].getAttribute("orig-value"),
                    "SELECT" == r[n].tagName && (o[l] = r[n].value))
                }
                var c = {};
                for (n = 0; n < s.length; n++) {
                    if (!o[l = "option" + (n + 1)] && !e) {
                        var u = this.pInformation.first_or_available_variant;
                        o[l] = u.options[n],
                        "object" == typeof o[l] && o[l].title && (o[l] = o[l].title)
                    }
                    c[l] = o[l]
                }
                return c
            }
        }, {
            key: "getFirstAvailableVariant",
            value: function(e) {
                undefined;
                return "storefront" == S ? "undefined" != typeof e.availableForSale && e.availableForSale ? e.variants.nodes.find(function(e) {
                    return !0 === e.availableForSale
                }) : e.variants.nodes[0] : "undefined" != typeof e.available && e.available ? e.variants.find(function(e) {
                    return !0 === e.available
                }) : e.variants[0]
            }
        }, {
            key: "resetMultiLingualData",
            value: function() {
                this.multiLingualInfo = null,
                this.untranslatedData = null,
                this.untranslatedFetchStatus = "none"
            }
        }, {
            key: "getMultiLingualInfo",
            value: function() {
                if (null == this.multiLingualInfo) {
                    var e = g;
                    e && "" != e && (e = e.replace(/\/$/, "")),
                    this.multiLingualInfo = {
                        default_language: this.clientSpecs.getDefaultLanguage(),
                        money_format: b
                    },
                    this.multiLingualInfo.current_url = e,
                    window.Shopify && window.Shopify.locale && (this.multiLingualInfo.current_language = window.Shopify.locale);
                    window.location.pathname.split("/")[1];
                    this.multiLingualInfo.translation_status = this.multiLingualInfo.current_language != this.multiLingualInfo.default_language,
                    $(["Found language information in DOM", this.multiLingualInfo])
                }
                return this.multiLingualInfo
            }
        }, {
            key: "fetchUntranslatedOptions",
            value: function(e) {
                var t = this;
                if (this.getMultiLingualInfo().translation_status && e) {
                    this.untranslatedFetchStatus = "pending";
                    var a = o(this.multiLingualInfo.default_language)
                      , i = window.Shopify.country
                      , n = this.getDataFromSessionStorage(this.getSessionStorageKey(e, !1, !0, !0));
                    if (n)
                        return null !== n.id && (this.untranslatedData = {
                            handle: n.handle,
                            options: n.options,
                            variants: n.variants.nodes
                        }),
                        void (this.untranslatedFetchStatus = "completed");
                    var r = "\n            query productDetails($variantsCursor: String) @inContext(country: " + i.toUpperCase() + ", language: " + a + ') {\n                product(id: "gid://shopify/Product/' + e + '") {\n                    id\n                    handle\n                    title\n                    vendor\n                    availableForSale\n                    onlineStoreUrl\n                    tags\n                    publishedAt\n                    priceRange{\n                        maxVariantPrice{\n                            amount\n                        }\n                        minVariantPrice{\n                            amount\n                        }\n                    }\n                    featuredImage{\n                        id\n                        url\n                    }\n                    options{\n                        id\n                        name\n                        values\n                        optionValues{\n                            id\n                            name\n                        }\n                    }\n                    images(first: 250){\n                        nodes{\n                            id\n                            url\n                            altText\n                        }\n                    }\n                    compareAtPriceRange {\n                        maxVariantPrice {\n                            amount\n                        }\n                         minVariantPrice {\n                            amount\n                        }\n                    }\n                    ... on Product @defer {\n                        variants(first: 250, after: $variantsCursor) {\n                            nodes{\n                                id\n                                availableForSale\n                                quantityAvailable\n                                compareAtPrice{\n                                    currencyCode\n                                    amount\n                                }\n                                selectedOptions{\n                                    name\n                                    value\n                                }\n                                currentlyNotInStock\n                                featured_image: image{\n                                    id\n                                    src: url\n                                    altText\n                                }\n                                price{\n                                    currencyCode\n                                    amount\n                                }\n                                title\n                                sku\n                                compareAtPrice {\n                                    amount\n                                }\n                            }\n                            pageInfo {\n                                hasNextPage\n                                endCursor\n                            }\n                        }\n                    }\n                }\n            }\n        ';
                    this.executeStorefrontFetch({
                        query: r,
                        isMultiple: !1,
                        callback: function(a, i) {
                            var n = a.product
                              , r = i ? i.country : null
                              , s = i ? i.language : null;
                            t.setDataToSessionStorage(t.getSessionStorageKey(e, !1, !0, !0, r, s), n),
                            t.setDataToSessionStorage(t.getSessionStorageKey(n.handle, !1, !0, !0, r, s), n),
                            t.untranslatedData = {
                                handle: n.handle,
                                options: n.options,
                                variants: n.variants.nodes
                            },
                            t.untranslatedFetchStatus = "completed"
                        }
                    })
                }
            }
        }, {
            key: "getUntranslatedFetchStatus",
            value: function() {
                return this.untranslatedFetchStatus
            }
        }, {
            key: "getUntranslatedData",
            value: function() {
                return this.untranslatedData
            }
        }, {
            key: "getTranslation",
            value: function(e) {
                var t = this.getMultiLingualInfo();
                if (t.translation_status) {
                    var a = this.clientSpecs.getLocalizedStrings()[e];
                    if (a && (a = a[t.current_language]) && a.trim().length > 0)
                        return a
                }
                return e
            }
        }, {
            key: "getHandleFromURL",
            value: function(e) {
                var t = e.split("/");
                return (t = (t = t[t.length - 1]).split(RegExp("\\?|\\#|\\.js", "gi")))[0]
            }
        }, {
            key: "getSessionStorageKey",
            value: function(e, t, a) {
                var i = !(arguments.length <= 3 || arguments[3] === undefined) && arguments[3]
                  , n = arguments.length <= 4 || arguments[4] === undefined ? null : arguments[4]
                  , r = arguments.length <= 5 || arguments[5] === undefined ? null : arguments[5]
                  , s = arguments.length <= 6 || arguments[6] === undefined ? null : arguments[6];
                if (!window.sessionStorage)
                    return null;
                var l = t ? this.getHandleFromURL(e) : e
                  , c = this.getMultiLingualInfo()
                  , u = n || (window.Shopify && window.Shopify.country ? window.Shopify.country : "NULL")
                  , d = r || o(a ? c.default_language : c.current_language).toUpperCase();
                return "storefront" === S ? s ? "starapps_storefront_" + s + "_" + l + "_" + d + "_" + u : "starapps_storefront_detailed_" + l + "_" + d + "_" + u : i ? s ? "starapps_storefront_" + s + "_" + l + "_" + d + "_" + u : "starapps_storefront_detailed_" + l + "_" + d + "_" + u : "starapps_" + l + "_" + d + "_" + u
            }
        }, {
            key: "getDataFromSessionStorage",
            value: function(e) {
                if (window.sessionStorage && "string" == typeof e) {
                    var t = sessionStorage.getItem(e);
                    if (t)
                        return JSON.parse(t)
                }
                return null
            }
        }, {
            key: "setDataToSessionStorage",
            value: function(e, t) {
                if (window.sessionStorage && "string" == typeof e && "object" == typeof t) {
                    var a = function() {
                        var a = (new Date).getTime();
                        null != t ? t.created_at = a : t = {
                            id: null,
                            created_at: a
                        };
                        var i = JSON.stringify(t);
                        return setTimeout(function() {
                            try {
                                sessionStorage.setItem(e, i)
                            } catch (t) {}
                        }, 0),
                        {
                            v: !0
                        }
                    }();
                    if ("object" == typeof a)
                        return a.v
                }
                return !1
            }
        }, {
            key: "removeDataToSessionStorage",
            value: function(e) {
                return !(!window.sessionStorage || "string" != typeof e) && (sessionStorage.removeItem(e),
                !0)
            }
        }, {
            key: "handleMultipartResponse",
            value: async function(e) {
                var t = {
                    initial: null,
                    deferred: null
                }
                  , a = e.body ? e.body.getReader() : e._bodyInit && e._bodyInit.stream ? e._bodyInit.stream().getReader() : null;
                if (!a)
                    return $(["Product data is not fetched... ", e]),
                    t;
                for (var i = new TextDecoder, n = ""; ; ) {
                    var r = await a.read()
                      , s = r.done
                      , o = r.value;
                    if (s)
                        break;
                    if ((n += i.decode(o, {
                        stream: !0
                    })).includes("--graphql")) {
                        var l = n.split("--graphql");
                        n = l.pop() || "";
                        var c = !0
                          , u = !1
                          , d = undefined;
                        try {
                            for (var p, h = l[Symbol.iterator](); !(c = (p = h.next()).done); c = !0) {
                                var g = p.value;
                                if (g.trim()) {
                                    var f = g.match(/{.*}/s);
                                    if (f)
                                        try {
                                            var v = JSON.parse(f[0]);
                                            t.initial ? t.deferred = v : t.initial = v
                                        } catch (m) {
                                            console.error("Error parsing chunk:", m)
                                        }
                                }
                            }
                        } catch (_) {
                            u = !0,
                            d = _
                        } finally {
                            try {
                                !c && h["return"] && h["return"]()
                            } finally {
                                if (u)
                                    throw d
                            }
                        }
                    }
                }
                return t
            }
        }, {
            key: "fetchProductData",
            value: async function(e) {
                for (var t = this, a = [], i = 0, n = !0, r = null, s = null, o = null, l = g + "api/" + c + "/graphql.json"; n && i < j; )
                    try {
                        await async function() {
                            var c = {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json",
                                    "X-Shopify-Storefront-Access-Token": t.clientSpecs.storefront_access_token,
                                    Accept: "multipart/mixed; deferSpec=20220824"
                                },
                                body: JSON.stringify({
                                    query: e,
                                    variables: {
                                        variantsCursor: r
                                    }
                                }),
                                credentials: "same-origin"
                            }
                              , u = new AbortController
                              , d = setTimeout(function() {
                                return u.abort()
                            }, 6500);
                            c.signal = u.signal;
                            var p = await fetch(l, c);
                            if (clearTimeout(d),
                            !p.ok)
                                throw new Error("HTTP error! Status: " + p.status);
                            var h = p.headers.get("Content-Type") || ""
                              , g = undefined;
                            if (h.includes("multipart/mixed"))
                                g = await t.handleMultipartResponse(p);
                            else {
                                var f = await p.json();
                                o || (o = f.extensions.context || null),
                                g = {
                                    initial: f,
                                    deferred: null
                                }
                            }
                            !s && g.initial.data.product && (s = _extends({}, g.initial.data.product));
                            var v = undefined
                              , m = g.deferred;
                            if (v = m && m.incremental && m.incremental.length > 0 ? m.incremental[m.incremental.length - 1].data.variants : null) {
                                var _ = v.nodes || [];
                                a = [].concat(_toConsumableArray(a), _toConsumableArray(_)),
                                n = v.pageInfo.hasNextPage || !1,
                                r = v.pageInfo.endCursor || null,
                                i = 0
                            } else
                                console.log("deferData not found ::: "),
                                n = !1
                        }()
                    } catch (u) {
                        i++,
                        console.warn("Attempt " + i + " failed: " + u.message),
                        "function" == typeof window.reportError && window.reportError(u),
                        i >= j ? n = !1 : await new Promise(function(e) {
                            return setTimeout(e, 1e3 * Math.pow(2, i - 1))
                        }
                        )
                    }
                return {
                    productData: s,
                    allVariants: a,
                    context: o
                }
            }
        }, {
            key: "disableAdd2CartButton",
            value: function(e, t) {
                var a = this.clientSpecs.getSelectors()
                  , i = this.currentDocument.querySelectorAll(a.add_to_cart_selector);
                Object.entries(i).forEach(function(i) {
                    var n = _slicedToArray(i, 2)
                      , r = n[0]
                      , s = n[1];
                    if ("length" != r)
                        if (s.setAttribute("disabled", "disabled"),
                        "" != t.trim() && (s.className = t),
                        "INPUT" == s.tagName)
                            s.hasAttribute("original-text") || s.setAttribute("original-text", s.value),
                            s.value = e;
                        else if ("BUTTON" == s.tagName) {
                            var o = s;
                            s.children.length > 0 && (o = s.querySelector(a.add_to_cart_text_selector)),
                            o && (s.hasAttribute("original-text") || s.setAttribute("original-text", o.innerHTML),
                            o.innerHTML = e)
                        }
                })
            }
        }, {
            key: "restoreAddToCart",
            value: function() {
                var e = this
                  , t = this.clientSpecs.getSelectors()
                  , a = this.currentDocument.querySelectorAll(t.add_to_cart_selector);
                Object.entries(a).forEach(function(a) {
                    var i = _slicedToArray(a, 2)
                      , n = i[0]
                      , r = i[1];
                    if ("length" != n)
                        if (r.removeAttribute("disabled"),
                        e.clientSpecs.getSelectors().add_to_cart_enabled_classes && "" != e.clientSpecs.getSelectors().add_to_cart_enabled_classes.trim() && (r.className = e.clientSpecs.getSelectors().add_to_cart_enabled_classes),
                        "INPUT" == r.tagName && r.hasAttribute("original-text")) {
                            var s = r.getAttribute("original-text");
                            r.removeAttribute("original-text"),
                            r.value = s
                        } else if ("BUTTON" == r.tagName) {
                            var o = r;
                            if (r.children.length > 0 && (o = r.querySelector(t.add_to_cart_text_selector)),
                            o && r.hasAttribute("original-text")) {
                                s = r.getAttribute("original-text");
                                r.removeAttribute("original-text"),
                                o.innerHTML = s
                            }
                        }
                })
            }
        }, {
            key: "getOptionIndexKey",
            value: function(e, t) {
                var a = this.clientSpecs.getSelectors().option_index_attributes
                  , i = t;
                if ("undefined" == typeof this.themeSupportConfig.attribute_name || "none" != this.themeSupportConfig.attribute_name && e.hasAttribute(this.themeSupportConfig.attribute_name)) {
                    for (var n = 0; n < a.length; n++)
                        if (e.hasAttribute(a[n])) {
                            var r = e.getAttribute(a[n]);
                            if (r.match(RegExp("option\\d+", "gi"))) {
                                i = r,
                                this.themeSupportConfig.attribute_name = a[n];
                                break
                            }
                        }
                    "undefined" == typeof this.themeSupportConfig.attribute_name && (this.themeSupportConfig.attribute_name = "none")
                } else
                    "none" != this.themeSupportConfig.attribute_name && e.hasAttribute(this.themeSupportConfig.attribute_name) && (i = e.getAttribute(this.themeSupportConfig.attribute_name));
                return i
            }
        }, {
            key: "sortObjectByKeys",
            value: function(e) {
                for (var t = {}, a = 1, i = "option" + a; "undefined" != typeof e[i]; )
                    t[i] = e[i],
                    i = "option" + (a += 1);
                return t
            }
        }, {
            key: "getCurrentOption",
            value: function() {
                for (var e = {}, t = this.currentDocument.querySelectorAll(this.themeSupportConfig.option_selector), a = 0; a < t.length; a++) {
                    var i = "option" + (a + 1)
                      , n = t[a].value;
                    if (i = this.getOptionIndexKey(t[a], i),
                    t[a].hasAttribute("orig-value"))
                        n = t[a].options[t[a].selectedIndex].getAttribute("orig-value");
                    e[i] = n
                }
                return e = this.sortObjectByKeys(e)
            }
        }, {
            key: "getCurrentOptionDawn",
            value: function() {
                var e = this.themeSupportConfig.key_mapping
                  , t = {}
                  , a = this.currentDocument.querySelectorAll(this.themeSupportConfig.option_selector);
                if (1 == a.length && "SELECT" == a[0].tagName && "id" == a[0].name)
                    return this.getCurrentOptionMotion(a[0]);
                for (var i = this.clientSpecs.getCustomButtonParams(), n = 0; n < a.length; n++) {
                    var r = a[n]
                      , s = V && r.getAttribute("sa-value") || r.value
                      , o = r.name ? r.name : r.id
                      , l = "SELECT" != r.tagName && "INPUT" != r.tagName;
                    if (l) {
                        o = null;
                        for (var c = 0; c < i.data.length; c++) {
                            var u = i.data[c]
                              , d = u.option_attribute
                              , p = u.value_attribute;
                            if (r.hasAttribute(d))
                                o = r.getAttribute(d);
                            else {
                                var h = r.closest("[" + d + "]") || r.parentNode.querySelector("[" + d + "]");
                                h && (o = h.getAttribute(d))
                            }
                            if (o && r.hasAttribute(p)) {
                                s = r.getAttribute(p);
                                break
                            }
                        }
                    }
                    var g = e[o];
                    if (!g && o) {
                        var f = s;
                        if ("SELECT" == r.tagName) {
                            var v = r.options[1];
                            v && (f = v.value)
                        }
                        var m = o;
                        if (!l) {
                            var _ = this.clientSpecs.getSelectors().option_index_attributes;
                            if (_ && _.length > 0)
                                for (var y = 0; y < _.length; y++) {
                                    var w = _[y]
                                      , b = r.getAttribute(w);
                                    if (b) {
                                        m = b;
                                        break
                                    }
                                }
                        }
                        var S = this.themeSupportConfig.index_strategy
                          , k = this.productInfoTree.getOptionKeyByName(m, f, S, this.morphValues.bind(this));
                        this.themeSupportConfig.index_strategy = k[1],
                        (g = k[0]) == o && (o = this.productInfoTree.getOptionNameByKey(g)),
                        this.themeSupportConfig.key_mapping[o] = g
                    } else
                        o || (g = "option" + (n + 1));
                    r.checked || "SELECT" == r.tagName ? t[g] = s : l && r.matches(i.selected_selector) ? t[g] = s : "undefined" == typeof t[g] && (t[g] = s)
                }
                return t = this.sortObjectByKeys(t)
            }
        }, {
            key: "getCurrentOptionPrestige",
            value: function() {
                for (var e = {}, t = this.currentDocument.querySelectorAll(this.themeSupportConfig.option_selector), a = 0; a < t.length; a++)
                    if (t[a].classList.contains("is-selected") || 1 == t[a].checked) {
                        var i = "option" + (a + 1)
                          , n = V && t[a].getAttribute("sa-value") || t[a].value;
                        if ("button" == t[a].getAttribute("type") && (n = t[a].getAttribute("data-value")),
                        t[a].hasAttribute("data-option-value") && (n = t[a].getAttribute("data-option-value")),
                        t[a].hasAttribute("data-option-position")) {
                            var r = t[a].getAttribute("data-option-position");
                            i = "option" + r,
                            r.includes("option") && (i = r)
                        }
                        e[i] = n
                    }
                return e = this.sortObjectByKeys(e)
            }
        }, {
            key: "getCurrentOptionMotion",
            value: function() {
                var e = arguments.length <= 0 || arguments[0] === undefined ? null : arguments[0]
                  , t = {}
                  , a = e || this.currentDocument.querySelector(this.themeSupportConfig.option_selector)
                  , i = 0
                  , n = a.value
                  , r = this.productInfoTree.getVariantsKeys();
                "" == n && (this.themeSupportConfig.last_variant_id || (this.themeSupportConfig.last_variant_id = Z()),
                n = this.themeSupportConfig.last_variant_id);
                var s = this.productInfoTree.getVariants()
                  , o = s[n];
                for (void 0 === o && (n = r[0],
                a.value = n,
                o = s[n],
                this.dispatchEvent("change", a)); a; ) {
                    var l = "option" + (i + 1);
                    if (!o[l])
                        break;
                    t[l] = o[l],
                    i++
                }
                return t
            }
        }, {
            key: "currentOptionSwitch",
            value: function(e) {
                switch (e) {
                case "common":
                    return {
                        get: this.getCurrentOption.bind(this)
                    };
                case "prestige":
                    return {
                        get: this.getCurrentOptionPrestige.bind(this)
                    };
                case "motion":
                    return {
                        get: this.getCurrentOptionMotion.bind(this)
                    };
                case "dawn":
                    return {
                        get: this.getCurrentOptionDawn.bind(this)
                    }
                }
            }
        }, {
            key: "triggerChange",
            value: function(e, t) {
                for (var a = this.currentDocument.querySelectorAll(this.themeSupportConfig.option_selector), i = 0; i < a.length; i++) {
                    var n = "option" + (i + 1);
                    if ((n = this.getOptionIndexKey(a[i], n)) == e) {
                        if (a[i].hasAttribute("orig-value"))
                            for (var r = a[i].options, s = 0; s < r.length; s++) {
                                var o = r[s];
                                if (o.hasAttribute("orig-value") && o.getAttribute("orig-value") == t) {
                                    t = o.getAttribute("value");
                                    break
                                }
                            }
                        var l = a[i].value != t;
                        if (this.doNotSelectAnOption.status && this.doNotSelectAnOption.trusted_event_detected && (l = !0),
                        l) {
                            a[i].value = t,
                            this.dispatchEvent("change", a[i]);
                            var c = Z();
                            this.allOptionsData.variantId != c && (this.allOptionsData.variantId = c,
                            this.dispatchCustomEvent(a[i], "product:variant:changed", this.allOptionsData))
                        }
                        break
                    }
                }
            }
        }, {
            key: "triggerChangeDawn",
            value: function(e, t) {
                var a = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2]
                  , i = this.themeSupportConfig.key_mapping
                  , n = this.currentDocument.querySelectorAll(this.themeSupportConfig.option_selector);
                if (1 == n.length && "SELECT" == n[0].tagName && "id" == n[0].name)
                    return this.triggerChangeMotion(e, t, n[0]);
                for (var r = this.clientSpecs.getCustomButtonParams(), s = 0; s < n.length; s++) {
                    var o = n[s]
                      , l = V && o.getAttribute("sa-value") || o.value
                      , c = "SELECT" == o.tagName
                      , u = o.name ? o.name : o.id
                      , d = !c && "INPUT" != o.tagName;
                    if (d) {
                        u = null;
                        for (var p = 0; p < r.data.length; p++) {
                            var h = r.data[p]
                              , g = h.option_attribute
                              , f = h.value_attribute;
                            if (o.hasAttribute(g))
                                u = o.getAttribute(g);
                            else {
                                var v = o.closest("[" + g + "]") || o.parentNode.querySelector("[" + g + "]");
                                v && (u = v.getAttribute(g))
                            }
                            if (u && o.hasAttribute(f)) {
                                l = o.getAttribute(f);
                                break
                            }
                        }
                    }
                    var m = i[u];
                    if (!m && u) {
                        var _ = l;
                        if (c) {
                            var y = o.options[1];
                            y && (_ = y.value)
                        }
                        var w = u;
                        if (!d) {
                            var b = this.clientSpecs.getSelectors().option_index_attributes;
                            if (b && b.length > 0)
                                for (var S = 0; S < b.length; S++) {
                                    var k = b[S]
                                      , A = o.getAttribute(k);
                                    if (A) {
                                        w = A;
                                        break
                                    }
                                }
                        }
                        var I = this.themeSupportConfig.index_strategy
                          , T = this.productInfoTree.getOptionKeyByName(w, _, I, this.morphValues.bind(this));
                        this.themeSupportConfig.index_strategy = T[1],
                        (m = T[0]) == u && (u = this.productInfoTree.getOptionNameByKey(m)),
                        this.themeSupportConfig.key_mapping[u] = m
                    } else
                        u || (m = "option" + (s + 1));
                    if (c) {
                        var C = o.value != t;
                        if (this.doNotSelectAnOption.status && this.doNotSelectAnOption.trusted_event_detected && (C = !0),
                        C && m == e) {
                            o.value = t,
                            this.dispatchEvent("change", o);
                            var x = Z();
                            this.allOptionsData.variantId != x && (this.allOptionsData.variantId = x,
                            this.dispatchCustomEvent(o, "product:variant:changed", this.allOptionsData));
                            break
                        }
                    } else {
                        C = d ? !o.matches(r.selected_selector) : !o.checked;
                        if (this.doNotSelectAnOption.status && this.doNotSelectAnOption.trusted_event_detected && (C = !0),
                        C && m == e && (l == t || l == a)) {
                            o.removeAttribute("disabled"),
                            o.click(),
                            d || o.checked || o.click();
                            x = Z();
                            this.allOptionsData.variantId != x && (this.allOptionsData.variantId = x,
                            this.dispatchCustomEvent(o, "product:variant:changed", this.allOptionsData));
                            break
                        }
                    }
                }
            }
        }, {
            key: "triggerChangePrestige",
            value: function(e, t) {
                for (var a = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2], i = this.currentDocument.querySelectorAll(this.themeSupportConfig.option_selector), n = 0; n < i.length; n++) {
                    var r = "option" + (n + 1)
                      , s = V && i[n].getAttribute("sa-value") || i[n].value;
                    if ("button" == i[n].getAttribute("type") && (s = i[n].getAttribute("data-value")),
                    i[n].hasAttribute("data-option-value") && (s = i[n].getAttribute("data-option-value")),
                    i[n].hasAttribute("data-option-position")) {
                        var o = i[n].getAttribute("data-option-position");
                        r = "option" + o,
                        o.includes("option") && (r = o)
                    }
                    var l = !i[n].classList.contains("is-selected") && !i[n].checked;
                    if (this.doNotSelectAnOption.status && this.doNotSelectAnOption.trusted_event_detected && (l = !0),
                    l && r == e && (s == t || s == a)) {
                        i[n].click();
                        var c = Z();
                        this.allOptionsData.variantId != c && (this.allOptionsData.variantId = c,
                        this.dispatchCustomEvent(i[n], "product:variant:changed", this.allOptionsData));
                        break
                    }
                }
            }
        }, {
            key: "triggerChangeMotion",
            value: function(e, t) {
                var a = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2]
                  , i = a || this.currentDocument.querySelector(this.themeSupportConfig.option_selector)
                  , n = this.productInfoTree.getVariants()
                  , r = this.productInfoTree.getVariantsKeys()
                  , s = i.value
                  , o = [];
                "" == s && (this.themeSupportConfig.last_variant_id || (this.themeSupportConfig.last_variant_id = Z()),
                s = this.themeSupportConfig.last_variant_id);
                var l = n[s];
                void 0 === l && (s = r[0],
                i.value = s,
                l = n[s],
                this.dispatchEvent("change", i));
                for (var c = 0; c < r.length; c++) {
                    for (var u = n[r[c]], d = null, p = 0; null == d || 1 == d; ) {
                        var h = "option" + (p + 1);
                        if (!u[h] || !l[h])
                            break;
                        var g = l[h];
                        h == e && (g = t),
                        u[h] != g ? d = !1 : (d = !0,
                        o.push(u)),
                        p++
                    }
                    !d && o.length > 0 && c == r.length - 1 && (d = !0,
                    u = o[0]);
                    var f = d && i.value != u.id;
                    if (d && this.doNotSelectAnOption.status && this.doNotSelectAnOption.trusted_event_detected && (f = !0),
                    f) {
                        this.themeSupportConfig.last_variant_id = u.id,
                        i.value = u.id,
                        this.dispatchEvent("change", i);
                        var v = i.closest("[data-section-type]");
                        if (v) {
                            var m = {
                                variant: n[u.id]
                            };
                            this.dispatchThemeEvent("variantChange", v, m)
                        }
                        var _ = this.currentDocument.querySelector(this.clientSpecs.getSelectors().add_to_cart_selector);
                        _ && ("" == i.value ? _.setAttribute("disabled", !0) : _.removeAttribute("disabled"));
                        var y = Z();
                        this.allOptionsData.variantId != y && (this.allOptionsData.variantId = y,
                        this.dispatchCustomEvent(i, "product:variant:changed", this.allOptionsData));
                        break
                    }
                    if (!f && d)
                        break
                }
            }
        }, {
            key: "changeSwitch",
            value: function(e) {
                switch (e) {
                case "common":
                    return {
                        change: this.triggerChange.bind(this)
                    };
                case "prestige":
                    return {
                        change: this.triggerChangePrestige.bind(this)
                    };
                case "motion":
                    return {
                        change: this.triggerChangeMotion.bind(this)
                    };
                case "dawn":
                    return {
                        change: this.triggerChangeDawn.bind(this)
                    }
                }
            }
        }, {
            key: "generateUISwitch",
            value: function() {
                return this.isInstanceTypeCollection() ? this.generateUIForCollection.bind(this) : this.generateUI.bind(this)
            }
        }, {
            key: "generateUI",
            value: function(e) {
                var t = this
                  , a = null
                  , i = null
                  , n = null
                  , r = null
                  , s = {}
                  , o = {}
                  , l = !1
                  , c = !1
                  , u = undefined
                  , d = undefined
                  , p = "optionValueName";
                d = b ? b.trim() : this.multiLingualInfo.money_format.trim();
                var h = Z(this.currentDocument);
                if (this.allOptionsData.variantId = h,
                e) {
                    if ("LI" == (u = e.target).tagName && u.hasAttribute("orig-value") && u.children && (u = u.children[0]),
                    "keyup" == e.type && 13 !== e.keyCode)
                        return;
                    for (; u.hasAttribute("swatch-inside") || "FONT" == u.tagName || "SVG" == u.tagName || "I" == u.tagName; )
                        u = u.parentNode;
                    if (this.isClickEvent(e.type) && u.hasAttribute("data-navigation"))
                        return void this.scrollSwatchSlider(u, !1);
                    if (!u.hasAttribute("swatch-option"))
                        return;
                    if ("SELECT" == u.tagName && "change" != e.type)
                        return
                }
                if (e && u.hasAttribute("swatch-url") && this.isEventTrusted(e, !0) && window.encodeURIComponent && (this.isClickEvent(e.type) && "SELECT" != u.tagName || "change" == e.type && "SELECT" == u.tagName)) {
                    if (u.hasAttribute("current-product"))
                        return;
                    var g = "";
                    if (!this.hasOnlyDefaultVariant && !this.hasOnlySingleVariant) {
                        var f = this.currentOptionSwitch(this.themeCode).get()
                          , v = Object.keys(f);
                        if (this.clientSpecs.getPersistGroupVariant()) {
                            var m = this.productInfoTree.getVariantByVariantId(h)
                              , _ = this.productInfoTree.getOptions();
                            "storefront" === S && f.option1 && _.length > 0 && (p = this.findMatchingOption(_[0].optionValues, f.option1));
                            for (var y = 0; y < v.length; y++) {
                                var w = v[y]
                                  , k = f[w];
                                parseInt(k);
                                "optionValueId" == p && m.selectedOptions && m.selectedOptions.length > 0 && (k = m.selectedOptions[y].value),
                                g += "&" + w + "=" + encodeURIComponent(k)
                            }
                            "" != g && (g = g.replace(RegExp("^&", "gi"), "?"))
                        }
                    }
                    var A = u.getAttribute("swatch-url");
                    "SELECT" == u.tagName && (A = u.value);
                    var I = A + g;
                    this.clientSpecs.getHistoryFreeGroupNavigation() ? window.location.replace(I) : window.location.assign ? window.location.assign(I) : window.location.href = I
                } else {
                    if (e && "select" == u.getAttribute("type")) {
                        var T = u
                          , C = u.parentNode.querySelector("ul.swatch-drop-down-list")
                          , x = "true" == T.getAttribute("aria-expanded");
                        return T.setAttribute("aria-expanded", !x),
                        void C.classList.toggle("swatch-hide")
                    }
                    if (e && "select_value" == u.getAttribute("type"))
                        (T = u.closest("div.swatch-drop-down-inner").querySelector('div[type="select"]')).style.minWidth && "0px" != T.style.minWidth || this.setSelectMinWidth(T),
                        T.innerHTML = u.innerHTML,
                        T.setAttribute("aria-label", u.innerText),
                        T.setAttribute("aria-expanded", !1),
                        u.parentNode.classList.add("swatch-hide");
                    if (e && this.doNotSelectAnOption.status) {
                        var E = u.getAttribute("swatch-option")
                          , D = parseInt(E[6]) - 1
                          , O = this.productInfoTree.getOptions()[D]
                          , L = "undefined" != typeof O.untranslated_name ? O.untranslated_name : O.name
                          , P = this.clientSpecs.getTriggerActionByOptionName(L)
                          , N = O.values
                          , M = "virtual_click" == e.type || "change" == e.type && !this.isEventTrusted(e, !0);
                        if (this.doNotSelectAnOption.option_name = O.name,
                        this.doNotSelectAnOption.trusted_event_detected = !1,
                        "manual" == P && N.length > 1) {
                            if (this.dispatchCustomEvent(this.currentDocument, "manual:selection:hold", this.allOptionsData),
                            window.starapps_stock_data ? window.starapps_stock_data.show_stock_alert = !1 : (window.starapps_stock_data = {},
                            window.starapps_stock_data.show_stock_alert = !1),
                            !this.doNotSelectAnOption[E] && M) {
                                var q = this.getTranslation(this.doNotSelectAnOption.text);
                                q = q.replace(/{{\s*option_name\s*}}/gm, O.name);
                                var F = u.closest("div.swatch-single").querySelector("label.swatch-label");
                                if (this.uiElements.isDropDown(u.tagName)) {
                                    var V = document.createElement("option");
                                    V.value = "",
                                    V.innerHTML = q,
                                    u.insertBefore(V, u.options[0]),
                                    u.selectedIndex = 0
                                } else if ("select_value" == u.getAttribute("type")) {
                                    var R = u.closest(".swatch-drop-down-inner");
                                    if (R)
                                        (R = R.querySelector('[type="select"]')).querySelector("span").innerHTML = q,
                                        this.setSelectMinWidth(R)
                                } else
                                    F.hasAttribute("original-text") || F.setAttribute("original-text", F.innerHTML),
                                    F.innerHTML = '<input type="checkbox" name="manual" value="true" checked="checked">' + q;
                                if (!this.doNotSelectAnOption.allow_virtual_trigger) {
                                    if (this.doNotSelectAnOption.control_add_to_cart)
                                        j = (j = this.getTranslation(this.doNotSelectAnOption.make_a_selection_text)).replace(/{{\s*option_name\s*}}/gm, this.doNotSelectAnOption.option_name),
                                        this.disableAdd2CartButton(j, this.clientSpecs.getSelectors().add_to_cart_disabled_classes);
                                    return
                                }
                                l = !0
                            } else if (!M) {
                                this.doNotSelectAnOption.trusted_event_detected = !0,
                                this.restoreAddToCart();
                                var H = (F = u.closest("div.swatch-single").querySelector("label.swatch-label")).getAttribute("original-text");
                                H && (F.removeAttribute("original-text"),
                                F.innerHTML = H),
                                this.uiElements.isDropDown(u.tagName) && !this.doNotSelectAnOption[E] && u.remove(0),
                                this.doNotSelectAnOption[E] || (this.doNotSelectAnOption.count += 1,
                                this.doNotSelectAnOption[E] = !0)
                            }
                        } else
                            this.doNotSelectAnOption[E] || (this.doNotSelectAnOption.count += 1,
                            this.doNotSelectAnOption[E] = !0)
                    }
                    if (!(e && this.uiElements.isDropDown(u.tagName) && u.options && u.options.length > 1 && this.isClickEvent(e.type))) {
                        if (e && u.hasAttribute("swatch-option")) {
                            if (r = u.getAttribute("swatch-option"),
                            a = r,
                            this.uiElements.isDropDown(u.tagName))
                                i = u.value;
                            else {
                                i = u.getAttribute("orig-value"),
                                n = u.getAttribute("option-value-id");
                                var z = u.closest("[option-target]").querySelector("span.swatch-variant-name")
                                  , B = u.getAttribute("data-value");
                                z && "null" != i && "none" != B && (z.innerHTML = ' <span class="swatch-split-symbol">' + this.labelSplitSymbol + "</span> " + B)
                            }
                            var j;
                            if (l || this.uiElements.selectSwatch(r, u, i),
                            this.changeSwitch(this.themeCode).change(r, i, n),
                            l)
                                if (this.doNotSelectAnOption.control_add_to_cart)
                                    j = (j = this.getTranslation(this.doNotSelectAnOption.make_a_selection_text)).replace(/{{\s*option_name\s*}}/gm, this.doNotSelectAnOption.option_name),
                                    this.disableAdd2CartButton(j, this.clientSpecs.getSelectors().add_to_cart_disabled_classes)
                        }
                        if (this.readyToInit()) {
                            this.doNotSelectAnOption.status && this.doNotSelectAnOption.count >= this.productInfoTree.getOptions().length && (this.doNotSelectAnOption.status = !1,
                            window.starapps_stock_data ? window.starapps_stock_data.show_stock_alert = !0 : (window.starapps_stock_data = {},
                            window.starapps_stock_data.show_stock_alert = !0),
                            this.dispatchCustomEvent(this.currentDocument, "selection:release", this.allOptionsData));
                            var U = this.getCorrectSwatchRoot();
                            if (this.uiElements.getIsSwatchRootDisplayed() || this.uiElements.renderSwatchRoot(this.uiElements.getSwatchRoot(this.productInfoTree.getOptions()), U),
                            s = this.currentOptionSwitch(this.themeCode).get(),
                            $(s),
                            "undefined" == typeof s.option1) {
                                $("currentOption was not properly formed!");
                                for (var W = this.productInfoTree.getOptions(), G = 0; G < W.length; G++) {
                                    var J = "option" + (G + 1)
                                      , K = this.currentDocument.querySelector('[swatch-option="' + J + '"].swatch-selected');
                                    s[J] = "",
                                    K && (this.uiElements.isDropDown(K.tagName) ? s[J] = K.value : s[J] = K.getAttribute("orig-value"))
                                }
                            }
                            if (!e && this.clientSpecs.getPersistGroupVariant() && window.decodeURIComponent && window.location.href.includes("option1=") && !window.location.href.includes("variant="))
                                for (var X = /option\d=[^\&]*/gm, Y = window.location.href, Q = null, ee = (_ = this.productInfoTree.getOptions(),
                                0); null !== (Q = X.exec(Y)); ) {
                                    Q.index === X.lastIndex && X.lastIndex++;
                                    var te = Q[0].split("=")
                                      , ae = (E = te[0],
                                    decodeURIComponent(te[1]))
                                      , ie = undefined;
                                    0 == ee && "storefront" == S && (p = this.findMatchingOption(_[0].optionValues, ae)),
                                    "optionValueName" == p && "storefront" == S ? (ae = this.getMatchingOptionName(_[ee], ae),
                                    ie = this.getMatchingOptionId(_[ee], ae),
                                    s[E] = ae) : "optionValueId" == p && (ie = this.getMatchingOptionId(_[ee], ae),
                                    s[E] = ie),
                                    this.changeSwitch(this.themeCode).change(E, ae, ie),
                                    ee++
                                }
                            o = this.productInfoTree.getNodeByOptions(s, d, this.getMoneyWithFormat.bind(this)),
                            $(o);
                            var ne = !0
                              , re = !1
                              , se = undefined;
                            try {
                                var oe = function() {
                                    var e = _slicedToArray(le.value, 2)
                                      , i = e[0]
                                      , n = e[1];
                                    if (null != a) {
                                        if (a == i)
                                            a = null;
                                        else {
                                            var r = n.view_type_preset.params.price_badge;
                                            if (r != undefined && r.price_enabled) {
                                                var o = U.querySelectorAll('[option-target="' + i + '"] .swatch-view-item .swatch-selector');
                                                ue = !0,
                                                de = !1,
                                                pe = undefined;
                                                try {
                                                    for (he = o[Symbol.iterator](); !(ue = (ge = he.next()).done); ue = !0) {
                                                        var u = ge.value;
                                                        u.querySelector(".swatch-price-adjacent span").innerHTML = t.getOptionPriceInfo("option1" == i ? u.dataset.value : t.doNotSelectAnOption.option1 || s.option1 ? s.option1 : null, "option2" == i ? u.dataset.value : t.doNotSelectAnOption.option2 || s.option2 ? s.option2 : null, "option3" == i ? u.dataset.value : t.doNotSelectAnOption.option3 || s.option3 ? s.option3 : null)
                                                    }
                                                } catch (y) {
                                                    de = !0,
                                                    pe = y
                                                } finally {
                                                    try {
                                                        !ue && he["return"] && he["return"]()
                                                    } finally {
                                                        if (de)
                                                            throw pe
                                                    }
                                                }
                                            }
                                        }
                                        return "continue"
                                    }
                                    if (l) {
                                        for (var d = s[i], h = 0; h < n.data.length; h++) {
                                            if (d == n.data[h].value || d == n.data[h].option_value_id) {
                                                t.changeSwitch(t.themeCode).change(i, n.data[h].value, n.data[h].option_value_id);
                                                break
                                            }
                                            if (h == n.data.length - 1) {
                                                t.changeSwitch(t.themeCode).change(i, n.data[0].value, n.data[0].option_value_id);
                                                break
                                            }
                                        }
                                        if (t.doNotSelectAnOption.control_add_to_cart) {
                                            var g = t.getTranslation(t.doNotSelectAnOption.make_a_selection_text);
                                            g = g.replace(/{{\s*option_name\s*}}/gm, t.doNotSelectAnOption.option_name),
                                            t.disableAdd2CartButton(g, t.clientSpecs.getSelectors().add_to_cart_disabled_classes)
                                        }
                                        return "continue"
                                    }
                                    var f = t.uiElements.getViewByType(n.view_type_preset).getView(i, n)
                                      , v = t.uiElements.renderNormal(i, f, U);
                                    1 == n.data.length && "null" == n.data[0].value && v.length > 0 && v[0].closest && (v[0].closest("div.swatch-single").style.display = "none"),
                                    $("Generated UI for - " + i);
                                    var m = s[i]
                                      , _ = !1;
                                    if (Object.entries(v).forEach(function(e) {
                                        var i = _slicedToArray(e, 2)
                                          , r = i[0]
                                          , s = i[1];
                                        if ("length" != r) {
                                            var o = null
                                              , l = null;
                                            if (setTimeout(function() {
                                                var e = "swatch-allow-animation";
                                                s.classList.add(e)
                                            }, 128),
                                            t.uiElements.isDropDown(s.tagName)) {
                                                t.getLabelWidth(s, n.view_type_preset.params.padding_left),
                                                o = s.value;
                                                var u = s.querySelectorAll("option")
                                                  , d = !0
                                                  , h = !1
                                                  , g = undefined;
                                                try {
                                                    for (var f, w = u[Symbol.iterator](); !(d = (f = w.next()).done); d = !0) {
                                                        if ((x = f.value).getAttribute("value") === m) {
                                                            o = m,
                                                            s.value = m;
                                                            break
                                                        }
                                                    }
                                                } catch (y) {
                                                    h = !0,
                                                    g = y
                                                } finally {
                                                    try {
                                                        !d && w["return"] && w["return"]()
                                                    } finally {
                                                        if (h)
                                                            throw g
                                                    }
                                                }
                                            } else if ("true" === s.getAttribute("custom-select")) {
                                                t.getLabelWidth(s, n.view_type_preset.params.padding_left),
                                                o = s.getAttribute("aria-label");
                                                var b = s.closest(".swatch-drop-down-inner");
                                                if (b)
                                                    if ((u = b.querySelectorAll(".swatch-drop-down-list li")).length > 0) {
                                                        var S = !1
                                                          , k = !0
                                                          , A = !1
                                                          , I = undefined;
                                                        try {
                                                            for (var T, C = u[Symbol.iterator](); !(k = (T = C.next()).done); k = !0) {
                                                                var x;
                                                                if ((x = T.value).getAttribute("value") === m || x.getAttribute("option-value-id") === m) {
                                                                    o = m,
                                                                    l = m,
                                                                    S = !0;
                                                                    break
                                                                }
                                                            }
                                                        } catch (y) {
                                                            A = !0,
                                                            I = y
                                                        } finally {
                                                            try {
                                                                !k && C["return"] && C["return"]()
                                                            } finally {
                                                                if (A)
                                                                    throw I
                                                            }
                                                        }
                                                        S || (m = u[0].getAttribute("orig-value"),
                                                        "optionValueName" == p && (m = u[0].getAttribute("option-value-id")))
                                                    } else
                                                        $("This is custom select, option values are not found!")
                                            } else
                                                o = s.getAttribute("orig-value"),
                                                l = s.getAttribute("option-value-id");
                                            if (o != m && l != m || (_ = !0,
                                            t.uiElements.isDropDown(s.tagName) ? t.dispatchEvent("change", s) : t.dispatchEvent("virtual_click", s)),
                                            r == v.length - 1) {
                                                var E = s.closest(".swatch-navigable, variant-swatch-king")
                                                  , D = s.closest(".swatch-view-stack, variant-swatch-king");
                                                if (E && "VARIANT-SWATCH-KING" != E.tagName) {
                                                    E.querySelector(".swatch-navigation");
                                                    var O = s.closest(".swatch-navigable");
                                                    t.resSliderSize(O, n.view_type_preset.params, n.view_type_preset.assoc_view_type)
                                                } else if (D && "VARIANT-SWATCH-KING" != D.tagName) {
                                                    O = s.closest(".swatch-view-stack");
                                                    t.resStackSize(O, n.view_type_preset.params, n.view_type_preset.assoc_view_type)
                                                }
                                                a = "None",
                                                _ || (t.uiElements.isDropDown(v[0].tagName) ? t.dispatchEvent("change", v[0]) : t.dispatchEvent("virtual_click", v[0]),
                                                c = !0)
                                            }
                                        }
                                    }),
                                    c)
                                        return "break"
                                };
                                e: for (var le, ce = Object.entries(o)[Symbol.iterator](); !(ne = (le = ce.next()).done); ne = !0) {
                                    var ue, de, pe, he, ge;
                                    switch (oe()) {
                                    case "continue":
                                        continue;
                                    case "break":
                                        break e
                                    }
                                }
                            } catch (fe) {
                                re = !0,
                                se = fe
                            } finally {
                                try {
                                    !ne && ce["return"] && ce["return"]()
                                } finally {
                                    if (re)
                                        throw se
                                }
                            }
                        }
                    }
                }
            }
        }, {
            key: "getMatchingOptionId",
            value: function(e, t) {
                if (!e)
                    return null;
                var a = e.optionValues[0].id.match(/\d+/)[0]
                  , i = e.optionValues.find(function(e) {
                    return e.name.toLowerCase() === t.toLowerCase()
                });
                return i ? i.id.match(/\d+/)[0] : a
            }
        }, {
            key: "getMatchingOptionName",
            value: function(e, t) {
                if (!e)
                    return null;
                var a = e.optionValues[0].name
                  , i = e.optionValues.find(function(e) {
                    return e.name.toLowerCase() === t.toLowerCase()
                });
                return i ? i.name : a
            }
        }, {
            key: "findMatchingOption",
            value: function(e, t) {
                var a = t.toLowerCase()
                  , i = !0
                  , n = !1
                  , r = undefined;
                try {
                    for (var s, o = e[Symbol.iterator](); !(i = (s = o.next()).done); i = !0) {
                        var l = s.value;
                        if (l.name.toLowerCase() === a)
                            return "optionValueName";
                        if (l.id.match(/\d+/)[0] === t)
                            return "optionValueId"
                    }
                } catch (c) {
                    n = !0,
                    r = c
                } finally {
                    try {
                        !i && o["return"] && o["return"]()
                    } finally {
                        if (n)
                            throw r
                    }
                }
                return "optionValueName"
            }
        }, {
            key: "resSliderSize",
            value: function(e, t, a) {
                var i = this
                  , n = window.matchMedia ? window.matchMedia("screen and (max-width: 768px)") : screen.width <= 768
                  , r = e.closest(".swatch-navigable-wrapper")
                  , s = "li.swatch-view-item"
                  , o = e.querySelector("ul.swatch-view")
                  , l = o.querySelectorAll(s).length
                  , c = e.querySelector('[navigation="left"]')
                  , u = e.querySelector('[navigation="right"]')
                  , d = e.getBoundingClientRect().width
                  , p = r ? r.getBoundingClientRect().width : null
                  , h = undefined
                  , g = undefined
                  , f = undefined
                  , v = undefined
                  , m = undefined
                  , _ = undefined
                  , y = undefined
                  , w = undefined
                  , b = undefined
                  , S = undefined
                  , k = t.arrow_mode
                  , A = undefined
                  , I = t.adjust_margin_right;
                n.matches && (k = t.mobile_arrow_mode,
                I = t.mobile_adjust_margin_right);
                var T = parseFloat(t.margin_right.match(/[\d\.]+/g))
                  , C = T;
                "swatch-pill" == t.swatch_type || "button" == a ? (_ = 0,
                o.querySelectorAll(s).forEach(function(e, t) {
                    e.style.width = e.getBoundingClientRect().width + "px",
                    _ = _ + e.getBoundingClientRect().width + C,
                    e.firstChild.classList.contains("swatch-selected") && (b = (_ - e.getBoundingClientRect().width) / (.8 * d),
                    S = t,
                    "mode_4" == k && (r.querySelector(".swatch-navigable").setAttribute("data-current-scroll", t),
                    e.scrollIntoView({
                        behavior: "auto",
                        block: "nearest",
                        inline: "start"
                    }))),
                    0 == t && (y = e.getBoundingClientRect().width),
                    t == l - 1 && (w = e.getBoundingClientRect().width,
                    _ -= C)
                })) : function() {
                    h = parseFloat(t.width.match(/[\d\.]+/g)),
                    g = parseFloat(t.border_width.match(/[\d\.]+/g));
                    var e = t.border_space || t.margin_swatch_horizontal;
                    f = parseFloat(e.match(/[\d\.]+/g)),
                    v = h + 2 * g + 2 * f;
                    var a = t.last_swatch_preview;
                    n.matches && (a = t.mobile_last_swatch_preview);
                    var i = (d + C) / (v + C);
                    "mode_1" == k && (i = (p + C) / (v + C));
                    var r = 0;
                    if (i >= l && !I)
                        r = parseInt(i);
                    else {
                        switch (a) {
                        case "full":
                            if (i = (d + C) / (v + C),
                            r = parseInt(i),
                            A = d - r * v,
                            (C = Math.max(A / (r > 1 ? r - 1 : 1), T)) > A / (r > 1 ? r - 1 : 1)) {
                                var c = d - (r - 1) * C;
                                r = Math.floor(c / v)
                            }
                            break;
                        case "half":
                            var u = (d - (Math.floor(i) * v + Math.floor(i) * C)) / v * 100
                              , y = undefined;
                            if ((u < 20 || u > 80) && i > 1)
                                if (u < 20) {
                                    y = 80,
                                    r = Math.floor(i) - 1;
                                    var w = y / 100 * v;
                                    C = parseFloat(((d - (r * v + w)) / r).toFixed(3))
                                } else {
                                    w = (y = 80) / 100 * v;
                                    var x = Math.floor(i) + w / v;
                                    r = Math.floor(x),
                                    C = parseFloat(((d - (r * v + w)) / r).toFixed(3))
                                }
                            else
                                r = Math.floor(i)
                        }
                        var E = o.querySelector(s + ":last-child");
                        E && (E.style.width = v + "px")
                    }
                    m = r,
                    _ = (v + C) * (l - 1) + v,
                    o.querySelectorAll(s).forEach(function(e, t) {
                        e.firstChild instanceof Element && e.firstChild.classList.contains("swatch-selected") && (b = m > 0 ? (v + C) * t / (m * (v + C)) : 0,
                        "half" == a ? "mode_1" == k && (b = m > 2 ? (v + C) * t / ((m - 2) * (v + C)) : t - m >= 0 ? t - m + 1 : 0) : b = m > 2 ? (v + C) * t / ((m - 2) * (v + C)) : 0,
                        S = t),
                        t != l - 1 && (e.style.width = v + "px",
                        e.style.marginRight = C + "px")
                    })
                }(),
                o.parentElement.setAttribute("swatch-slider", "true");
                var x = {
                    swatchSliderItemWidth: v || 0,
                    totalScrollWidth: _,
                    sliderWidth: d,
                    visibleSwatches: m || 0,
                    marginRight: C,
                    swatchType: t.swatch_type,
                    firstSwatchWidth: y,
                    lastSwatchWidth: w,
                    assocViewType: a,
                    arrowMode: k
                };
                o.style.transform = "translateX(0px)",
                o.style.display = "flex";
                var E = o.closest("[option-name]");
                if ("mode_1" == k && (d = p),
                m >= l || d >= _) {
                    if (c.classList.remove("star-show"),
                    u.classList.remove("star-show"),
                    "mode_2" == k || "mode_3" == k)
                        e.classList.add("star-remove-margin"),
                        x.sliderWidth = e.getBoundingClientRect().width;
                    else if ("mode_4" == k)
                        return e.closest(".swatch-navigable").style.margin = "0px",
                        void (e.closest(".swatch-navigable").style.width = "100%");
                    return o.parentElement.setAttribute("data-slider-data", JSON.stringify(x)),
                    !1
                }
                if (u.classList.add("star-show"),
                u.classList.remove("star-disabled"),
                o.style.setProperty("justify-content", "unset"),
                o.style.setProperty("width", _ + "px", "important"),
                "mode_2" == k || "mode_3" == k)
                    c.classList.add("star-show", "star-disabled"),
                    e.classList.remove("star-remove-margin"),
                    x.sliderWidth = e.getBoundingClientRect().width;
                else if ("mode_0" == k)
                    c.classList.remove("star-show"),
                    u.classList.remove("star-show");
                else if ("mode_4" == k) {
                    e.style.margin = "auto",
                    u.classList.add("star-show"),
                    c.classList.add("star-show"),
                    u.classList.remove("star-disabled"),
                    c.classList.remove("star-disabled");
                    var D = c.getBoundingClientRect().width + u.getBoundingClientRect().width;
                    return void (e.closest(".swatch-navigable").style.width = "calc(100% - " + D + "px)")
                }
                return b = parseInt(b),
                setTimeout(function() {
                    for (var t = 0; t < b; t++)
                        i.clickToScroll(1, e.closest(".swatch-navigable"), !1);
                    var a, r;
                    n.matches && (a = undefined,
                    r = 0,
                    E && E.id.includes("swatch-group") && (o.querySelectorAll(s)[S].scrollIntoView(!1),
                    document.body.scrollIntoView()),
                    o.addEventListener("touchstart", function(e) {
                        a = e.touches[0].clientX,
                        r = 1
                    }, {
                        capture: !0
                    }),
                    o.addEventListener("touchmove", function(t) {
                        1 == r && (r += 1,
                        a >= t.touches[0].clientX ? i.clickToScroll(1, e.closest(".swatch-navigable")) : i.clickToScroll(0, e.closest(".swatch-navigable")))
                    }, {
                        capture: !0
                    }),
                    o.addEventListener("touchend", function() {
                        r = 0
                    }, {
                        capture: !0
                    }))
                }, 200),
                o.parentElement.setAttribute("data-slider-data", JSON.stringify(x)),
                !0
            }
        }, {
            key: "resStackSize",
            value: function(e, t, a) {
                if ("swatch-pill" != t.swatch_type && "button" != a && t.adjust_margin_right) {
                    var i = window.matchMedia ? window.matchMedia("screen and (max-width: 480px)") : screen.width <= 480
                      , n = t.adjust_margin_right;
                    if (i.matches && (n = t.mobile_adjust_margin_right),
                    n) {
                        var r = e.querySelector("ul.swatch-view");
                        r && (s = "li.swatch-view-item",
                        r.querySelectorAll(s).length,
                        o = e.getBoundingClientRect().width,
                        undefined,
                        l = parseFloat(t.width.match(/[\d\.]+/g)),
                        c = parseFloat(t.border_width.match(/[\d\.]+/g)),
                        u = t.border_space || t.margin_swatch_horizontal,
                        d = parseFloat(u.match(/[\d\.]+/g)),
                        p = parseFloat(t.margin_right.match(/[\d\.]+/g)),
                        h = parseInt((o + p) / (l + 2 * c + 2 * d + p)),
                        r.querySelectorAll(s).forEach(function(e, t) {
                            (t + 1) % h == 0 && (e.style.marginRight = 0)
                        }))
                    }
                }
                var s, o, l, c, u, d, p, h
            }
        }, {
            key: "getOptionValueId",
            value: function(e, t) {
                var a = e.find(function(e) {
                    return e.name === t
                });
                return a ? a.id.split("ProductOptionValue/")[1] : null
            }
        }, {
            key: "morphValues",
            value: function(e) {
                return this.clientSpecs.getHandleize() ? e = (e = (e = (e = (e = e.toLowerCase()).replace(RegExp("['\"\\(\\)\\{\\}\\[\\]]", "gi"), "")).replace(RegExp("[^a-z0-9_]+", "gi"), "-")).replace(RegExp("-+", "gi"), "-")).replace(RegExp("^-|-$", "gi"), "") : e
            }
        }, {
            key: "checkValidPrice",
            value: function(e, t) {
                var a = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2]
                  , i = arguments.length <= 3 || arguments[3] === undefined ? null : arguments[3];
                return null == a ? e[t] != undefined : null == i ? e[t][a] != undefined : e[t][a] != undefined && e[t][a][i] != undefined
            }
        }, {
            key: "getOption1Price",
            value: function(e, t) {
                return {
                    min_price: e[t].min_price,
                    max_price: e[t].max_price,
                    is_equal: e[t].min_price == e[t].max_price
                }
            }
        }, {
            key: "getOption2Price",
            value: function(e, t, a) {
                return {
                    min_price: e[t][a].min_price,
                    max_price: e[t][a].max_price,
                    is_equal: e[t][a].min_price == e[t][a].max_price
                }
            }
        }, {
            key: "getOption3Price",
            value: function(e, t, a, i) {
                return {
                    min_price: e[t][a][i].min_price,
                    max_price: e[t][a][i].max_price,
                    is_equal: e[t][a][i].min_price == e[t][a][i].max_price
                }
            }
        }, {
            key: "getOptionPriceInfo",
            value: function(e) {
                var t = arguments.length <= 1 || arguments[1] === undefined ? null : arguments[1]
                  , a = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2]
                  , i = this.productInfoTree.getOptionValueByOptionId(e)
                  , n = this.productInfoTree.getOptionValueByOptionId(t)
                  , r = this.productInfoTree.getOptionValueByOptionId(a);
                b = b ? b.trim() : this.multiLingualInfo.money_format.trim();
                var s = this.productInfoTree.getPriceInfoTree()
                  , o = null;
                if (null == n)
                    o = (u = this.getOption1Price(s, i)).is_equal ? this.getMoneyWithFormat(b, u.min_price) : this.getMoneyWithFormat(b, u.min_price) + "+";
                else if (null == r) {
                    if (this.checkValidPrice(s, i, n))
                        o = (c = this.getOption2Price(s, i, n)).is_equal ? this.getMoneyWithFormat(b, c.min_price) : this.getMoneyWithFormat(b, c.min_price) + "+";
                    else
                        o = (u = this.getOption1Price(s, i)).is_equal ? this.getMoneyWithFormat(b, u.min_price) : this.getMoneyWithFormat(b, u.min_price) + "+"
                } else if (this.checkValidPrice(s, i, n, r)) {
                    var l = this.getOption3Price(s, i, n, r);
                    o = l.is_equal ? this.getMoneyWithFormat(b, l.min_price) : this.getMoneyWithFormat(b, l.min_price) + "+"
                } else if (this.checkValidPrice(s, i, n)) {
                    var c;
                    o = (c = this.getOption2Price(s, i, n)).is_equal ? this.getMoneyWithFormat(b, c.min_price) : this.getMoneyWithFormat(b, c.min_price) + "+"
                } else {
                    var u;
                    o = (u = this.getOption1Price(s, i)).is_equal ? this.getMoneyWithFormat(b, u.min_price) : this.getMoneyWithFormat(b, u.min_price) + "+"
                }
                return o
            }
        }, {
            key: "updateSecondaryAndLastImage",
            value: function(e, t) {
                return e.featured_image && (e.featured_image.secondary_src = e.featured_image.src,
                e.featured_image.last_src = e.featured_image.src,
                void 0 !== t && t.length > 1 && (e.featured_image.secondary_src = t[1],
                e.featured_image.last_src = t[t.length - 1])),
                e
            }
        }, {
            key: "updateSessionStorageProductData",
            value: function(e) {
                var t = arguments.length <= 1 || arguments[1] === undefined ? null : arguments[1]
                  , a = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
                if ("storefront" == S) {
                    var i = e.id.match(/\d+/)[0];
                    this.setDataToSessionStorage(this.getSessionStorageKey(e.handle, !1, !1, !1, t, a), e),
                    this.setDataToSessionStorage(this.getSessionStorageKey(i, !1, !1, !1, t, a), e)
                } else
                    this.setDataToSessionStorage(this.getSessionStorageKey(e.handle, !1, !1), e)
            }
        }, {
            key: "processJSONInformation",
            value: function(e) {
                var t = this
                  , a = arguments.length <= 1 || arguments[1] === undefined ? null : arguments[1]
                  , i = e.options
                  , n = e.variants
                  , r = e.images
                  , s = {}
                  , o = {}
                  , l = "storefront" == S ? e.id.split("Product/")[1] : e.id;
                if ("storefront" == S) {
                    if (n = e.variants ? e.variants.nodes : null,
                    r = e.images ? e.images.nodes.map(function(e) {
                        return e.url
                    }) : null,
                    n && r)
                        for (var c = e.images.nodes.reduce(function(e, t, a) {
                            return e[t.id] = a + 1,
                            e
                        }, {}), u = 0; u < n.length; u++) {
                            if (n[u].featured_image)
                                (T = c[n[u].featured_image.id]) !== undefined && (n[u].featured_image.position = T)
                        }
                } else
                    e.options_with_values && (i = e.options_with_values);
                var d = this.getMultiLingualInfo().translation_status ? this.getUntranslatedData() : null
                  , p = d ? d.handle : null;
                if (this.productInfoTree.setProductInfo({
                    id: l,
                    handle: e.handle,
                    untranslated_handle: p,
                    vendor: e.vendor,
                    published_at: e.publishedAt
                }),
                null != i && i != undefined && null != n && n != undefined) {
                    if (this.getMultiLingualInfo().translation_status && null == this.getUntranslatedData())
                        return "none" == this.getUntranslatedFetchStatus() && this.fetchUntranslatedOptions(l),
                        void setTimeout(function() {
                            t.processJSONInformation(e, a)
                        }, 200);
                    var h = this.isInstanceTypeProduct() && !this.clientSpecs.getVariantsEnableStatusForProductType()
                      , g = this.isInstanceTypeCollection() && !this.clientSpecs.getEnableStatusForProductGridType();
                    if (h || g)
                        return this.hasOnlySingleVariant = !0,
                        this.hasOnlyDefaultVariant = !0,
                        void this.initialize();
                    var f = {}
                      , v = f
                      , m = a ? a.country : null
                      , _ = a ? a.language : null;
                    if ("undefined" != typeof e.tags && "all" != this.clientSpecs.getAppExecutionStrategy()) {
                        var y = this.clientSpecs.getAppExecutionStrategy();
                        if ("enabled_except" == y && e.tags.includes("vsk_disable"))
                            return this.hasOnlyDefaultVariant = !0,
                            void $("App won't run as vsk_disable is present in product tags with strategy enabled_except");
                        if ("disabled_except" == y && !e.tags.includes("vsk_enable"))
                            return this.hasOnlyDefaultVariant = !0,
                            void $("App won't run as vsk_enable is not present in product tags with strategy disabled_except")
                    }
                    if (1 == n.length && (this.hasOnlySingleVariant = !0,
                    n[0].title.toLowerCase().includes("default")))
                        return this.hasOnlyDefaultVariant = !0,
                        "undefined" == typeof n[0].merged_options && this.updateSessionStorageProductData(e, m, _),
                        void this.initialize();
                    n.length > 0 && "undefined" == typeof n[0].merged_options && this.updateSessionStorageProductData(e, m, _);
                    for (u = 0; u < i.length; u++) {
                        var w = null;
                        if (null != d) {
                            var b = d.options[u].name;
                            i[u].untranslated_name = b,
                            w = this.clientSpecs.getViewTypeByOptionName(b, this.instanceType)
                        } else {
                            b = i[u].name;
                            w = this.clientSpecs.getViewTypeByOptionName(b, this.instanceType)
                        }
                        i[u].view_type_preset = w
                    }
                    for (var k = null, A = null, I = 0; I < r.length; I++) {
                        for (var T = I + 1, C = 0; C < n.length; C++) {
                            var x = n[C]
                              , E = x.featured_image
                              , D = "storefront" == S ? x.id.split("/ProductVariant/")[1] : x.id;
                            if (E) {
                                var O = parseInt(E.position + "");
                                if (T == O) {
                                    k = D,
                                    A = T;
                                    break
                                }
                                null != k && A == O && (o[D] = o[k])
                            }
                        }
                        if (null != k) {
                            "undefined" == typeof o[k] && (o[k] = []);
                            var L = r[I];
                            o[k].push(L)
                        }
                    }
                    var P = {}
                      , N = {};
                    for (u = 0; u < n.length; u++) {
                        var M = n[u].id
                          , q = n[u].available;
                        "storefront" == S && (M = n[u].id.split("ProductVariant/")[1] ? n[u].id.split("ProductVariant/")[1] : n[u].id,
                        n[u].id = M,
                        q = n[u].availableForSale,
                        n[u].options = []),
                        null == this.pInformation.first_or_available_variant && (q ? this.pInformation.first_or_available_variant = n[u] : u == n.length - 1 && (this.pInformation.first_or_available_variant = n[0])),
                        n[u] = this.updateSecondaryAndLastImage(n[u], o[M]),
                        s[M] = n[u],
                        f = v;
                        for (var F = null, V = "storefront" == S ? parseFloat(n[u].price.amount) : n[u].price, R = 0; R < i.length; R++) {
                            var H = "option" + (R + 1)
                              , z = i[R].name
                              , B = (w = i[R].view_type_preset,
                            "storefront" == S ? n[u].selectedOptions[R].value : n[u][H])
                              , j = "storefront" == S ? this.getOptionValueId(i[R].optionValues, n[u].selectedOptions[R].value) : null;
                            n[u][H] = this.morphValues(B),
                            n[u].options[R] = n[u][H],
                            f[H] == undefined && (f[H] = []);
                            for (var U = !1, W = 1, G = f[H].length, J = G - 1; J >= 0; J--) {
                                var K = f[H][J];
                                if (K != undefined && (U = K.name == z && K.value == n[u][H])) {
                                    W = G - J;
                                    break
                                }
                            }
                            if (U)
                                null != F && (q && (F.available = q),
                                V >= 0 && (F.min_price = F.min_price && V > F.min_price ? F.min_price : V,
                                F.max_price = F.max_price && V < F.max_price ? F.max_price : V));
                            else {
                                var X = {};
                                if (X.name = z,
                                X.untranslated_name = i[R].untranslated_name,
                                X.value = n[u][H],
                                X.original_value = B,
                                X.option_value_id = j,
                                X.view_type_preset = w,
                                X.available = !1,
                                X.compare_at_price = n[u].compareAtPrice,
                                null != d && (X.untranslated_value = d.variants[u].selectedOptions[R].value),
                                this.uiElements.isASwatch(w.assoc_view_type) && (X.featured_image = n[u].featured_image,
                                X.featured_image)) {
                                    X.featured_image.secondary_src = X.featured_image.src,
                                    X.featured_image.last_src = X.featured_image.src;
                                    var Z = o[M];
                                    void 0 !== Z && Z.length > 1 && (X.featured_image.secondary_src = Z[1],
                                    X.featured_image.last_src = Z[Z.length - 1])
                                }
                                null != F && q && (F.available = q),
                                null != F && V >= 0 && (F.min_price = F.min_price && V > F.min_price ? F.min_price : V,
                                F.max_price = F.max_price && V < F.max_price ? F.max_price : V),
                                R == i.length - 1 && (X.variant_id = M,
                                X.available = q,
                                X.min_price = V,
                                X.max_price = V),
                                f[H].push(X)
                            }
                            F = f = f[H][f[H].length - W]
                        }
                        N = P;
                        var Y = "storefront" == S ? n[u].selectedOptions : n[u].options;
                        for (R = 0; R < Y.length; R++) {
                            var Q = "storefront" == S ? Y[R].value : Y[R];
                            N[Q] == undefined && (N[Q] = {
                                min_price: V,
                                max_price: V
                            }),
                            N[Q].min_price = Math.min(N[Q].min_price, V),
                            N[Q].max_price = Math.max(N[Q].max_price, V),
                            N = N[Q]
                        }
                    }
                    var ee = null;
                    "storefront" == S ? !(ee = e.featuredImage ? e.featuredImage.url : null) && e.images.nodes && e.images.nodes.length > 0 && (ee = e.images.nodes[0].url) : (!(ee = e.featured_image) && e.images && e.images.length > 0 && (ee = e.images[0]),
                    ee && "object" == typeof ee && (ee = ee.src)),
                    this.isInstanceTypeCollection() && (this.currentDocument.hasAttribute("swatch-default-variant") ? (this.pInformation.preselect_variant = this.currentDocument.getAttribute("swatch-default-variant"),
                    this.currentDocument.removeAttribute("swatch-default-variant")) : this.clientSpecs.getCollectionPreselectVariant() && (this.pInformation.preselect_variant = this.pInformation.first_or_available_variant.id)),
                    this.uiElements.setDefaultFeaturedImage(ee),
                    this.productInfoTree.setValues(v, i, s, P),
                    $(["Processed JS data structure", this.productInfoTree])
                } else if (e.handle && "" != e.handle) {
                    var te = window.Shopify.locale;
                    "storefront" == S ? this.executeFetch({
                        handle: e.handle,
                        locale: te,
                        path_name: null,
                        allow_processing: !1,
                        callback: function(e, a) {
                            t.processJSONInformation(e, a)
                        },
                        translation_request: !1
                    }) : this.executeFetch({
                        url: this.getMultiLingualInfo().current_url + "/collections/all/products/" + e.handle + ".js",
                        path_name: null,
                        allow_processing: !1,
                        callback: function(e) {
                            t.processJSONInformation(e)
                        },
                        translation_request: !1
                    })
                }
            }
        }, {
            key: "hideFormElements",
            value: function(e, t) {
                t && this.currentDocument.querySelectorAll(e).forEach(function(e) {
                    e.parentNode.style.display = "none"
                });
                this.uiElements.hideElementStyles(e)
            }
        }, {
            key: "retryFetchInformationFromJs",
            value: function(e) {
                var t = this;
                setTimeout(function() {
                    t.fetchInformationFromJs()
                }, e)
            }
        }, {
            key: "fetchInformationFromJs",
            value: function() {
                var e = this;
                if (this.isInstanceTypeCollection()) {
                    var t = this.getProductHandleFromScope();
                    t && (this.processJSONInformation({
                        id: "0",
                        title: "",
                        handle: decodeURI(t)
                    }),
                    this.currentDocument.setAttribute("swatch-generated", t))
                } else {
                    var a = window.decodeURI(window.location.pathname.replace(/\/$/, ""))
                      , i = a.includes("/products")
                      , n = null;
                    if ("sectioned" == this.instanceSubType && !this.isSectionPrimary ? (n = this.getProductHandleFromScope(),
                    this.currentDocument.setAttribute("swatch-generated", n)) : this.isSectionPrimary && this.currentDocument.setAttribute("swatch-generated", a),
                    "quick_view" != this.instanceSubType) {
                        if (i && !n)
                            if ("storefront" == S) {
                                if ("pending" == window.starAppsStudioStorefrontDataRequest)
                                    return void this.retryFetchInformationFromJs(100);
                                if ("undefined" != typeof window.starAppsStudioStorefrontData && window.starAppsStudioStorefrontDataURL == a)
                                    return void setTimeout(function() {
                                        window.starAppsStudioStorefrontDataRequest = "complete",
                                        e.processJSONInformation(window.starAppsStudioStorefrontData)
                                    }, 100);
                                window.starAppsStudioStorefrontDataRequest = "pending"
                            } else {
                                if ("pending" == window.starAppsStudioJSDataRequest)
                                    return void this.retryFetchInformationFromJs(100);
                                if ("undefined" != typeof window.starAppsStudioJSData && window.starAppsStudioJSDataURL == a)
                                    return void setTimeout(function() {
                                        window.starAppsStudioJSDataRequest = "complete",
                                        e.processJSONInformation(window.starAppsStudioJSData)
                                    }, 100);
                                window.starAppsStudioJSDataRequest = "pending"
                            }
                        if (i || n)
                            if ("storefront" == S) {
                                n || (n = a.split("/products/")[1]);
                                var r = window.Shopify.locale;
                                this.executeFetch({
                                    handle: n,
                                    locale: r,
                                    path_name: i && !n ? a : null,
                                    allow_processing: !0,
                                    translation_request: !1,
                                    callback: null
                                })
                            } else {
                                var s = undefined;
                                s = n ? this.getMultiLingualInfo().current_url + "/products/" + n + ".js" : a + ".js",
                                $("JS data fetch request initiated for URL: " + s),
                                this.executeFetch({
                                    url: s,
                                    path_name: i && !n ? a : null,
                                    allow_processing: !0,
                                    callback: null,
                                    translation_request: !1
                                })
                            }
                        else
                            this.productUndefined = !0
                    }
                }
            }
        }, {
            key: "executeFetch",
            value: async function(e, t) {
                var a, i = this, n = e.path_name, r = e.allow_processing, s = e.callback, l = e.translation_request;
                if ("storefront" == S) {
                    var c = e.handle
                      , u = o(e.locale)
                      , d = window.Shopify.country
                      , p = "\n                query productDetails($variantsCursor: String) @inContext(country: " + d.toUpperCase() + ", language: " + u + ') {\n                    product(handle:"' + c + '") {\n                        id\n                        handle\n                        title\n                        vendor\n                        availableForSale\n                        onlineStoreUrl\n                        tags\n                        publishedAt\n                        priceRange{\n                            maxVariantPrice{\n                                amount\n                            }\n                            minVariantPrice{\n                                amount\n                            }\n                        }\n                        featuredImage{\n                            id\n                            url\n                        }\n                        options{\n                            id\n                            name\n                            values\n                            optionValues{\n                                id\n                                name\n                            }\n                        }\n                        images(first: 250){\n                            nodes{\n                                id\n                                url\n                                altText\n                            }\n                        }\n                        compareAtPriceRange {\n                            maxVariantPrice {\n                                amount\n                            }\n                            minVariantPrice {\n                                amount\n                            }\n                        }\n                        ... on Product @defer {\n                            variants(first: 250, after: $variantsCursor) {\n                                nodes{\n                                    id\n                                    availableForSale\n                                    quantityAvailable\n                                    compareAtPrice{\n                                        currencyCode\n                                        amount\n                                    }\n                                    selectedOptions{\n                                        name\n                                        value\n                                    }\n                                    currentlyNotInStock\n                                    featured_image: image{\n                                        id\n                                        src: url\n                                        altText\n                                    }\n                                    price{\n                                        currencyCode\n                                        amount\n                                    }\n                                    title\n                                    sku\n                                    compareAtPrice {\n                                        amount\n                                    }\n                                }\n                                pageInfo {\n                                    hasNextPage\n                                    endCursor\n                                }\n                            }\n                        }\n                    }\n                }\n            ';
                    this.clientSpecs.storefront_access_token,
                    JSON.stringify({
                        query: p
                    });
                    if ((m = this.getDataFromSessionStorage(this.getSessionStorageKey(c, !1, l))) && !t)
                        return void (null !== m.id && (n && (window.starAppsStudioStorefrontDataRequest = "complete",
                        window.starAppsStudioStorefrontDataURL = n,
                        window.starAppsStudioStorefrontData = m),
                        r && (this.processJSONInformation(m),
                        $("JS data fetch request finished")),
                        s && s.call(this, m)));
                    if (window.fetch) {
                        var h = await this.fetchProductData(p)
                          , g = h.productData
                          , f = h.allVariants
                          , v = h.context;
                        g && (g.variants = {
                            nodes: [].concat(_toConsumableArray(f))
                        },
                        n && (window.starAppsStudioStorefrontDataRequest = "complete",
                        window.starAppsStudioStorefrontDataURL = n,
                        window.starAppsStudioStorefrontData = g),
                        r && (this.processJSONInformation(g, v),
                        $("Storefront data fetch request finished")),
                        s && s.call(this, g, v))
                    }
                } else {
                    var m, _ = e.url;
                    if ((m = this.getDataFromSessionStorage(this.getSessionStorageKey(_, !0, l))) && !t)
                        return void (null !== m.id && (n && (window.starAppsStudioJSDataRequest = "complete",
                        window.starAppsStudioJSDataURL = n,
                        window.starAppsStudioJSData = m),
                        r && (this.processJSONInformation(m),
                        $("JS data fetch request finished")),
                        s && s.call(this, m)));
                    window.fetch ? fetch(_).then(function(e) {
                        return e.json()
                    }).then(function(e) {
                        n && (window.starAppsStudioJSDataRequest = "complete",
                        window.starAppsStudioJSDataURL = n,
                        window.starAppsStudioJSData = e),
                        r && (i.processJSONInformation(e),
                        $("JS data fetch request finished")),
                        s && s.call(i, e)
                    }) : ((a = new XMLHttpRequest).open("GET", _, !0),
                    a.onload = function() {
                        if (a.status >= 200 && a.status < 400) {
                            var e = JSON.parse(a.responseText);
                            n && (window.starAppsStudioJSDataRequest = "complete",
                            window.starAppsStudioJSDataURL = n,
                            window.starAppsStudioJSData = e),
                            r && (this.processJSONInformation(e),
                            $("JS data fetch request finished")),
                            s && s.call(this, e)
                        }
                    }
                    .bind(i),
                    a.send())
                }
            }
        }, {
            key: "executeStorefrontFetch",
            value: async function(e) {
                var t = this
                  , a = e.callback
                  , i = g + "api/" + c + "/graphql.json"
                  , n = e.query
                  , r = e.isMultiple
                  , s = {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "X-Shopify-Storefront-Access-Token": this.clientSpecs.storefront_access_token
                    },
                    body: JSON.stringify({
                        query: n
                    })
                };
                if (window.fetch)
                    if (r)
                        fetch(i, s).then(function(e) {
                            return e.json()
                        }).then(function(e) {
                            if (a) {
                                var i = e.extensions ? e.extensions.context : null;
                                a.call(t, e.data, i)
                            }
                        });
                    else {
                        var o = await this.fetchProductData(n)
                          , l = o.productData
                          , u = o.allVariants
                          , d = o.context;
                        l && (l.variants = {
                            nodes: [].concat(_toConsumableArray(u))
                        },
                        a && a.call(this, {
                            product: l
                        }, d))
                    }
            }
        }, {
            key: "regenerateSwatches",
            value: function(t) {
                var a = t.target;
                if (a.getAttribute("swatch-generated") != a.getAttribute("sa-groups-generated")) {
                    var i = a.querySelector("variant-swatch-king");
                    i && i.remove(),
                    a.setAttribute("swatch-generated", "none"),
                    setTimeout(function() {
                        new e("collections",a,null).initialize()
                    }, 100)
                }
            }
        }, {
            key: "initialize",
            value: function() {
                var e = this;
                if ($("Hey! I have started working with setting - " + this.themeCode),
                !this.eventsRegistered) {
                    var t = function() {
                        var t = ["click", "change", "virtual_click", "keyup"];
                        e.isInstanceTypeCollection() && F.switch_on_hover && (t.push("mouseover"),
                        t.push("mouseout"));
                        var a = e.getCorrectSwatchRoot()
                          , i = null;
                        if (e.isInstanceTypeProduct() && e.groupsDisplaySelector && (i = e.getCorrectSwatchRoot("groups")),
                        !a && !i)
                            return setTimeout(e.initialize.bind(e), 250),
                            {
                                v: undefined
                            };
                        Object.entries(t).forEach(function(t) {
                            var n = _slicedToArray(t, 2)
                              , r = n[0]
                              , s = n[1];
                            "length" != r && (a && a.addEventListener(s, e.generateUISwitch()),
                            i ? i.addEventListener(s, e.generateUISwitch()) : e.groupsDisplaySelector = null)
                        }),
                        window.addEventListener("resize", function() {
                            if (this.isInstanceTypeCollection()) {
                                var e = this.currentDocument.querySelector("div.swatches-type-collections");
                                if (e) {
                                    var t = e.parentNode.parentNode;
                                    e.style.width = t.offsetWidth + "px"
                                }
                            }
                        }
                        .bind(e)),
                        e.eventsRegistered = !0,
                        e.generateProductGroups(),
                        document.addEventListener("vkcl:product:changed", e.regenerateSwatches)
                    }();
                    if ("object" == typeof t)
                        return t.v
                }
                !p && this.isInstanceTypeCollection() && (this.hideFormElements(this.getInstanceConfig().selectors_to_hide, !1),
                p = !0),
                d || (window.document.addEventListener("click", function(e) {
                    for (var t = e.target; t.hasAttribute("swatch-inside"); )
                        t = t.parentNode;
                    for (var a = document.querySelectorAll("ul.swatch-drop-down-list:not(.swatch-hide)"), i = 0; i < a.length; i++) {
                        var n = a[i]
                          , r = n.parentNode.querySelector('[type="select"]');
                        t != r && (r.setAttribute("aria-expanded", !1),
                        n.classList.add("swatch-hide"))
                    }
                }),
                d = !0),
                $("Generating swatch UI..."),
                this.generateUISwitch()()
            }
        }, {
            key: "readyToInit",
            value: function() {
                return null != this.productInfoTree.getTree()
            }
        }, {
            key: "detectAndInitialize",
            value: function() {
                var e = !(arguments.length <= 0 || arguments[0] === undefined) && arguments[0]
                  , t = null
                  , a = null;
                this.clientSpecs.getThemeType() && "" != this.clientSpecs.getThemeType() && (t = this.clientSpecs.getThemeType()),
                this.clientSpecs.getSelectors().option_selectors && "" != this.clientSpecs.getSelectors().option_selectors.trim() && (a = this.clientSpecs.getSelectors().option_selectors),
                this.hasOnlySingleVariant && Q() && e && (t = "motion",
                a = '[name="id"]');
                var i = [{
                    theme_type: "common",
                    option_selector: 'select[class*="single-option-selector"]',
                    hide_elements: 'select.single-option-selector, select[id*="SingleOptionSelector"]'
                }, {
                    theme_type: "common",
                    option_selector: 'select[id*="SingleOptionSelector"]',
                    hide_elements: 'select.single-option-selector, select[id*="SingleOptionSelector"]'
                }, {
                    theme_type: "common",
                    option_selector: ".option-selectors select",
                    hide_elements: ".option-selectors"
                }, {
                    theme_type: "common",
                    option_selector: ".option-values select",
                    hide_elements: ".option-values.option-values-select .form-element-wrapper"
                }, {
                    theme_type: "dawn",
                    option_selector: 'select[class*="single-option-selector"]',
                    hide_elements: 'select.single-option-selector, select[id*="SingleOptionSelector"]'
                }, {
                    theme_type: "dawn",
                    option_selector: 'select[id*="SingleOptionSelector"]',
                    hide_elements: 'select.single-option-selector, select[id*="SingleOptionSelector"]'
                }, {
                    theme_type: "dawn",
                    option_selector: ".option-selectors select",
                    hide_elements: ".option-selectors"
                }, {
                    theme_type: "dawn",
                    option_selector: ".option-values select",
                    hide_elements: ".option-values.option-values-select .form-element-wrapper"
                }, {
                    theme_type: "dawn",
                    option_selector: ".single-option-radio input.single-option-selector__radio",
                    hide_elements: ".radio-wrapper.js, form .radio-wrapper"
                }, {
                    theme_type: "dawn",
                    option_selector: ".single-option-radio input.single-option-selector-product-template",
                    hide_elements: ".radio-wrapper.js, form .radio-wrapper"
                }, {
                    theme_type: "dawn",
                    option_selector: 'form input[class*="variant__input"]',
                    hide_elements: "form .variant-wrapper.variant-wrapper--button.js, form .variant-wrapper .variant-input-wrap, form .variant-wrapper .variant__label"
                }, {
                    theme_type: "prestige",
                    option_selector: 'input[data-option-position][type="radio"], button[data-option-position][type="button"], div[data-option-position][data-option-value]',
                    hide_elements: 'form[action*="/cart/add"] .ProductForm__Option, form[action*="/cart/add"] .product-form__option'
                }, {
                    theme_type: "dawn",
                    option_selector: 'form[action*="/cart/add"] .form-options .form-field-select[data-product-option]',
                    hide_elements: 'form[action*="/cart/add"] .form-field.form-options'
                }, {
                    theme_type: "dawn",
                    option_selector: "variant-radios input",
                    hide_elements: "variant-radios"
                }, {
                    theme_type: "dawn",
                    option_selector: "fieldset.variants-ui__radios input.option-value-input",
                    hide_elements: "fieldset.variants-ui__radios"
                }, {
                    theme_type: "motion",
                    option_selector: "select.product-single__variants",
                    hide_elements: "noelement"
                }]
                  , n = null
                  , r = !!t;
                if (!!a) {
                    if (!this.currentDocument.querySelector(a))
                        throw $("option_selectors is defined and selector was not found!"),
                        "SelectorNotFoundException";
                    n = {
                        theme_type: r ? t : "common",
                        option_selector: a,
                        hide_elements: "noelement"
                    }
                } else
                    for (var s = 0; s < i.length; s++) {
                        var o = i[s];
                        if (r) {
                            if (o.theme_type != t)
                                continue;
                            $("theme_type(" + t + ") is defined, Looking for its selector...")
                        }
                        if (this.currentDocument.querySelector(o.option_selector)) {
                            n = o;
                            break
                        }
                        if (s == i.length - 1)
                            throw "SelectorNotFoundException"
                    }
                if (!n)
                    throw "SelectorNotFoundException";
                this.getCorrectSwatchRoot() ? (this.themeSupportConfig = {
                    option_selector: n.option_selector,
                    hide_elements: n.hide_elements + ", " + n.option_selector,
                    deferred: !!n.deferred,
                    key_mapping: {},
                    index_strategy: null
                },
                this.clientSpecs.getProductSettings().init_deferred && (this.themeSupportConfig.deferred = this.clientSpecs.getProductSettings().init_deferred),
                this.themeCode = n.theme_type,
                "" != this.clientSpecs.getSelectors().selectors_to_hide_override ? this.hideFormElements(this.clientSpecs.getSelectors().selectors_to_hide_override, !1) : (this.hideFormElements(this.themeSupportConfig.hide_elements, "common" == this.themeCode),
                this.hideFormElements(this.clientSpecs.getSelectors().selectors_to_hide, !1)),
                this.preInitialize()) : console.log("Swatch King:", "We cannot find any swatch display location, please get in touch with us at support@starapps.studio")
            }
        }, {
            key: "preInitialize",
            value: function() {
                !this.themeSupportConfig.deferred || Q() ? this.initialize() : setTimeout(this.preInitialize.bind(this), 250)
            }
        }, {
            key: "onInstanceActivate",
            value: function() {
                var e = this
                  , t = 0
                  , a = setInterval(function() {
                    try {
                        if (e.readyToInit()) {
                            $("Starting operations...");
                            var i = t > 0;
                            e.detectAndInitialize(i),
                            Y(a)
                        } else
                            e.productUndefined && ($("Product not found!"),
                            Y(a))
                    } catch (n) {
                        $(["Loading Failed... Retrying.", n]),
                        Q() && t >= 3 ? Y(a) : Q() && "SelectorNotFoundException" == n && t++
                    }
                }, 250)
            }
        }]),
        e
    }()
      , G = function() {
        function e() {
            _classCallCheck(this, e),
            this.tree = null,
            this.options = null,
            this.variants = null,
            this.variantsKeys = null,
            this.productInfo = null,
            this.priceInfoTree = null
        }
        return _createClass(e, [{
            key: "getVariantInfoFromOptions",
            value: function(e) {
                for (var t = Object.keys(e), a = this.getVariantsKeys() || [], i = this.getVariants() || [], n = !1, r = null, s = 0; s < a.length; s++) {
                    for (var o = i[a[s]], l = !0, c = 0; c < t.length; c++) {
                        if (e[t[c]] != o.options[c]) {
                            l = !1;
                            break
                        }
                        n = !0,
                        r = o
                    }
                    if (l)
                        return o
                }
                return n ? r : null
            }
        }, {
            key: "getNodeByOptions",
            value: function(e, t, a) {
                for (var i = this.tree, n = null, r = {}, s = Object.keys(e), o = 0; o < s.length; o++) {
                    var l = s[o]
                      , c = !1;
                    if (i[l] != undefined) {
                        i = i[l];
                        for (var u = 0; u < i.length; u++) {
                            r[l] == undefined && (r[l] = {
                                available_count: 0,
                                data: [],
                                name: i[u].name,
                                untranslated_name: i[u].untranslated_name,
                                view_type_preset: i[u].view_type_preset
                            });
                            var d = {
                                value: i[u].value,
                                option_value_id: i[u].option_value_id,
                                original_value: i[u].original_value,
                                untranslated_value: i[u].untranslated_value
                            };
                            i[u].featured_image != undefined && (d.featured_image = i[u].featured_image),
                            i[u].available != undefined && (d.available = i[u].available,
                            d.available && (r[l].available_count += 1)),
                            i[u].min_price != undefined && i[u].max_price != undefined && (i[u].min_price == i[u].max_price ? d.price = a(t, i[u].min_price) : d.price = a(t, i[u].min_price) + "+"),
                            d.min_compare_at_price = i[u].compare_at_price ? parseFloat(i[u].compare_at_price.amount) : 0,
                            d.min_price = parseFloat(i[u].min_price),
                            r[l].data.push(d),
                            i[u].value == e[l] || i[u].option_value_id == e[l] ? (n = i[u],
                            c = !0) : c || u != i.length - 1 || (n = i[0])
                        }
                        i = n
                    }
                }
                return r
            }
        }, {
            key: "getTree",
            value: function() {
                return this.tree
            }
        }, {
            key: "getOptions",
            value: function() {
                return this.options || []
            }
        }, {
            key: "getOptionNameByKey",
            value: function(e) {
                for (var t = 0; t < this.options.length; t++) {
                    if ("option" + (t + 1) == e)
                        return this.options[t].name
                }
                return ""
            }
        }, {
            key: "getOptionValueByOptionId",
            value: function(e) {
                for (var t = 0; t < this.options.length; t++)
                    if (this.options[t].optionValues) {
                        var a = this.options[t].optionValues.find(function(t) {
                            return t.id == "gid://shopify/ProductOptionValue/" + e
                        });
                        if (a)
                            return a.name
                    }
                return e
            }
        }, {
            key: "getOptionKeyByName",
            value: function(e, t, a, i) {
                for (var n = RegExp("(?:(?:optio.*?\\D)([0-3])(?:\\D|$))|(?:^([0-3])$)|(?:\\D([0-3])$)|(?:^([0-3])\\D)|(?:\\D([0-3])\\D)", "gi"), r = null, s = 5, o = s, l = null; null !== (l = n.exec(e)); ) {
                    l.index === n.lastIndex && n.lastIndex++;
                    for (var c = 1; c <= s; c++)
                        l[c] && c <= o && (r = l[c],
                        o = c)
                }
                var u = null;
                for (c = 0; c < this.options.length; c++) {
                    var d = this.options[c]
                      , p = d.name;
                    if (r) {
                        var h = parseInt(r)
                          , g = o < 4;
                        if (a && g && "zeroed" == a) {
                            u = "option" + (h + 1);
                            break
                        }
                        if (a && g) {
                            u = "option" + h;
                            break
                        }
                        for (var f = "storefront" == S ? d.optionValues : d.values, v = 0; v < f.length; v++) {
                            var m = f[v]
                              , _ = !1;
                            if ("storefront" == S) {
                                var y = m.id.split("/ProductOptionValue/")[1];
                                _ = t == i(m.name) || t == y
                            } else
                                _ = t == i(m);
                            if (_) {
                                g ? c == h ? (a = "zeroed",
                                u = "option" + (h + 1)) : (a = "oned",
                                u = "option" + h) : u = "option" + (c + 1);
                                break
                            }
                        }
                    } else if (!this.options[c].is_iterated) {
                        var w = p.replace(RegExp("(?:\\[|\\]|\\(|\\)|\\+|\\$)", "gi"), "\\$&{0,1}");
                        if (w = w.replace(RegExp("\\s", "gi"), "[\\s\\+\\-]{0,1}"),
                        RegExp("(?:" + w + ")", "gi").exec(e)) {
                            for (f = "storefront" == S ? d.optionValues : d.values,
                            v = 0; v < f.length; v++) {
                                m = f[v],
                                _ = !1;
                                if ("storefront" == S) {
                                    y = m.id.split("/ProductOptionValue/")[1];
                                    _ = t == i(m.name) || t == y
                                } else
                                    _ = t == i(m);
                                if (_) {
                                    u = "option" + (c + 1),
                                    this.options[c].is_iterated = !0;
                                    break
                                }
                            }
                            if (u)
                                break
                        }
                    }
                }
                return [u, a]
            }
        }, {
            key: "getVariants",
            value: function() {
                return this.variants
            }
        }, {
            key: "getVariantsKeys",
            value: function() {
                return this.variantsKeys
            }
        }, {
            key: "getProductInfo",
            value: function() {
                return this.productInfo
            }
        }, {
            key: "getUntranslatedProductHandle",
            value: function() {
                return this.productInfo.untranslated_handle
            }
        }, {
            key: "setProductInfo",
            value: function(e) {
                this.productInfo = e
            }
        }, {
            key: "getPriceInfoTree",
            value: function() {
                return this.priceInfoTree
            }
        }, {
            key: "getVariantByVariantId",
            value: function(e) {
                return this.variants[e]
            }
        }, {
            key: "setValues",
            value: function(e, t, a, i) {
                this.tree = e,
                this.options = t,
                this.variants = a,
                this.variantsKeys = Object.keys(a),
                this.priceInfoTree = i
            }
        }]),
        e
    }()
      , J = function() {
        function e() {
            _classCallCheck(this, e),
            this.app_setting = y.app_setting,
            this.app_setting_styles = y.app_setting_styles,
            this.app_setting_config = y.app_setting_config,
            this.theme_setting = w,
            this.options = y.product_options,
            this.presets = y.presets,
            this.presetsMap = {},
            this.default_language = y.primary_locale,
            this.default_currency = y.currency,
            this.lambda_cloudfront_url = y.lambda_cloudfront_url,
            this.data_url_source = y.data_url_source,
            this.localized_strings = y.localized_string,
            this.storefront_access_token = y.storefront_key
        }
        return _createClass(e, [{
            key: "getGroupsEnableStatusForProductType",
            value: function() {
                return (k || I || C || E || O || P || M) && this.app_setting_config.product_template.group_swatches
            }
        }, {
            key: "getVariantsEnableStatusForProductType",
            value: function() {
                return (k || I || C || E || O || P || M) && this.app_setting_config.product_template.variant_swatches
            }
        }, {
            key: "getEnableStatusForProductGridType",
            value: function() {
                return A || T || x || D || L || N || q
            }
        }, {
            key: "getSwatchPresentation",
            value: function(e) {
                return this.app_setting_styles[e + "_swatch_presentation"]
            }
        }, {
            key: "getViewStyle",
            value: function(e) {
                return this.app_setting_styles[e]
            }
        }, {
            key: "getViewDefault",
            value: function(e) {
                var t = this
                  , a = "products" == e
                  , i = a ? this.presets[this.app_setting.default_preset] : undefined;
                return void 0 === i && a ? Object.entries(this.presets).forEach(function(a) {
                    var n = _slicedToArray(a, 2)
                      , r = n[0]
                      , s = n[1];
                    "button" == s.assoc_view_type && s.apply_to == e && (t.app_setting.default_preset = r,
                    i = s)
                }) : "collections" == e && (i = this.getHiddenPreset()),
                i
            }
        }, {
            key: "getSelectors",
            value: function() {
                return this.theme_setting.configurations.products
            }
        }, {
            key: "getProductSettings",
            value: function() {
                return this.theme_setting.settings.products
            }
        }, {
            key: "getHandleize",
            value: function() {
                return this.theme_setting.settings.products.handleize
            }
        }, {
            key: "getThemeType",
            value: function() {
                return this.theme_setting.configurations.products.theme_type
            }
        }, {
            key: "getStyles",
            value: function() {
                return this.app_setting_styles
            }
        }, {
            key: "getHiddenPreset",
            value: function() {
                return {
                    assoc_view_type: "hidden"
                }
            }
        }, {
            key: "getViewTypeByGroup",
            value: function(e, t) {
                var a = null;
                if ("products" == t)
                    a = this.presets[e.products_preset_id];
                else if ("collections" == t) {
                    var i = e.collections_preset_id;
                    a = null == i || "0" == i.toString() ? this.getHiddenPreset() : this.presets[i]
                }
                return void 0 !== a ? Object.assign({
                    products_swatch: e.products_swatch,
                    collections_swatch: e.collections_swatch
                }, a) : Object.assign({
                    products_swatch: e.products_swatch,
                    collections_swatch: e.collections_swatch
                }, this.getViewDefault(t))
            }
        }, {
            key: "getViewTypeByOptionName",
            value: function(e, t) {
                if ("undefined" != typeof this.presetsMap[e])
                    return this.presetsMap[e];
                for (var a = this.getViewDefault(t), i = null, n = 0; n < this.options.length; n++) {
                    var r = this.options[n]
                      , s = null;
                    if ("products" == t)
                        s = this.presets[r.products_preset_id];
                    else if ("collections" == t) {
                        var o = r.collections_preset_id;
                        s = null == o || "0" == o.toString() ? this.getHiddenPreset() : this.presets[o]
                    }
                    s = void 0 !== s ? Object.assign({
                        trigger_action: r.trigger_action,
                        products_swatch: r.products_swatch,
                        collections_swatch: r.collections_swatch
                    }, s) : Object.assign({
                        trigger_action: r.trigger_action
                    }, a),
                    this.presetsMap[r.name] = s,
                    this.options[n].name == e && (i = s)
                }
                return i || a
            }
        }, {
            key: "getTriggerActionByOptionName",
            value: function(e) {
                if ("undefined" != typeof this.presetsMap[e])
                    return this.presetsMap[e].trigger_action;
                for (var t = 0; t < this.options.length; t++)
                    if (this.presetsMap[this.options[t].name] = this.options[t],
                    this.options[t].name == e)
                        return this.options[t].trigger_action;
                return "auto"
            }
        }, {
            key: "getOptions",
            value: function() {
                return this.options || []
            }
        }, {
            key: "getCustomStyle",
            value: function() {
                if ("" != this.theme_setting.custom_css || "" != this.getSizeChartConfig().size_chart_app_css)
                    return '<style type="text/css" app="vsk" role="custom-css">' + this.theme_setting.custom_css + " " + this.getSizeChartConfig().size_chart_app_css + "</style>"
            }
        }, {
            key: "getCustomScripts",
            value: function() {
                var e = this.theme_setting.custom_scripts;
                if (0 != e.length) {
                    for (var t = "", a = 0; a < e.length; a++)
                        t += e[a].script;
                    return t
                }
            }
        }, {
            key: "getDoNotSelectAnOption",
            value: function() {
                return this.app_setting_config.do_not_select_an_option
            }
        }, {
            key: "getAllOptionsData",
            value: function() {
                return {
                    variantId: null
                }
            }
        }, {
            key: "getDisplayLogs",
            value: function() {
                return this.app_setting.display_logs
            }
        }, {
            key: "getCollectionConfig",
            value: function() {
                return this.theme_setting.configurations.collections
            }
        }, {
            key: "getCollectionSettings",
            value: function() {
                return this.theme_setting.settings.collections
            }
        }, {
            key: "getCustomButtonParams",
            value: function() {
                return this.theme_setting.configurations.products.custom_button_params
            }
        }, {
            key: "getAppExecutionStrategy",
            value: function() {
                return this.app_setting_config.app_execution_strategy
            }
        }, {
            key: "getProductOptionsDisabled",
            value: function() {
                return this.app_setting_config.products_options_disabled
            }
        }, {
            key: "getCollectionsOptionsDisabled",
            value: function() {
                return this.app_setting_config.collections_options_disabled
            }
        }, {
            key: "getDefaultSwatchImage",
            value: function() {
                return this.app_setting_config.default_swatch_image
            }
        }, {
            key: "getPersistGroupVariant",
            value: function() {
                return this.theme_setting.settings.products.persist_group_variant
            }
        }, {
            key: "getCollectionPreselectVariant",
            value: function() {
                return F.preselect_variant
            }
        }, {
            key: "hideSingleValueOption",
            value: function(e) {
                return this.theme_setting.settings[e].hide_single_value_option
            }
        }, {
            key: "getSizeChartSelector",
            value: function() {
                return this.getAllSizeChartSelectors()
            }
        }, {
            key: "getAllSizeChartSelectors",
            value: function() {
                var e = this.getSizeChartConfig().size_chart_app_selector.split(",").filter(Boolean)
                  , t = this.theme_setting.settings.products.size_chart_selector.split(",").filter(Boolean);
                return [].concat(_toConsumableArray(new Set([].concat(_toConsumableArray(e), _toConsumableArray(t))))).join(",")
            }
        }, {
            key: "getSizeChartConfig",
            value: function() {
                return this.app_setting_config.size_chart
            }
        }, {
            key: "getNoTranslate",
            value: function() {
                return !!this.app_setting_config.notranslate
            }
        }, {
            key: "getLocalizedStrings",
            value: function() {
                return this.localized_strings
            }
        }, {
            key: "getSwatchUrlSource",
            value: function() {
                return this.app_setting.swatch_url_source
            }
        }, {
            key: "getDataUrlSource",
            value: function() {
                return this.data_url_source
            }
        }, {
            key: "getLambdaCloudFrontUrl",
            value: function() {
                return this.lambda_cloudfront_url
            }
        }, {
            key: "getSwatchUrlHost",
            value: function() {
                return "cdn" == this.app_setting.swatch_url_source ? "cdn.starapps.studio/v2" : "media-cdn.starapps.studio"
            }
        }, {
            key: "getDefaultCurrency",
            value: function() {
                return this.default_currency
            }
        }, {
            key: "getDefaultLanguage",
            value: function() {
                return this.default_language
            }
        }, {
            key: "getHistoryFreeGroupNavigation",
            value: function() {
                return this.app_setting_config.history_free_group_navigation
            }
        }, {
            key: "getPresetBadgeOrder",
            value: function(e) {
                return y.app_setting_config.preset_badge.order.find(function(t) {
                    return t.name == e
                }).order
            }
        }, {
            key: "getPresetBadgeOrderList",
            value: function() {
                return y.app_setting_config.preset_badge.order.sort(function(e, t) {
                    return e.order - t.order
                }).map(function(e) {
                    return e.name
                })
            }
        }]),
        e
    }()
      , K = function() {
        function e(t, a, i, n) {
            _classCallCheck(this, e),
            this.instanceType = t,
            this.clientSpecs = a,
            this.currentDocument = i,
            this.storeSlug = window.Shopify.shop.split(".myshopify.com")[0],
            this.swatchDir = y.swatch_dir,
            this.preservedState = {},
            this.defaultFeaturedImage = null,
            this.viewTypes = null,
            this.isSwatchRootDisplayed = {
                options: !1,
                groups: !1
            },
            this.selectedSwatches = {},
            this.getTranslation = n
        }
        return _createClass(e, [{
            key: "setPreservedState",
            value: function(e, t, a) {
                "undefined" == typeof this.preservedState[e] && (this.preservedState[e] = {}),
                this.preservedState[e][t] = a
            }
        }, {
            key: "getPreservedState",
            value: function(e, t) {
                if ("undefined" != typeof this.preservedState[e]) {
                    var a = this.preservedState[e];
                    if ("undefined" != typeof a[t])
                        return a[t]
                }
                return null
            }
        }, {
            key: "isInstanceTypeProduct",
            value: function() {
                return "products" == this.instanceType
            }
        }, {
            key: "isInstanceTypeCollection",
            value: function() {
                return "collections" == this.instanceType
            }
        }, {
            key: "getSwatchPresentation",
            value: function() {
                return this.isInstanceTypeProduct() ? this.clientSpecs.getSwatchPresentation("products") : this.isInstanceTypeCollection() ? this.clientSpecs.getSwatchPresentation("collections") : void 0
            }
        }, {
            key: "getSwatchSlideStyleHTML",
            value: function(e) {
                return '<div class="swatch-navigation-wrapper" navigation="' + e + '"><div class="swatch-navigation ' + ("left" == e ? "swatch-navigation-left" : "swatch-navigation-right") + '" data-navigation="' + e + '" role="presentation" tabindex="0">\n        ' + ("left" == e ? this.getLeftNavigationSVG() : this.getRightNavigationSVG()) + "\n        </div></div>"
            }
        }, {
            key: "getRightNavigationSVG",
            value: function() {
                return "" != this.getSwatchPresentation().slide_right_button_svg ? this.getSwatchPresentation().slide_right_button_svg.replace(RegExp("<[a-z]+", "gi"), ' swatch-inside="true"') : '<svg viewBox="0 0 24 24" focusable="false" swatch-inside="true" style="enable-background:new 0 0 477.175 477.175;" xml:space="preserve"><path swatch-inside="true" d="M0 0h24v24H0z" fill="none"></path><path swatch-inside="true" d="M8.59,16.59L13.17,12L8.59,7.41L10,6l6,6l-6,6L8.59,16.59z"></path></svg>'
            }
        }, {
            key: "getLeftNavigationSVG",
            value: function() {
                return "" != this.getSwatchPresentation().slide_left_button_svg ? this.getSwatchPresentation().slide_left_button_svg.replace(RegExp("<[a-z]+", "gi"), ' swatch-inside="true"') : '<svg viewBox="0 0 24 24" focusable="false" swatch-inside="true" style="enable-background:new 0 0 477.175 477.175;" xml:space="preserve"><path swatch-inside="true" d="M0 0h24v24H0z" fill="none"></path><path swatch-inside="true" d="M8.59,16.59L13.17,12L8.59,7.41L10,6l6,6l-6,6L8.59,16.59z"></path></svg>'
            }
        }, {
            key: "getMinifiedHTML",
            value: function(e, t, a) {
                e = this.cvt2HTMLEntities(e);
                var i = this.clientSpecs.getSwatchPresentation("collections").minified_template;
                i = (i = (i = (i = i.replace(RegExp("{count}", "gi"), t)).replace(RegExp("{option_name}", "gi"), e)).replace(RegExp("{product_id}", "gi"), a.id)).replace(RegExp("{product_handle}", "gi"), a.handle);
                var n = g;
                return n && "" != n && (n = n.replace(/\/$/, "")),
                i = i.replace(RegExp("{routes_root}", "gi"), n),
                this.parseHTML('<li class="swatch-view-item swatch-minified-text" orig-value="' + e + '">' + i + "</li>")[0]
            }
        }, {
            key: "parseHTML",
            value: function(e) {
                var t = document.implementation.createHTMLDocument("");
                return t.body.innerHTML = e,
                t.body.children
            }
        }, {
            key: "decodeHTML",
            value: function(e) {
                return (new DOMParser).parseFromString(e, "text/html").documentElement.textContent
            }
        }, {
            key: "setDefaultFeaturedImage",
            value: function(e) {
                var t = this.clientSpecs.getDefaultSwatchImage();
                this.defaultFeaturedImage = t || e
            }
        }, {
            key: "hideElementStyles",
            value: function(e) {
                var t = document.querySelector('style[app="vsk"][role="hide_elements"]')
                  , a = "";
                if ("object" == typeof e || "array" == typeof e)
                    for (var i = 0; i < e.length; i++)
                        a += e[i],
                        i < e.length - 1 && (a += ",");
                else
                    "string" == typeof e && (a = e);
                "" != a.trim() && (t ? t.innerHTML += a + "{display: none!important;}" : (a = '<style type="text/css" app="vsk" role="hide_elements">' + a + "{display: none!important;}</style>",
                document.querySelector("head").appendChild(this.parseHTML(a)[0])))
            }
        }, {
            key: "getStyleProps",
            value: function() {
                if (this.isInstanceTypeCollection()) {
                    var e = this.currentDocument.querySelector("variant-swatch-king").parentNode.getBoundingClientRect().width;
                    return 'style="width: ' + (e ? e + "px" : "100%") + "; z-index: " + this.clientSpecs.getCollectionSettings().layer_index + ';"'
                }
                return ""
            }
        }, {
            key: "getSwatchRoot",
            value: function(e) {
                var t = this.isInstanceTypeProduct() && !!this.clientSpecs.getSizeChartSelector()
                  , a = this.clientSpecs.getSizeChartConfig()
                  , i = "undefined" == typeof window.matchMedia || window.matchMedia("(hover: hover)").matches
                  , n = this.clientSpecs.getNoTranslate()
                  , r = "";
                r += '<div class="swatches swatches-type-' + this.instanceType + " " + (i ? "hover-enabled" : "hover-disabled") + (n ? " notranslate" : "") + '" ' + this.getStyleProps() + '>\n        <div sa-group-position="top"></div><div sa-options-position="default">';
                for (var s = 0; s < e.length; s++) {
                    var o = this.isInstanceTypeProduct() ? 'id="swatch-option' + (s + 1) + '"' : ""
                      , l = "swatch-hide"
                      , c = e[s].untranslated_name ? e[s].untranslated_name : e[s].name;
                    c = this.cvt2HTMLEntities(c.trim());
                    var u = "";
                    t && -1 != a.labels.split(",").indexOf(c) && (u += '<span class="swatch-size-chart"></span>'),
                    "all" == this.clientSpecs.hideSingleValueOption(this.instanceType) && e[s].values.length <= 1 && (l += " option-single-value"),
                    r += "<div " + o + ' option-name="' + c + '" option-target="option' + (s + 1) + '" class="' + l + '">\n            ' + u + "\n            </div>"
                }
                return r += '</div><div sa-group-position="bottom"></div>'
            }
        }, {
            key: "renderSwatchRoot",
            value: function(e, t) {
                var a = this
                  , i = arguments.length <= 2 || arguments[2] === undefined ? "options" : arguments[2];
                if (!this.isSwatchRootDisplayed[i]) {
                    var n, r, s = t.querySelector(".swatches.swatches-type-" + this.instanceType);
                    s && s.querySelector("[option-target]") && s.parentNode.removeChild(s),
                    t.innerHTML = e,
                    this.isInstanceTypeProduct() && (n = a.clientSpecs.getSizeChartConfig(),
                    r = [{
                        type: "size_chart",
                        append_to: "span.swatch-size-chart",
                        element_selector: a.clientSpecs.getSizeChartSelector()
                    }],
                    Object.entries(r).forEach(function(e) {
                        var t, i, r, s = _slicedToArray(e, 2), o = (s[0],
                        s[1]), l = o.append_to, c = o.element_selector;
                        c && (r = a.currentDocument.querySelector(l)) && (t = 5e3,
                        i = setInterval(function() {
                            t -= 250;
                            var e = document.querySelector(c);
                            if (e) {
                                r.appendChild(e);
                                var a = r.parentElement.querySelector("span.swatch-label-container");
                                if (a) {
                                    var s = "size-chart-" + n.position;
                                    a.classList.add(s),
                                    a.appendChild(r)
                                }
                                clearInterval(i)
                            } else
                                t <= 0 && clearInterval(i)
                        }, 250))
                    })),
                    this.isSwatchRootDisplayed[i] = !0
                }
            }
        }, {
            key: "renderNormal",
            value: function(e, t, a) {
                var i = this
                  , n = a.querySelector('[option-target="' + e + '"]')
                  , r = n.querySelector(".swatch-single")
                  , s = n.querySelector(".swatch-size-chart");
                r && (s && n.insertBefore(s, r),
                n.removeChild(r));
                var o = this.parseHTML(t)[0];
                n.appendChild(o),
                n.classList.remove("swatch-hide");
                var l, c, u = n.querySelector("label.swatch-label"), d = n.querySelector(".visually-hidden-label"), p = n.querySelector("legend");
                return this.isInstanceTypeProduct() && (l = i.clientSpecs.getSizeChartConfig(),
                c = [{
                    type: "size_chart",
                    append_to: "span.swatch-size-chart"
                }],
                Object.entries(c).forEach(function(e) {
                    var t = _slicedToArray(e, 2)
                      , a = (t[0],
                    t[1])
                      , n = i.currentDocument.querySelector(a.append_to);
                    if (n) {
                        var r = n.parentElement.querySelector("span.swatch-label-container");
                        if (r) {
                            var s = "size-chart-" + l.position;
                            r.classList.add(s),
                            p.appendChild(d),
                            r.appendChild(u),
                            r.appendChild(n)
                        }
                    }
                })),
                n.querySelectorAll(".swatch-selector")
            }
        }, {
            key: "getFlexibleSize",
            value: function(e) {
                e = parseInt(e.replace("px", ""));
                var t = window.innerWidth
                  , a = t / 500;
                return t >= 992 && (a = .4 * t / 500),
                a = Math.max(a, .75),
                e * (a = Math.min(a, 1.25)) + "px"
            }
        }, {
            key: "getLazyResolution",
            value: function(e, t, a, i) {
                var n = !0;
                "cover" != a && "contain" != a || ("contain" == a && (n = !1),
                a = "100%"),
                a = parseInt(a.replace("%", "")),
                a *= 2;
                var r = "center";
                i && (r = i);
                var s = ""
                  , o = "width=" + parseInt(t[0].replace("px", "")) * (a / 100) + "&height=" + parseInt(t[1].replace("px", "")) * (a / 100) + (n ? "&crop=" + r : "");
                return o = e.includes("?") ? "&" + o : "?" + o,
                e.match(/(\.jpg)(?=$|\?)/gm) && (o += s),
                e + o
            }
        }, {
            key: "getViewByType",
            value: function(e) {
                var t = null
                  , a = {
                    getView: null
                };
                switch (e.assoc_view_type) {
                case "swatch":
                    t = e[this.instanceType + "_swatch"],
                    a.getView = "custom_swatch" == t ? this.getCustomImageView.bind(this, e) : this.getVariantImageView.bind(this, e);
                    break;
                case "drop_down":
                    a.getView = this.getDropDownView.bind(this, e);
                    break;
                case "swatch_drop_down":
                    a.getView = this.getDropDownViewCustom.bind(this, e);
                    break;
                case "button":
                    a.getView = this.getButtonView.bind(this, e);
                    break;
                case "hidden":
                    a.getView = this.getHiddenView.bind(this, e)
                }
                return a
            }
        }, {
            key: "cvt2HTMLEntities",
            value: function(e) {
                return e.replace(/&/g, "&amp;").replace(/>/g, "&gt;").replace(/</g, "&lt;").replace(/"/g, "&quot;")
            }
        }, {
            key: "displayLabel",
            value: function() {
                var e = arguments.length <= 0 || arguments[0] === undefined ? null : arguments[0];
                return this.isInstanceTypeCollection() ? this.clientSpecs.getCollectionSettings().display_label : !e || !e.params || e.params.display_label === undefined || e.params.display_label
            }
        }, {
            key: "isValueMorphed",
            value: function() {
                return !!this.clientSpecs.getHandleize()
            }
        }, {
            key: "isASwatch",
            value: function(e) {
                return "swatch" == e || "swatch_drop_down" == e
            }
        }, {
            key: "displayAlignment",
            value: function() {
                var e = arguments.length <= 0 || arguments[0] === undefined ? "swatch-view-stack" : arguments[0];
                return this.isInstanceTypeCollection() ? "swatch-view-stack" == e ? "swatch-align-" + F.alignment : "swatch-slider-align-" + F.alignment : ""
            }
        }, {
            key: "getImageType",
            value: function(e, t) {
                var a = undefined;
                return (a = ["second_product_image", "second_variant_image"].includes(t) ? e.secondary_src : ["last_product_image", "last_variant_image"].includes(t) ? e.last_src : e.src) || (a = e.src),
                a
            }
        }, {
            key: "getImageSrc",
            value: function(e, t, a) {
                var i = null;
                return this.isInstanceTypeCollection() ? i = this.getImageType(e, a) : this.isInstanceTypeProduct() && (i = this.getImageType(e, t)),
                i
            }
        }, {
            key: "getVariantImageView",
            value: function(e, t, a) {
                var i = window.matchMedia ? window.matchMedia("screen and (max-width: 480px)") : screen.width <= 480
                  , n = "swatch-view-" + e.params.swatch_style
                  , r = this.isAllNewPreset(a);
                i.matches && (n = "swatch-view-" + e.params.mobile_swatch_style);
                var s = "undefined" != typeof a.product_group_index
                  , o = s ? 'data-group-index="' + a.product_group_index + '"' : ""
                  , l = '<div class="swatch-single swatch-preset-' + e.id + " " + n + '" ' + o + "><fieldset>";
                l += '<legend><label class="swatch-label swatch-label-image ' + (this.displayLabel(e) ? "" : "star-hide") + '">\n            <input type="checkbox" name="' + this.cvt2HTMLEntities(a.name) + '" value="true" checked="checked" />\n            <span class="swatch-option-name">' + a.name + "</span>\n            " + (e.params.display_variant_label ? '<span class="swatch-variant-name"></span>' : "") + "\n            </label></legend>",
                l += '<span class="swatch-label-container"><label class="visually-hidden-label"><span class="swatch-option-name">' + a.name + "</span></label></span>",
                "swatch-view-slide" == n && (l += '<div class="swatch-navigable-wrapper">',
                l += '<div class="swatch-navigable">',
                l += this.getSwatchSlideStyleHTML("left"));
                var c = "tooltip" == e.params.option_value_display
                  , u = this.isInstanceTypeCollection() ? "32px" : "80px"
                  , d = this.isInstanceTypeCollection() ? "32px" : "80px";
                l += '<ul class="swatch-view swatch-view-image' + (c ? " swatch-with-tooltip" : "") + " " + this.displayAlignment(n) + '" role="radiogroup">';
                for (var p = e.params.width || e.params.swatch_size || u, h = e.params.height || e.params.swatch_size || d, g = 0; g < a.data.length; g++) {
                    var f = this.cvt2HTMLEntities(a.data[g].value)
                      , v = a.data[g].option_value_id
                      , m = f
                      , _ = 1 == a.data[g].available;
                    this.isValueMorphed() && (m = this.cvt2HTMLEntities(a.data[g].original_value));
                    var y = s && a.data[g].selected;
                    if (!("invisible" == e.params.stock_out_type && 0 != a.available_count && !_) || y) {
                        l += '<li class="swatch-view-item' + (_ ? "" : " swatch-item-unavailable") + '" orig-value="' + f + '" ' + (v ? 'option-value-id="' + v + '"' : "") + ' aria-label="' + f + (_ ? "" : " - Sold Out") + '" role="radio" ' + (s && a.data[g].selected ? 'aria-checked="true"' : 'aria-checked="false"') + ' tabindex="0">',
                        l += '<div class="swatch-image ' + (s ? "swatch-group-selector" : "swatch-selector") + '" type="image" data-value="' + m + '" orig-value="' + f + '" ' + (v ? 'option-value-id="' + v + '"' : "") + " " + (s ? 'swatch-url="' + a.data[g].url + '" ' : "") + 'swatch-option="' + t + '"' + (s && a.data[g].selected ? ' current-product="true"' : "") + ">";
                        var w = this.defaultFeaturedImage
                          , b = a.data[g].featured_image;
                        b != undefined && (w = this.getImageSrc(b, e.products_swatch, e.collections_swatch));
                        var S = w && "none" != w;
                        S && ($("Requested background image with URL(" + w + ")"),
                        w = this.getLazyResolution(w, [p, h], e.params.background_size, e.params.background_position)),
                        l += '<div style="width:' + p + ";height:" + h + ";background-image:url(" + w + ');" class="star-set-image" swatch-inside="true">',
                        l += this.renderBadge(e, a.data[g], r),
                        l += '<i class="hidden"></i></div>';
                        var k = "adjacent" == e.params.option_value_display;
                        if (l += '<div class="' + (k ? "swatch-img-text-adjacent" : "swatch-img-text") + (!k && S ? " swatch-img-text-hidden" : "") + '" swatch-inside="true"><p swatch-inside="true">' + m + "</p></div>",
                        e.params.price_badge) {
                            var A = !!e.params.price_badge.price_enabled;
                            (!s || s && 1 == a.show_price && !V) && (l += '<div class="' + (A ? "swatch-price-adjacent" : "swatch-price-hidden") + '" swatch-inside="true"><span swatch-inside="true">' + a.data[g].price + "</span></div>")
                        }
                        l += "</div>",
                        c && (l += '<div class="swatch-tool-tip">\n                <span class="swatch-tool-tip-text">' + m + '</span>\n                </div>\n                <div class="swatch-tool-tip-pointer"></div>'),
                        l += "</li>"
                    }
                }
                return l += "</ul>",
                "swatch-view-slide" == n && (l += this.getSwatchSlideStyleHTML("right"),
                l += "</div></div>"),
                l += "</fieldset></div>"
            }
        }, {
            key: "generateChecksum",
            value: function(e) {
                var t = e.length
                  , a = undefined
                  , i = "";
                if (0 === t)
                    return 0;
                for (e = e.replace(new RegExp("\n\ts"), ""),
                a = 0; a < t; a++)
                    i += e.charCodeAt(a) + "";
                return i
            }
        }, {
            key: "getResizeValue",
            value: function(e, t) {
                e = e.split("px")[0],
                t = t.split("px")[0];
                var a = 2 * Math.max(e, t);
                return a <= 50 ? 50 : a >= 300 ? 300 : 100 * Math.ceil(a / 100)
            }
        }, {
            key: "getSwatchImageURL",
            value: function(e, t) {
                for (var a = [{
                    char: "!",
                    replacer: "~21"
                }, {
                    char: "*",
                    replacer: "~2A"
                }, {
                    char: "'",
                    replacer: "~92"
                }, {
                    char: "(",
                    replacer: "~28"
                }, {
                    char: ")",
                    replacer: "~29"
                }, {
                    char: ";",
                    replacer: "~3B"
                }, {
                    char: ":",
                    replacer: "~3A"
                }, {
                    char: "@",
                    replacer: "~40"
                }, {
                    char: "&",
                    replacer: "~26"
                }, {
                    char: "=",
                    replacer: "~3D"
                }, {
                    char: "+",
                    replacer: "~2B"
                }, {
                    char: "$",
                    replacer: "~24"
                }, {
                    char: ",",
                    replacer: "~2C"
                }, {
                    char: "/",
                    replacer: "~2F"
                }, {
                    char: "\\",
                    replacer: "~5C"
                }, {
                    char: "?",
                    replacer: "~3F"
                }, {
                    char: "%",
                    replacer: "~25"
                }, {
                    char: "#",
                    replacer: "~23"
                }, {
                    char: "[",
                    replacer: "~5B"
                }, {
                    char: "]",
                    replacer: "~5D"
                }, {
                    char: "{",
                    replacer: "~7B"
                }, {
                    char: "}",
                    replacer: "~7D"
                }, {
                    char: '"',
                    replacer: "~22"
                }, {
                    char: "<",
                    replacer: "~3C"
                }, {
                    char: ">",
                    replacer: "~3E"
                }, {
                    char: "|",
                    replacer: "~7C"
                }, {
                    char: "`",
                    replacer: "~60"
                }, {
                    char: "^",
                    replacer: "~5E"
                }, {
                    char: ".",
                    replacer: "~2E"
                }], i = 0; i < a.length; i++) {
                    var n = a[i];
                    e = e.replace(RegExp("\\" + n.char, "gi"), n.replacer),
                    t = t.replace(RegExp("\\" + n.char, "gi"), n.replacer)
                }
                return e = encodeURIComponent(e),
                t = encodeURIComponent(t),
                "cdn" == this.clientSpecs.getSwatchUrlSource() && (e = encodeURIComponent(e),
                t = encodeURIComponent(t)),
                "https://" + this.clientSpecs.getSwatchUrlHost() + "/apps/" + this.swatchDir + "/" + this.storeSlug + "/swatches/" + e + "/" + t + ".media"
            }
        }, {
            key: "getCustomImageView",
            value: function(e, t, a) {
                var i = window.matchMedia ? window.matchMedia("screen and (max-width: 480px)") : screen.width <= 480
                  , n = "swatch-view-" + e.params.swatch_style;
                i.matches && (n = "swatch-view-" + e.params.mobile_swatch_style);
                var r = "undefined" != typeof a.product_group_index
                  , s = r ? 'data-group-index="' + a.product_group_index + '"' : ""
                  , o = '<div class="swatch-single swatch-preset-' + e.id + " " + n + '" ' + s + "><fieldset>";
                o += '<legend><label class="swatch-label swatch-label-custom-image ' + (this.displayLabel(e) ? "" : "star-hide") + '">\n            <input type="checkbox" name="' + this.cvt2HTMLEntities(a.name) + '" value="true" checked="checked" />\n            <span class="swatch-option-name">' + a.name + "</span>\n            " + (e.params.display_variant_label ? '<span class="swatch-variant-name"></span>' : "") + "\n            </label></legend>",
                o += '<span class="swatch-label-container"><label class="visually-hidden-label"><span class="swatch-option-name">' + a.name + "</span></label></span>",
                "swatch-view-slide" == n && (o += '<div class="swatch-navigable-wrapper">',
                o += '<div class="swatch-navigable">',
                o += this.getSwatchSlideStyleHTML("left"));
                var l = "tooltip" == e.params.option_value_display
                  , c = this.isInstanceTypeCollection() ? "32px" : "80px"
                  , u = this.isInstanceTypeCollection() ? "32px" : "80px";
                o += '<ul class="swatch-view swatch-view-custom-image' + (l ? " swatch-with-tooltip" : "") + " " + this.displayAlignment(n) + '" role="radiogroup">';
                for (var d = e.params.width || e.params.swatch_size || c, p = e.params.height || e.params.swatch_size || u, h = this.getResizeValue(d, p), g = 0; g < a.data.length; g++) {
                    var f = a.data[g].value
                      , v = this.cvt2HTMLEntities(f)
                      , m = a.data[g].option_value_id
                      , _ = v
                      , y = 1 == a.data[g].available
                      , w = this.isAllNewPreset(a);
                    this.isValueMorphed() && (f = a.data[g].original_value,
                    _ = this.cvt2HTMLEntities(f));
                    var b = r && a.data[g].selected;
                    if (!("invisible" == e.params.stock_out_type && 0 != a.available_count && !y) || b) {
                        o += '<li class="swatch-view-item' + (y ? "" : " swatch-item-unavailable") + '" orig-value="' + v + '" ' + (m ? 'option-value-id="' + m + '"' : "") + ' aria-label="' + v + (y ? "" : " - Sold Out") + '" role="radio" ' + (r && a.data[g].selected ? 'aria-checked="true"' : 'aria-checked="false"') + ' tabindex="0">',
                        o += '<div class="swatch-custom-image ' + (r ? "swatch-group-selector" : "swatch-selector") + '" type="image" data-value="' + _ + '" orig-value="' + v + '" ' + (m ? 'option-value-id="' + m + '"' : "") + " " + (r ? 'swatch-url="' + a.data[g].url + '" ' : "") + 'swatch-option="' + t + '"' + (r && a.data[g].selected ? ' current-product="true"' : "") + ">";
                        var S = null;
                        if (r)
                            r && (S = this.getLazyResolution(a.data[g].featured_image.src, [d, p], e.params.background_size, e.params.background_position));
                        else {
                            var k = a.untranslated_name ? a.untranslated_name : a.name
                              , A = a.data[g].untranslated_value ? a.data[g].untranslated_value : f;
                            S = this.getSwatchImageURL(k, A)
                        }
                        if (this.clientSpecs.app_setting_config.use_optimized_urls) {
                            var I = S.split("/");
                            S = I.slice(0, -1).join("/") + "/" + h + "/" + I.pop().replace(".media", ".webp")
                        }
                        if (o += '<div style="width:' + d + ";height:" + p + ";background-image: url(" + S + ');" class="star-set-image" swatch-inside="true">',
                        o += this.renderBadge(e, a.data[g], w),
                        o += '<i class="hidden"></i></div>',
                        o += '<div class="' + ("adjacent" == e.params.option_value_display ? "swatch-img-text-adjacent" : "swatch-img-text swatch-img-text-hidden") + '" swatch-inside="true"><p swatch-inside="true">' + _ + "</p></div>",
                        e.params.price_badge) {
                            var T = !!e.params.price_badge.price_enabled;
                            (!r || r && 1 == a.show_price && !V) && (o += '<div class="' + (T ? "swatch-price-adjacent" : "swatch-price-hidden") + '" swatch-inside="true"><span swatch-inside="true">' + a.data[g].price + "</span></div>")
                        }
                        o += "</div>",
                        l && (o += '<div class="swatch-tool-tip">\n                <span class="swatch-tool-tip-text">' + _ + '</span>\n                </div>\n                <div class="swatch-tool-tip-pointer"></div>'),
                        o += "</li>"
                    }
                }
                return o += "</ul>",
                "swatch-view-slide" == n && (o += this.getSwatchSlideStyleHTML("right"),
                o += "</div></div>"),
                o += "</fieldset></div>"
            }
        }, {
            key: "getButtonView",
            value: function(e, t, a) {
                var i = "undefined" != typeof a.product_group_index
                  , n = i ? ' data-group-index="' + a.product_group_index + '"' : ""
                  , r = window.matchMedia ? window.matchMedia("screen and (max-width: 480px)") : screen.width <= 480
                  , s = "swatch-view-" + e.params.button_style;
                r.matches && (s = "swatch-view-" + e.params.mobile_button_style);
                var o = '<div class="swatch-single swatch-preset-' + e.id + " " + s + '"' + n + "><fieldset>"
                  , l = '<legend><label class="swatch-label swatch-label-button ' + (this.displayLabel() ? "" : "star-hide") + '">\n            <input type="checkbox" name="' + this.cvt2HTMLEntities(a.name) + '" value="true" checked="checked" />\n            <span class="swatch-option-name">' + a.name + "</span>" + (e.params.display_variant_label ? '<span class="swatch-variant-name"></span>' : "") + "\n            </label></legend>"
                  , c = '<span class="swatch-label-container"><label class="visually-hidden-label"><span class="swatch-option-name">' + a.name + "</span></label></span>";
                "inline" !== e.params.label_display_position && (o += l),
                "inline" === e.params.label_display_position && (o += "<div class='inline-label-container'>",
                o += l),
                o += c,
                "swatch-view-slide" == s && (o += '<div class="swatch-navigable-wrapper">',
                o += '<div class="swatch-navigable" ' + (e.params.connected_button ? "data-current-scroll=0" : "") + " >",
                o += this.getSwatchSlideStyleHTML("left")),
                o += '<ul class="swatch-view swatch-view-button ' + (e.params.full_width || e.params.radio_button ? "enable-price-alignment" : "") + "  " + this.displayAlignment(s) + '" role="radiogroup">';
                for (var u = 0; u < a.data.length; u++) {
                    var d = this.cvt2HTMLEntities(a.data[u].value)
                      , p = a.data[u].option_value_id
                      , h = d
                      , g = 1 == a.data[u].available
                      , f = "";
                    0 === u && (f += "first-btn"),
                    u === a.data.length - 1 && (f += " last-btn"),
                    this.isValueMorphed() && (h = this.cvt2HTMLEntities(a.data[u].original_value));
                    var v = i && a.data[u].selected;
                    if (!("invisible" == e.params.stock_out_type && 0 != a.available_count && !g) || v) {
                        if (o += '<li class="swatch-view-item' + (g ? "" : " swatch-item-unavailable") + '" orig-value="' + d + '" ' + (p ? 'option-value-id="' + p + '"' : "") + ' aria-label="' + d + (g ? "" : " - Sold Out") + '" role="radio" ' + (i && a.data[u].selected ? 'aria-checked="true"' : 'aria-checked="false"') + ' tabindex="0">',
                        o += "<div " + (e.params.connected_button ? "data-item-idx=" + u : "") + '   class=" ' + f + " swatch-button " + (i ? " swatch-group-selector" : "swatch-selector") + ' star-set-btn" swatch-option="' + t + '" type="swatch-button" ' + (i ? 'swatch-url="' + a.data[u].url + '" ' : "") + 'data-value="' + h + '" orig-value="' + d + '" ' + (p ? 'option-value-id="' + p + '"' : "") + " " + (i && a.data[u].selected ? ' current-product="true"' : "") + ">",
                        o += "  " + (e.params.radio_button ? "<div swatch-inside='true' class='radio-button-icon'></div>" : ""),
                        o += "  <div swatch-inside='true' class=\"swatch-title-and-icon-container\">",
                        o += '<div class="swatch-button-title-text" swatch-inside="true"><span swatch-inside="true">' + h + "</span></div>",
                        e.params.price_badge) {
                            var m = !!e.params.price_badge.price_enabled;
                            (!i || i && 1 == a.show_price && !V) && (o += '<div swatch-inside="true" class="' + (m ? "swatch-price-adjacent swatch-button-price" : "swatch-button-price-hidden") + '"><span swatch-inside="true">' + a.data[u].price + "</span></div>")
                        }
                        o += "</div>",
                        o += "</div>",
                        o += "</li>"
                    }
                }
                return o += "</ul>",
                "swatch-view-slide" == s && (o += this.getSwatchSlideStyleHTML("right"),
                o += "</div></div>"),
                "inline" === e.params.label_display_position && (o += "</div>"),
                o += "</fieldset></div>"
            }
        }, {
            key: "getDropDownView",
            value: function(e, t, a) {
                var i = "undefined" != typeof a.product_group_index
                  , n = i ? ' data-group-index="' + a.product_group_index + '"' : ""
                  , r = '<div class="swatch-single swatch-preset-' + e.id + ' swatch-view-stack"' + n + "><fieldset>"
                  , s = ""
                  , o = "";
                "default" == e.params.dropdown_type && (r += '<legend><label class="swatch-label swatch-label-drop-down ' + (this.displayLabel(e) ? "" : "star-hide") + '">\n            <input type="checkbox" name="' + this.cvt2HTMLEntities(a.name) + '" value="true" checked="checked" />\n            <span>' + a.name + '<span class="label-seperator">' + e.params.seperator + "</span></span></label></legend>",
                r += '<span class="swatch-label-container"><label class="visually-hidden-label"><span>' + a.name + "</span></label></span>");
                r += '<div class="swatch-drop-down-wrapper ' + this.displayAlignment() + ' swatch-drop-down-custom">',
                r += '<div class="swatch-drop-down-inner ' + ("label_inside" == e.params.dropdown_type ? "swatch-drop-down-label" : "") + '">',
                "label_inside" == e.params.dropdown_type && (r += '<div class="swatch-label-inside"><legend><label class="swatch-label swatch-label-drop-down">\n            <input type="checkbox" name="' + this.cvt2HTMLEntities(a.name) + '" value="true" checked="checked" />\n            <span  >' + a.name + '<span class="label-seperator">' + e.params.seperator + "</span></span></label></legend></div>"),
                r += '<div type="select" custom-select=true class="swatch-selector swatch-view swatch-drop-down swatch-drop-down-selected" swatch-option="' + t + '" aria-label="{{ option_value_text }}"  aria-haspopup="listbox" aria-expanded="false" tabindex="0">{{ option_value }}</div>',
                r += '<ul class="swatch-drop-down-list" role="listbox">';
                for (var l = 0; l < a.data.length; l++) {
                    var c = this.cvt2HTMLEntities(a.data[l].value)
                      , u = a.data[l].option_value_id
                      , d = c
                      , p = a.data[l].price
                      , h = 1 == a.data[l].available;
                    this.isValueMorphed() && (d = this.cvt2HTMLEntities(a.data[l].original_value));
                    var g = i && a.data[l].selected;
                    "invisible" == e.params.stock_out_type && 0 != a.available_count && !h && !g || (d.length > s.length && (o = "<span swatch-inside='true' class='d-flex'> <span swatch-inside=\"true\"> " + (s = d) + " </span> " + (e.params.display_price ? "<span  swatch-inside='true' class='dropdown-swatch-price'>" + p + " </span>" : "") + " </span>"),
                    r += '<li value="' + (i ? a.data[l].url : c) + '"  type="select_value" class="swatch-drop-down swatch-allow-animation ' + (i ? "swatch-group-selector" : "swatch-selector") + " swatch-drop-down-list-item" + (h ? "" : " swatch-item-unavailable") + '" orig-value="' + c + '" ' + (u ? 'option-value-id="' + u + '"' : "") + " " + (i ? 'swatch-url="' + a.data[l].url + '" ' : "") + 'swatch-option="' + t + '"' + (i && a.data[l].selected ? ' current-product="true"' : "") + ' aria-label="' + c + (h ? "" : " - Sold Out") + '" role="option" ' + (i && a.data[l].selected ? 'aria-selected="true"' : 'aria-selected="false"') + ' tabindex="0">',
                    r += "<span swatch-inside='true' class='d-flex'> <span swatch-inside=\"true\"> " + d + " </span> " + (e.params.display_price ? "<span  swatch-inside='true' class='dropdown-swatch-price'>" + p + " </span>" : "") + " </span>",
                    r += "</li>")
                }
                return r += "</ul>",
                r += "double_triangle" == e.params.icon_style ? '<svg viewBox="0 0 20 20" class="swatch-drop-down-svg"><path d="M7.676 9h4.648c.563 0 .879-.603.53-1.014l-2.323-2.746a.708.708 0 0 0-1.062 0l-2.324 2.746c-.347.411-.032 1.014.531 1.014Zm4.648 2h-4.648c-.563 0-.878.603-.53 1.014l2.323 2.746c.27.32.792.32 1.062 0l2.323-2.746c.349-.411.033-1.014-.53-1.014Z"></path></svg>' : "inverted_triangle" == e.params.icon_style ? '<svg class="swatch-drop-down-svg" viewBox="0 0 20 20"><path d="m5 8 5 5 5-5H5z"></path></svg>' : '<svg class="swatch-drop-down-svg" focusable="false" viewBox="0 0 24 24"><path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"></path></svg>',
                r += "</div>",
                r += "</div>",
                r = (r = (r += "</fieldset></div>").replace("{{ option_value_text }}", s)).replace("{{ option_value }}", o)
            }
        }, {
            key: "getDropDownViewCustom",
            value: function(e, t, a) {
                var i = "undefined" != typeof a.product_group_index
                  , n = i ? ' data-group-index="' + a.product_group_index + '"' : ""
                  , r = '<div class="swatch-single swatch-preset-' + e.id + ' swatch-view-stack"' + n + "><fieldset>"
                  , s = ""
                  , o = "";
                r += '<legend><label class="swatch-label swatch-label-drop-down ' + (this.displayLabel() ? "" : "star-hide") + '">\n        <input type="checkbox" name="' + this.cvt2HTMLEntities(a.name) + '" value="true" checked="checked" />' + a.name + "</label></legend>",
                r += '<span class="swatch-label-container"><label class="visually-hidden-label">' + a.name + "</label></span>";
                var l = e[this.instanceType + "_swatch"]
                  , c = this.isInstanceTypeCollection() ? "24px" : "48px"
                  , u = this.isInstanceTypeCollection() ? "24px" : "48px"
                  , d = e.params.swatch_size || c
                  , p = e.params.swatch_size || u
                  , h = this.getResizeValue(d, p);
                r += '<div class="swatch-drop-down-wrapper ' + this.displayAlignment() + ' swatch-drop-down-custom">',
                r += '<div class="swatch-drop-down-inner">',
                r += '<div type="select" class="swatch-view swatch-drop-down" swatch-option="' + t + '" aria-label="{{ option_value_text }}" aria-haspopup="listbox" aria-expanded="false" tabindex="0">{{ option_value }}</div>',
                r += '<ul class="swatch-drop-down-list" role="listbox">';
                for (var g = 0; g < a.data.length; g++) {
                    var f = a.data[g].value
                      , v = this.cvt2HTMLEntities(f)
                      , m = a.data[g].option_value_id
                      , _ = a.data[g].price
                      , y = v
                      , w = 1 == a.data[g].available;
                    this.isValueMorphed() && (f = a.data[g].original_value,
                    y = this.cvt2HTMLEntities(f));
                    var b = i && a.data[g].selected;
                    if (!("invisible" == e.params.stock_out_type && 0 != a.available_count && !w) || b) {
                        var S = null;
                        if ("custom_swatch" == l) {
                            if (i)
                                i && (S = a.data[g].featured_image.src);
                            else {
                                var k = a.untranslated_name ? a.untranslated_name : a.name
                                  , A = a.data[g].untranslated_value ? a.data[g].untranslated_value : f;
                                S = this.getSwatchImageURL(k, A)
                            }
                            if (this.clientSpecs.app_setting_config.use_optimized_urls) {
                                var I = S.split("/");
                                S = I.slice(0, -1).join("/") + "/" + h + "/" + I.pop().replace(".media", ".webp")
                            }
                        } else {
                            S = this.defaultFeaturedImage;
                            var T = a.data[g].featured_image;
                            T != undefined && (S = this.getImageSrc(T, e.products_swatch, e.collections_swatch)),
                            "" != S && "none" != S && "null" != S && "undefined" != S && (S = this.getLazyResolution(S, [d, p], e.params.background_size, e.params.background_position))
                        }
                        var C = '<div style="width:' + d + ";height:" + p + ";background-image:url(" + S + ');" class="star-set-image" swatch-inside="true"><i class="hidden"></i></div>';
                        y.length > s.length && (o = C + ' <span swatch-inside="true">' + (s = y) + "</span>"),
                        r += '<li type="select_value" class="' + (i ? "swatch-group-selector" : "swatch-selector") + " swatch-drop-down-list-item" + (w ? "" : " swatch-item-unavailable") + '" orig-value="' + v + '" ' + (m ? 'option-value-id="' + m + '"' : "") + " " + (i ? 'swatch-url="' + a.data[g].url + '" ' : "") + 'swatch-option="' + t + '"' + (i && a.data[g].selected ? ' current-product="true"' : "") + ' aria-label="' + v + (w ? "" : " - Sold Out") + '" role="option" ' + (i && a.data[g].selected ? 'aria-selected="true"' : 'aria-selected="false"') + ' tabindex="0">',
                        r += C,
                        r += '<span swatch-inside="true" class=\'d-flex\'> <span swatch-inside="true"> ' + y + " </span> " + (e.params.display_price ? "<span  swatch-inside='true' class='dropdown-swatch-price'>" + _ + " </span>" : "") + " </span>",
                        r += "</li>"
                    }
                }
                return r += "</ul>",
                r += "double_triangle" == e.params.icon_style ? '<svg viewBox="0 0 20 20" class="swatch-drop-down-svg"><path d="M7.676 9h4.648c.563 0 .879-.603.53-1.014l-2.323-2.746a.708.708 0 0 0-1.062 0l-2.324 2.746c-.347.411-.032 1.014.531 1.014Zm4.648 2h-4.648c-.563 0-.878.603-.53 1.014l2.323 2.746c.27.32.792.32 1.062 0l2.323-2.746c.349-.411.033-1.014-.53-1.014Z"></path></svg>' : "inverted_triangle" == e.params.icon_style ? '<svg class="swatch-drop-down-svg" viewBox="0 0 20 20"><path d="m5 8 5 5 5-5H5z"></path></svg>' : '<svg class="swatch-drop-down-svg" focusable="false" viewBox="0 0 24 24"><path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"></path></svg>',
                r += "</div>",
                r += "</div>",
                r = (r = (r += "</fieldset></div>").replace("{{ option_value_text }}", s)).replace("{{ option_value }}", o)
            }
        }, {
            key: "getHiddenView",
            value: function(e, t, a) {
                for (var i = "", n = 0; n < a.data.length; n++) {
                    var r = a.data[n].value
                      , s = this.cvt2HTMLEntities(r)
                      , o = a.data[n].option_value_id
                      , l = !!a.data[n].available;
                    if (("" == i || l) && (i = '<div class="swatch-single swatch-view-stack">\n                    <input type="hidden" class="swatch-selector" value="' + s + '" swatch-option="' + t + '" orig-value="' + s + '" ' + (o ? 'option-value-id="' + o + '"' : "") + " />\n                </div>",
                    l))
                        break
                }
                return i
            }
        }, {
            key: "selectSwatch",
            value: function(e, t, a) {
                var i = "swatch-selected";
                if ("undefined" != typeof this.selectedSwatches[e]) {
                    var n, r = this.selectedSwatches[e];
                    if (r.classList.remove(i),
                    r.removeAttribute("current-product"),
                    "SELECT" != r.tagName)
                        if (n = "LI" == r.tagName ? r : r.closest("li.swatch-view-item"))
                            "option" == n.getAttribute("role") ? n.setAttribute("aria-selected", !1) : n.setAttribute("aria-checked", !1)
                }
                (this.isDropDown(t.tagName) && (t.value = a),
                t.classList.add(i),
                "SELECT" != t.tagName) && ((n = "LI" == t.tagName ? t : t.closest("li.swatch-view-item")) && ("option" == n.getAttribute("role") ? n.setAttribute("aria-selected", !0) : n.setAttribute("aria-checked", !0)));
                this.selectedSwatches[e] = t
            }
        }, {
            key: "isDropDown",
            value: function(e) {
                return "SELECT" == e
            }
        }, {
            key: "getIsSwatchRootDisplayed",
            value: function() {
                var e = arguments.length <= 0 || arguments[0] === undefined ? "options" : arguments[0];
                return this.isSwatchRootDisplayed[e]
            }
        }, {
            key: "setIsSwatchRootDisplayed",
            value: function(e) {
                var t = arguments.length <= 1 || arguments[1] === undefined ? "options" : arguments[1];
                this.isSwatchRootDisplayed[t] = e
            }
        }, {
            key: "renderBadge",
            value: function(e, t, a) {
                var i = ""
                  , n = Number.MAX_SAFE_INTEGER;
                if ("storefront" == S) {
                    var r = !!e.params.new_badge && e.params.new_badge.enable
                      , s = !!e.params.sale_badge && e.params.sale_badge.enable
                      , o = !!e.params.sold_out_badge && e.params.sold_out_badge.enable
                      , l = this.isSalePreset(t.min_compare_at_price, t.min_price)
                      , c = y.app_setting_config.preset_badge;
                    r && n > this.clientSpecs.getPresetBadgeOrder(H) && this.isNewPreset(t.published_at) && !a && (i = "<span swatch-inside=\"true\" class='new-badge' style='color: " + c.new_badge_color + "; background-color: " + c.new_badge_bg_color + ";' >\n                    " + this.getTranslation(y.app_setting_config.preset_badge.new_badge_text) + "\n                </span>",
                    n = this.clientSpecs.getPresetBadgeOrder(H)),
                    o && n > this.clientSpecs.getPresetBadgeOrder(B) && !t.available && (i = "<span swatch-inside=\"true\" class='sold-out-badge' style='color: " + c.sold_out_badge_color + "; background-color: " + c.sold_out_badge_bg_color + ";'>\n                    " + this.getTranslation(y.app_setting_config.preset_badge.sold_out_badge_text) + "\n                </span>",
                    n = this.clientSpecs.getPresetBadgeOrder(B)),
                    s && l && n > this.clientSpecs.getPresetBadgeOrder(z) && (i = "<span swatch-inside=\"true\" class='sale-badge' style='color: " + c.sale_badge_color + "; background-color: " + c.sale_badge_bg_color + ";'>\n                    " + l + "\n                </span>",
                    n = this.clientSpecs.getPresetBadgeOrder(z))
                }
                return i
            }
        }, {
            key: "isNewPreset",
            value: function(e) {
                var t = new Date(e);
                return new Date < t.setDate(t.getDate() + parseInt(y.app_setting_config.preset_badge.new_product_max_duration))
            }
        }, {
            key: "isSalePreset",
            value: function(e, t) {
                var a = parseFloat(e - t)
                  , i = e > 0 ? a / e * 100 : 0;
                return e > t && i >= y.app_setting_config.preset_badge.min_price_diff_for_sale_badge ? this.applyReplacements(a, i) : ""
            }
        }, {
            key: "applyReplacements",
            value: function(e, t) {
                var a = {
                    "{{currency_symbol}}": y.currency_symbol,
                    "{{currency_code}}": y.currency,
                    "{{amount_save}}": e.toFixed(2),
                    "{{percentage_save}}": Math.round(t) + "%"
                };
                return this.getTranslation(y.app_setting_config.preset_badge.sale_badge_text).replace(/{{(?:currency_symbol|currency_code|amount_save|percentage_save)}}/g, function(e) {
                    return a[e]
                })
            }
        }, {
            key: "isAllNewPreset",
            value: function(e) {
                var t = !0
                  , a = this.clientSpecs.getPresetBadgeOrderList();
                if (!(a[0] === H))
                    for (var i = a[0], n = 0; n < e.data.length; n++) {
                        var r = e.data[n];
                        if (i === B && !r.available || i === z && this.isSalePreset(r.min_compare_at_price, r.min_price)) {
                            t = !1;
                            break
                        }
                    }
                if (t)
                    for (n = 0; n < e.data.length; n++)
                        if (!this.isNewPreset(e.data[n].published_at)) {
                            t = !1;
                            break
                        }
                return t
            }
        }]),
        e
    }()
      , $ = function(e) {
        if (u && u.getDisplayLogs()) {
            var t = Date(Date.now());
            console.log("<-------------- START ---------------->"),
            console.log("Swatch King:", e),
            console.log("Swatch King:", "Timestamp", t.toString()),
            console.log("<--------------- END ----------------->")
        }
    }
      , X = function(e) {
        var t = document.implementation.createHTMLDocument("");
        return t.body.innerHTML = e,
        t.body.children
    }
      , Z = function() {
        var e = arguments.length <= 0 || arguments[0] === undefined ? null : arguments[0]
          , t = null
          , a = {};
        if (document.location.search.substr(1).split("&").forEach(function(e) {
            var t = e.split("=");
            try {
                a[t[0].toString()] = t[1].toString()
            } catch (i) {}
        }),
        isNaN(a.variant)) {
            var i = undefined;
            e ? (i = e.querySelector('[name="id"]')) && (t = i.value) : (i = document.querySelector('[name="id"]')) && (t = i.value)
        } else
            a.variant && (t = a.variant);
        return t
    }
      , Y = function(e) {
        clearInterval(parseInt(e)),
        $(["Interval Removed...", e])
    }
      , Q = function() {
        return "complete" === document.readyState || "loaded" === document.readyState
    }
      , ee = function() {
        if (s("VariantSwatchKing")) {
            if (t(),
            !w)
                return;
            (k || I || C || E || O || P || M) && (te(),
            document.addEventListener("vsk:product:refresh", function() {
                setTimeout(function() {
                    te(),
                    $("Refreshing product swatch lookup complete.")
                }, 0)
            })),
            (A || T || x || D || L || N || q) && ae()
        }
    }
      , te = (setInterval(function() {
        ee()
    }, 500),
    function ne() {
        u || (u = new J);
        var e = u.getSelectors().swatch_root;
        e.use_section_as_root ? function() {
            var t = !1
              , a = document.querySelectorAll(e.section_selector);
            if (!h) {
                var i = window.location.pathname.includes("/products");
                t = 1 == a.length && i
            }
            Object.entries(a).forEach(function(e) {
                var a = _slicedToArray(e, 2)
                  , i = a[0]
                  , n = a[1];
                if ("length" != i && "undefined" == typeof n.vsk_initialized) {
                    n.vsk_initialized = !0,
                    n.setAttribute("swatch-generated", !0);
                    var r = {
                        instance_sub_type: "sectioned"
                    };
                    t && (r.primary = !0,
                    h = !0),
                    new W("products",n,r).onInstanceActivate()
                }
            });
            var n = Q() ? 1e3 : 250;
            setTimeout(ne.bind(_this26), n)
        }() : new W("products",document,null).onInstanceActivate()
    }
    )
      , ae = function() {
        u || (u = new J);
        var e = u.getCollectionConfig()
          , t = u.getCollectionSettings();
        ie(e, t, !0),
        document.addEventListener("vsk:render:swatches", function() {
            setTimeout(function() {
                ie(e, t, !1)
            }, 0)
        })
    }
      , ie = function re(e, t, a) {
        var i = document.querySelectorAll(e.swatch_root_selector);
        Object.entries(i).forEach(function(e) {
            var t = _slicedToArray(e, 2)
              , a = t[0]
              , i = t[1];
            "length" != a && ("undefined" == typeof i.vsk_initialized && (i.vsk_initialized = !0,
            i.setAttribute("swatch-generated", "none"),
            new W("collections",i,null).initialize()))
        }),
        a && t.continuous_lookup > 0 && setTimeout(function() {
            re(e, t, !0)
        }, t.continuous_lookup)
    }
}();
